// Library Imports
import React, { Component } from "react";
import { Formik, Field, Form, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import { pascalCase } from "change-case";
import ReactPlayer from "react-player";
import { connect } from "react-redux";
import { Tooltip } from "react-tippy";
import * as moment from "moment";
import { bindActionCreators } from "redux";
import { PDFDocument, 
} from 'pdf-lib';
import {
  sentenceCase,
} from "change-case";
import loadable from '@loadable/component';
import LoadingFallBack from "../loadingFallBack";
// Service Imports
import RestDataSource from "../../services/restdatasource";
import { LoginService } from "../../services/login.service";
import { RegionManagementService } from "../../services/regionManagement.service";
import { RegisterUserService } from "../../services/registration.service";
import { fetchAlertNotificationEvents, fetchNotificationEvents } from "../../services/fetchStudentDashboard.service";
import { Global_var } from "../../global/global_var";
//Other Imports
import { PopUpPortal } from "../../containers/popups/PopUpPortal";
import CustomSelect, { createOptions } from './CustomSelect';
import {
  warning,
  warningNotification,
} from "../notification/notifications";
// Redux Imports
import { getAlertNotificationEvents, getAlertNotificationEventsPending, getAlertNotificationEventsError } from "../../reducer/alertsNotificationReducer";
import { getNotificationEvents, getNotificationEventsPending, getNotificationEventsError } from "../../reducer/notificationReducer";
import {
  getPersonnelData,
  getPersonnelAddressData,
  getPreferenceData,
  getEmploymentData
} from "../../reducer/userProfileReducer";
// Assets Imports
const FinxLogo = require('../../assets/images/FinX Logo-1.png');
const Logo = require('../../assets/images/infoicon.png');

// Unused imports
// import { editAdminUser } from "../../services/admin.service";
// import FileBase64 from "react-file-base64";
// import Axios from 'axios';
// import { 
  // PDFDocument, 
  // StandardFonts,rgb ,degrees
// } from 'pdf-lib';
// import { FileSaver, saveAs } from "file-saver";
// import $ from "jquery";
// import sampleResumeVideo from "../../assets/video/sampleResumeVideo.mp4";
// import FinxLogo from "../../assets/images/FinX Logo-1.png"
// import SamplePDF from "../../assets/pdf/water.pdf"
// import Logo from "../../assets/images/infoicon.png"
// import { DropdownButton } from "react-bootstrap";
// import UserProfile from "../../components/userprofile/userProfileLandingPage";
// import { RegisterUserService } from "../../services/registration.service";
// import { LoginService } from "../../services/login.service";

const mapStateToProps = state => ({
  personnelData: getPersonnelData(state.userProfileReducers),
  addressData: getPersonnelAddressData(state.userProfileReducers),
  preferenceData: getPreferenceData(state.userProfileReducers),
  employmentData: getEmploymentData(state.userProfileReducers),

  alertNotificationEvents: getAlertNotificationEvents(
    state.alertNotificationEventsReducer
  ),
  pendingAlertNotificationEvents: getAlertNotificationEventsPending(
    state.alertNotificationEventsReducer
  ),
  errorAlertNotificationEvents: getAlertNotificationEventsError(
    state.alertNotificationEventsReducer
  ),

  notificationEvents: getNotificationEvents(state.notificationEventsReducer),
  pendingNotificationEvents: getNotificationEventsPending(
    state.notificationEventsReducer
  ),
  errorNotificationEvents: getNotificationEventsError(
    state.notificationEventsReducer
  ),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchUserProfileData: RegisterUserService.getUserPersonnelDetails,
      fetchUserAddressData: RegisterUserService.getUserAddress,
      fetchUserPreferenceData: RegisterUserService.getUserPreference,
      fetchUserEmploymentData: RegisterUserService.getUserEmployment,
      fetchAlertNotificationEvents: fetchAlertNotificationEvents,
      fetchNotificationEvents: fetchNotificationEvents,
    },
    dispatch
  );

const connectFunction = connect(mapStateToProps, mapDispatchToProps);
const AdminProfileEditConnect=connectFunction(
class AdminProfileEdit extends Component {
  constructor(props) {
    super(props);

    console.log("this.props.adminUser", this.props);
    var todaydate = new Date();

    if (localStorage.getItem("login") !== null) {
      this.state = {
        today: moment(todaydate).format("YYYY-MM-DD"),
        roleType: "",
        roleId: "",
        show: false,
        plus: true,
        submit: false,
        addressFlag: "",
        role: "",
        studentID: "",
        firstName: "",
        middleName: "",
        lastName: "",
        emailID: "",
        mobileNo: "",
        dob_1: "",
        gender: "",
        panNumber: "",
        aadharNumber: "",
        contactNo: "",
        secondaryEmailID: "",
        isActive: "",
        expiryDate: "",
        lastModifiedDate: "",
        peraddress: "",
        corsAddress: "",
        ca_address_id: "",
        ca_address_1: "",
        ca_address_2: "",
        ca_country: "",
        ca_state: "",
        ca_city: "",
        ca_postal_code: "",
        pa_address_id: "",
        pa_address_1: "",
        pa_address_2: "",
        pa_country: "",
        pa_state: "",
        pa_city: "",
        pa_postal_code: "",
        fatherName: "",
        dob_2: "",
        dob_3: "",
        company_name_1: "",
        mother_name: "",
        company_name_2: "",
        employment_type_1: "",
        employment_type_2: "",
        dob_2_validate_message: "",
        dob_3_validate_message: "",
        resumeDocumentURL: "",
        resumeVideoURL: "",
        linkedInUrl:null,
        profilePhotoURL: "",
        aadharCardURL: "",
        panCardURL: "",
        loading: false,
        countryList: [],
        stateList: [],
        cityList: [],
        countryListForPer: [],
        stateListForPer: [],
        cityListForPer: [],
        employeTypeForParents: [],
        studentQualification: [],
        createdBy: "",
        createdDate: "",
        lastModifiedBy: "",
        lastModifiedDateTime: "",
        lastLoginDateTime: "",
        listOfYear: [],
        listOfMonth: [],
        listOfDay: [],
        listOfFatherYear: [],
        listOfFatherMonth: [],
        listOfFatherDay: [],
        listOfMotherYear: [],
        listOfMotherMonth: [],
        listOfMotherDay: [],
        listOfExpiryYear: [],
        listOfExpiryMonth: [],
        listOfExpiryDay: [],
        currentTab:1,
        listOfTenureFromYear: [],
        listOfTenureFromMonth: [],
        listOfTenureFromDay: [],
        listOfTenureToYear: [],
        listOfTenureToMonth: [],
        listOfTenureToDay: [],
        tenureFromDay: "",
        tenureFromMonth: "",
        tenureFromYear: "",
        tenureToDay: "",
        tenureToMonth: "",
        tenureToYear: "",
        //
        loading: false,
        otherPreferenceList: [],
        // jobRoleList: [],
        // jobKeyskillList: [],
        jobInterestAreaList: [],
        jobNotificationList: [],
        courseNotificationList: [],
        jobPreferredDomainList:[],
        isCityLoaded: false,
        isStatesLoaded: false,
        employmentData:[],
        preferenceData:[],
        annualFamilyIncomeList:[]
      };
    } else {
      window.location.href = "/";
    }
  }

  handleCancel = () => {
    this.props.history.goBack("-1");
    console.log("cancelled")
    // this.setState({loading:true})
    if(localStorage.getItem("roleId")===2){
        // this.props.history.push("/admin-user-list");
      // setTimeout(()=>{
      //   window.location.reload();

      // },100)
      
    
      // window.location.href = 'admin-user-list';
      // setTimeout(()=>{
      //   window.location.href = 'admin-user-list';
      // },500)


      // this.setState({loading:false})

      // window.location.assign('/admin-user-list');
      // window.location.href = '/admin-user-list';
    }
    else if(localStorage.getItem("roleId")===6){
        // this.props.history.push("/ops-user-list");
      // setTimeout(()=>{
      //   window.location.reload();
      
      // },100)
      // window.location.href = '/ops-user-list';

      // window.location.href = '/ops-user-list';
      // this.setState({loading:false})
      // window.location.href = '/ops-user-list';
        // window.location.assign('/ops-user-list');
    
    }
  };

  replaceAll(str, find, replace) {
    var escapedFind = find.replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1");
    // alert(str.replace(new RegExp(escapedFind, 'g'), replace))
    return str.replace(new RegExp(escapedFind, 'g'), replace);
  }

  componentWillMount() {
    LoginService.TokenUser((res) => {
      localStorage.setItem("jwt-token", res.responseObject);
    });






    RegisterUserService.getOtherJobPreference((res) => {
      this.setState({
        otherPreferenceList: res.responseListObject,
      });
    })
    RegisterUserService.getJobRole((res) => {
      this.setState({
        jobRoleList: res.responseListObject,
      });
    })
    RegisterUserService.getJobKeyskill((res) => {
      this.setState({
        jobKeyskillList: res.responseListObject,
      });
    })
    RegisterUserService.getJobInterestArea((res) => {
      this.setState({
        jobInterestAreaList: res.responseListObject,
      });
    })
    RegisterUserService.getPreferredDomain((res) => {
      console.log("res",res);
      this.setState({
        jobPreferredDomainList: res.responseListObject,
      });
    })
    RegisterUserService.getPreferenceNotification('type=Job', (res) => {
      this.setState({
        jobNotificationList: res.responseListObject,
      });
    })
    RegisterUserService.getPreferenceNotification('type=Course', (res) => {
      this.setState({
        courseNotificationList: res.responseListObject,
      });
    })
    RegionManagementService.getState(
      "countryId=1",
      (res) => {
        this.setState({
          stateList: res.responseListObject,
          isStatesLoaded: true,
        }
        );
      })
  }
  tenureinitailizedDateDetails() {
    var listOfYear = [];
    var listOfMonth = [];
    var listOfDay = [];
  
    var year = 2000;

    for (var i = 1; year + i < 2051; i++) {
      var current = year + i;
      listOfYear.push(current);
    }
    listOfYear.reverse();

    listOfMonth = [
      { key: 1, value: "Jan" },
      { key: 2, value: "Feb" },
      { key: 3, value: "Mar" },
      { key: 4, value: "Apr" },
      { key: 5, value: "May" },
      { key: 6, value: "Jun" },
      { key: 7, value: "Jul" },
      { key: 8, value: "Aug" },
      { key: 9, value: "Sep" },
      { key: 10, value: "Oct" },
      { key: 11, value: "Nov" },
      { key: 12, value: "Dec" },
    ];
  
    for (var ld = 1; ld <= 31; ld++) {
      listOfDay.push(ld);
    }
    this.setState({ 
      listOfTenureFromDay: listOfDay,
      listOfTenureFromMonth: listOfMonth,
      listOfTenureFromYear: listOfYear,
      listOfTenureToDay: listOfDay,
      listOfTenureToMonth: listOfMonth,
      listOfTenureToYear: listOfYear,
    });
  }
  initailizedDateDetails() {
    var listOfYear = [];
    var listOfYear2 = [];
    var listOfMonth = [];
    var listOfDay = [];
    var year = new Date().getFullYear();
    var year1=new Date().getFullYear() + 10;
    var expiryyear = new Date().getFullYear();
    year = year - 18;


    for (var i = 0; i < 100; i++) {
      var current = year - i;
      var current2=year1-i;
      listOfYear.push(current);
      listOfYear2.push(current2);
    }
   
    for (var expi = 0; expi < 100; expi++) {
      var expcurrent = expiryyear + expi;
      listOfYear.push(expcurrent);
    }
    listOfMonth = [
      { key: 1, value: "Jan" },
      { key: 2, value: "Feb" },
      { key: 3, value: "Mar" },
      { key: 4, value: "Apr" },
      { key: 5, value: "May" },
      { key: 6, value: "Jun" },
      { key: 7, value: "Jul" },
      { key: 8, value: "Aug" },
      { key: 9, value: "Sep" },
      { key: 10, value: "Oct" },
      { key: 11, value: "Nov" },
      { key: 12, value: "Dec" },
    ];

    for (var ld = 1; ld <= 31; ld++) {
      listOfDay.push(ld);
    }

    this.setState({ listOfYear: listOfYear,listOfYear2:listOfYear2
    });
    this.setState({ listOfMonth: listOfMonth });
    this.setState({ listOfDay: listOfDay });

    this.setState({ listOfFatherYear: listOfYear });
    this.setState({ listOfFatherMonth: listOfMonth });
    this.setState({ listOfFatherDay: listOfDay });

    this.setState({ listOfMotherYear: listOfYear });
    this.setState({ listOfMotherMonth: listOfMonth });
    this.setState({ listOfMotherDay: listOfDay });

    this.setState({ listOfExpiryYear: listOfYear });
    this.setState({ listOfExpiryMonth: listOfMonth });
    this.setState({ listOfExpiryDay: listOfDay });


  }


  handleStateList=()=>{

    RegionManagementService.getState(
      "countryId=1",
      (res) => {
        let stateList=res.responseListObject;
        stateList.forEach((item) => {
          item.stateName = item.stateName
            .split(' ')
            .map((word) => {
              return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            })
            .join(' ');
        });
        
        this.setState({
          stateList,
          isStatesLoaded: true,
        }
        );
      })

  }

  handleCityList=(index,value)=>{
let data={
  stateIdList: [value]
}
if(value!==undefined){
    RegionManagementService.getCities(
      data,
      (res) => {
        let cityOptionList =this.state.cityList12?[...this.state.cityList12]:[];
        const beforeIndex = cityOptionList? cityOptionList.slice(0, index):"";
        const afterIndex = cityOptionList? cityOptionList.slice(index+1):"";
        
       
        let cityList=res.responseListObject;
     
        cityList&&cityList.forEach((item) => {
          item.cityName = item.cityName
            .split(' ')
            .map((word) => {
              return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            })
            .join(' ');
        });
        cityOptionList = [...beforeIndex,cityList, ...afterIndex];
        // cityOptionList.splice(index, 0, cityList);
        // cityOptionList.insert()
        
       
        this.setState({

          cityList12:cityOptionList
        })
      }
    );
    }
    else{
      let cityOptionList =this.state.cityList;
      cityOptionList.splice(index, 0,"");
        
       
      this.setState({

        cityList:cityOptionList
      })



    }
  }

handleWatermarkPDF = async () => {
  try {
    const awsPDFURL = this.state.resumeDocumentURL;
    // const awsPDFURL=SamplePDF;
    let docPath = awsPDFURL.split("?");
    let filename = docPath[0].split("/");
    let filename1 = filename[filename.length - 1];
    let extension=filename1.split(".");
    console.log("ext",extension)
    if(extension[1]==="pdf"){


    

 
    const watermarkImageURL=FinxLogo;

    const response = await fetch(awsPDFURL);
    const arrayBuffer = await response.arrayBuffer();
    console.log("arrayBuffer", arrayBuffer);
    const pdfBytes = new Uint8Array(arrayBuffer);
    console.log("pdfBytes", pdfBytes);

    const pdfDoc = await PDFDocument.load(pdfBytes);
    console.log("pdfDoc", pdfDoc);
    const pages = pdfDoc.getPages();
    console.log("pages", pages);

    const watermarkImageBytes = await fetch(watermarkImageURL).then((res) => res.arrayBuffer());
    console.log("watermarkImageBytes", watermarkImageBytes);
    const watermarkImage = await pdfDoc.embedPng(watermarkImageBytes);
    console.log("watermarkImage", watermarkImage);

   
    pages.forEach((page) => {
      const { width, height } = page.getSize();
    
      const watermarkImageWidth = watermarkImage.width * 0.47; // Scale - 52%
      const watermarkImageHeight = watermarkImage.height * 0.47;
      
      const watermarkX = (width - watermarkImageWidth) / 2;
      const watermarkY = (height - watermarkImageHeight) / 2;
    
      page.drawImage(watermarkImage, {
        x: watermarkX,
        y: watermarkY,
        // x:watermarkX/2,
        // y:watermarkY/2,
        width: watermarkImageWidth,
        height: watermarkImageHeight,
        opacity: 0.33, // Opacity - 33%
        rotateOrigin: {
          x: watermarkX + watermarkImageWidth / 2,
          y: watermarkY + watermarkImageHeight / 2,
        },
        processors: [
          {
            name: 'BrightnessContrast',
            params: { brightness: 3, contrast: 0 },
          },
        ],
      });
    });
    

    const modifiedBytes = await pdfDoc.save();
    console.log("modifiedBytes", modifiedBytes);

    const blob = new Blob([modifiedBytes], { type: 'application/pdf' });
    console.log("blob", blob);
    const url = URL.createObjectURL(blob);
    console.log("url", url);

    const link = document.createElement('a');
    console.log("link", link);
    link.href = url;
    link.download = `${filename1}`;
    link.click();

    console.log('Watermarked PDF created successfully!');
  }
  else{

    const link = document.createElement('a');
    console.log("link", link);
    link.href=awsPDFURL 
    link.target="_blank"
  
    link.download = `${filename1}`;
    link.click();

  
  }
  } catch (error) {
    console.error('Error:', error);
  }
};



handleWatermark=(video)=>{
  let videoPath = video.split("?");
  console.log("videopath",videoPath);
let filename=videoPath[0].split("/");
let filename1=filename[filename.length-1];
console.log("filename1",filename1);
 let filename2=`watermarked_${filename1}`
// var watermarkText = "watermarked_";
var modifiedUrl = videoPath[0].replace(filename1, filename2);
// var modifiedUrl = video.replace(filename1, filename2);

console.log("modifiedUrl)",modifiedUrl,filename2,filename1,video);


const link = document.createElement('a');
link.href = modifiedUrl;
link.target="_blank"
link.download = filename2;
console.log("filename2",filename2);
document.body.appendChild(link);
link.click();
document.body.removeChild(link);
}

  componentDidMount() {
    this.setState({loading:true})
    RegisterUserService.getAnnualFamilyIncomeList((res) => {
      if(res.status==="success"){
        this.setState({
          annualFamilyIncomeList: res.responseListObject,
          loading:false
        });
      }
      else{
        warning(res.reasonText,warningNotification);
        this.setState({
          loading:false
        })
      }
      });
    RegisterUserService.getTotalExperienceList((res) => {
    
      if(res.status==="success"){
      this.setState({
        totalExperienceList: res.responseListObject,
      });
    }
    });
    RegisterUserService.getAnnualSalaryList((res) => {
      if(res.status==="success"){
        this.setState({ annualSalaryList: res.responseListObject });
      }else{
        this.setState({ annualSalaryList: [] });
      }
    });
    var year = new Date().getFullYear();
    var yearlist = [];
    year = year - 18;
    for (var i = 0; i < 100; i++) {
      var current = year - i;
      yearlist.push(current);
    }
    this.setState({ listOfYear1: yearlist }); //.sort()
    this.setState({ listOfYear2: yearlist }); //.sort()


  


    let roleData=JSON.parse(localStorage.getItem("roleData"));
    console.log("vk",roleData);
    let partyId = roleData.role.partyID
 
    // let params=`partyID=${partyId}`;
    





    
    const {
      fetchUserProfileData,
      fetchUserAddressData,
      fetchUserPreferenceData,
      fetchUserEmploymentData,
      fetchAlertNotificationEvents,
      fetchNotificationEvents,
    } = this.props;
    // let partyId = localStorage.getItem("userid-Token");
    fetchUserProfileData("studentPartyID=" + partyId);
    fetchUserAddressData("partyId=" + partyId, () => {
      // console.log("student dashboard landing ", res);
    });
    fetchUserPreferenceData("partyID=" + partyId, (res) => {
      console.log("res123",res);
      this.setState({
        preferenceData:res.responseObject
      })
      // console.log("student dashboard landing ", res);
    });
    fetchUserEmploymentData("partyID=" + partyId, (res) => {
      console.log("res345",res)
      this.setState({
        employmentData:res.responseObject
      })
      // console.log("student dashboard landing ", res);
    });
    fetchAlertNotificationEvents();
    fetchNotificationEvents("partyId=" + partyId);
  
 

   
    console.log(
      " (this.props.location.state?this.props.location.state:JSON.parse(localStorage.getItem('roleData'))).role",
      this.props.location?.state?.role
    );

    // function onScroll(event) {
    //   var scrollPos = $("section#create-user").offset().top;
    //   //console.log("hiiiiiiiii" + scrollPos)

    //   $("section.page-section").each(function () {
    //     var scrollid = $(this).attr("id");
    //     var scrollPos = $("section#" + scrollid).offset().top;
    //     if (scrollPos > 100 && scrollPos < 300) {
    //       console.log("Scroll position :" + scrollid + scrollPos);
    //       $("#topheader .tab li").removeClass("active");
    //       $("a[href='#" + [scrollid] + "']")
    //         .parent("li")
    //         .addClass("active");
    //     }
    //   });
    // }

    if (
      (this.props.location.state?this.props.location.state:JSON.parse(localStorage.getItem('roleData'))).role.userRoleMatrixList[0].roleId.roleId === 5
    ) {
      this.setState({
        role: (this.props.location.state?this.props.location.state:JSON.parse(localStorage.getItem('roleData'))).role.userRoleMatrixList[0].roleId
          .roleName,
        roleId:
          (this.props.location.state?this.props.location.state:JSON.parse(localStorage.getItem('roleData'))).role.userRoleMatrixList[0].roleId.roleId,
        show: true,
        tabOptionLength:6
      });
    } else {
      this.setState({
        role: (this.props.location.state?this.props.location.state:JSON.parse(localStorage.getItem('roleData'))).role.userRoleMatrixList[0].roleId
          .roleName,
        roleId:
          (this.props.location.state?this.props.location.state:JSON.parse(localStorage.getItem('roleData'))).role.userRoleMatrixList[0].roleId.roleId,
      tabOptionLength:3
      });
    }

    this.dataSource = new RestDataSource(
      Global_var.BASEURL +
      Global_var.URL_FETCH_ADMIN_USER_BY_ROLE_PARTY_ID +
      "?partyID=" +
      (this.props.location.state?this.props.location.state:JSON.parse(localStorage.getItem('roleData'))).role.partyID +
      "&roleID=" +
      (this.props.location.state?this.props.location.state:JSON.parse(localStorage.getItem('roleData'))).role.userRoleMatrixList[0].roleId.roleId
    );
    LoginService.TokenUser((res) => {
      if (res.status === "success") {
        localStorage.setItem("jwt-token", res.responseObject);

        this.dataSource.GetData((res) => {
          if (
            (this.props.location.state?this.props.location.state:JSON.parse(localStorage.getItem('roleData'))).role.userRoleMatrixList[0].roleId
              .roleId === 5
              
          ) {
            this.setState({
              studentFatherEducation:res.data.responseObject.fatherEducation,
              studentMotherEducation:res.data.responseObject.motherEducation,
            })
            if (res.data.responseObject.dob || "") {
              let dob1 = (res.data.responseObject.dob || "").split(" ");
              let dob_1 = (dob1[0] || "").split("/");

              dob_1 = dob_1[2] + "-" + dob_1[1] + "-" + dob_1[0];
              this.setState({ dob_1: dob_1 });
            }
            if (res.data.responseObject.studentFatherDOB) {
              let dob2 = res.data.responseObject.studentFatherDOB.split(" ");
              console.log("dob2",dob2);
              let dob_21 = dob2[0].split("/");
             let dob_22 = dob_21[2] + "-" + dob_21[1] + "-" + dob_21[0];
              this.setState({ 
                dob_2: dob_22,
                studentFatherday:parseInt(dob_21[0]),
                studentFathermonth:parseInt(dob_21[1]),
                studentFatheryear:parseInt(dob_21[2])
              });
            }
            if (res.data.responseObject.studentMotherDOB) {
              let dob3 = res.data.responseObject.studentMotherDOB.split(" ");
              console.log("dob3123",dob3)
              let dob_31 = dob3[0].split("/");
              let dob_32 = dob_31[2] + "-" + dob_31[1] + "-" + dob_31[0];
              this.setState({ 
                dob_3: dob_32,
                studentMotherday:parseInt(dob_31[0]),
                studentMothermonth:parseInt(dob_31[1]),
                studentMotheryear:parseInt(dob_31[2])
              });
            }
          }
          if ((this.props.location.state?this.props.location.state:JSON.parse(localStorage.getItem('roleData'))).role.expiryDate) {
            let expiry = (this.props.location.state?this.props.location.state:JSON.parse(localStorage.getItem('roleData'))).role.expiryDate.split(" ");
            let expiry1 = expiry[0].split("/");
            let expiry2 = expiry1[2] + "-" + expiry1[1] + "-" + expiry1[0];
            this.setState({ expiryDate: expiry2 });
          }
          res.data.responseObject.studentQualification&&res.data.responseObject.studentQualification.map((item,index)=>(
            this.handleCityList(index,item.stateId)
          ))  
          this.setState({
            certiNumber:res.data.responseObject.certiNumber || "",
            batchNumber:res.data.responseObject.batchNumber || "",
            qualiCertiID: res.data.responseObject.qualificationCertificateId || "",
            studentID: res.data.responseObject.studentID || "",
            mobileNo:
              res.data.responseObject.mobileNo ||
              res.data.responseObject.contactNo ||
              "",
            emailID:
              res.data.responseObject.emailID ||
              res.data.responseObject.contactEmail ||
              "",
            gender: res.data.responseObject.gender || "",
            firstName: res.data.responseObject.firstName || "",
            middleName: res.data.responseObject.middleName || "",
            lastName: res.data.responseObject.lastName || "",
            secondaryEmailID:
              res.data.responseObject.contactEmail2 ||
              res.data.responseObject.secondaryEmailID ||
              "",
            contactNo:
              res.data.responseObject.contactNo2 ||
              res.data.responseObject.contactNo ||
              "",

            fatherName: res.data.responseObject.studentFatherName || "",
            company_name_1:
              res.data.responseObject.studentFatherCompanyName || "",
            mother_name: res.data.responseObject.studentMotherName || "",
            company_name_2:
              res.data.responseObject.studentMotherCompanyName || "",
            employment_type_1:
              res.data.responseObject.studentFatherEmployementType || "",
            employment_type_2:
              res.data.responseObject.studentMotherEmployementType || "",
            studentQualification:
              res.data.responseObject.studentQualification || [],
            panNumber: res.data.responseObject.panNumber || "",
            aadharNumber: res.data.responseObject.aadharNumber || "",
            isActive: res.data.responseObject.isActive,
            // expiryDate: !res.data.responseObject.expiryDate ? (this.props.location.state?this.props.location.state:JSON.parse(localStorage.getItem('roleData'))).role.expiryDate
            //   : moment(res.data.responseObject.expiryDate).format('MM/DD/YYYY'),
            resumeDocumentURL: res.data.responseObject.resumeDocumentURL || "",
            resumeVideoURL: res.data.responseObject.resumeVideoURL || "",
            linkedInUrl: res.data.responseObject.linkedInUrl || null,
            profilePhotoURL: res.data.responseObject.profilePhotoURL || "",
            aadharCardURL: res.data.responseObject.aadharCardURL || "",
            panCardURL: res.data.responseObject.panCardURL || "",
            partyID: (this.props.history.location.state?this.props.history.location.state:JSON.parse(localStorage.getItem('roleData'))).role.partyID
              ? (this.props.history.location.state?this.props.history.location.state:JSON.parse(localStorage.getItem('roleData'))).role.partyID
              : res.data.responseObject.partyID
                ? res.data.responseObject.partyID
                : " ",
          annualFamilyIncome:res.data.responseObject.annualFamilyIncome,
          studentFatherName:res.data.responseObject.studentFatherName,
          studentFatherCompanyName:res.data.responseObject.studentFatherCompanyName, 
        
          studentFatherEmployementType:res.data.responseObject.studentFatherEmployementType,
          studentMotherName:res.data.responseObject.studentMotherName, 
          studentMotherCompanyName:res.data.responseObject.studentMotherCompanyName,
         
          studentMotherEmployementType:res.data.responseObject.studentMotherEmployementType,
          studentFatherEmailID:res.data.responseObject.studentFatherEmailID, 
          studentMotherEmailID:res.data.responseObject.studentMotherEmailID, 
          studentFatherPanNumber:res.data.responseObject.studentFatherPanNumber,
          studentMotherPanNumber:res.data.responseObject.studentMotherPanNumber,
          studentFatherMobileNo:res.data.responseObject.studentFatherMobileNo, 
          studentMotherMobileNo:res.data.responseObject.studentMotherMobileNo,
          maritalStatus:res.data.responseObject.maritalStatus, 


            // createdBy: (this.props.history.location.state?this.props.history.location.state:JSON.parse(localStorage.getItem('roleData'))).role.createdBy
            //   ? (this.props.history.location.state?this.props.history.location.state:JSON.parse(localStorage.getItem('roleData'))).role.createdBy
            //   : res.data.responseObject.createdBy
            //   ? res.data.responseObject.createdBy
            //   : " ",
            //createdBy: res.data.responseObject.createdBy ||  " ",

            createdDate:
              ((this.props.location.state?this.props.location.state:JSON.parse(localStorage.getItem('roleData'))).role.createdDate || "") !== undefined
                ? ((this.props.location.state?this.props.location.state:JSON.parse(localStorage.getItem('roleData'))).role.createdDate || "").split(
                  " "
                )[0]
                : "" || "",
            //lastModifiedBy: res.data.responseObject.lastModifiedBy || "",
            // lastModifiedBy: (this.props.history.location.state?this.props.history.location.state:JSON.parse(localStorage.getItem('roleData'))).role
            //   .lastModifiedBy
            //   ? (this.props.history.location.state?this.props.history.location.state:JSON.parse(localStorage.getItem('roleData'))).role.lastModifiedBy
            //   : res.data.responseObject.lastModifiedBy
            //   ? res.data.responseObject.lastModifiedBy
            //   : " ",
            lastModifiedDateTime:
              (this.props.location.state?this.props.location.state:JSON.parse(localStorage.getItem('roleData'))).role.lastModifiedDateTime !== undefined
                ? (this.props.location.state?this.props.location.state:JSON.parse(localStorage.getItem('roleData'))).role.lastModifiedDateTime.split(
                  " "
                )[0]
                : "" || "",
            // lastLoginDateTime:
            //   (this.props.location.state?this.props.location.state:JSON.parse(localStorage.getItem('roleData'))).role.lastLoginDateTime !== undefined
            //     ? (this.props.location.state?this.props.location.state:JSON.parse(localStorage.getItem('roleData'))).role.lastLoginDateTime.split(" ")[0]
            //     : "" || ""
            lastLoginDateTime: (this.props.location.state?this.props.location.state:JSON.parse(localStorage.getItem('roleData'))).role
              .lastModifiedDateTime
              ? (this.props.location.state?this.props.location.state:JSON.parse(localStorage.getItem('roleData'))).role.lastModifiedDateTime.split(
                " "
              )[0]
              : " ",
          });
        });
      }
    });
    RegisterUserService.createdBy(
      "userId=" + (this.props.history.location.state?this.props.history.location.state:JSON.parse(localStorage.getItem('roleData'))).role.createdBy,
      (res) => {
        this.setState({
          createdBy:
            (res.responseObject || "").name ||
            (this.props.history.location.state?this.props.history.location.state:JSON.parse(localStorage.getItem('roleData'))).role.createdBy,
        });
      }
    );
    RegisterUserService.createdBy(
      "userId=" + (this.props.history.location.state?this.props.history.location.state:JSON.parse(localStorage.getItem('roleData'))).role.lastModifiedBy,
      (res) => {
        this.setState({
          lastModifiedBy: res.responseObject.name || "",
        });
      }
    );

    LoginService.TokenUser((res) => {
      if (res.status === "success") {
        localStorage.setItem("jwt-token", res.responseObject);
        this.props.getAdminAddress(
          "partyId=" + (this.props.location.state?this.props.location.state:JSON.parse(localStorage.getItem('roleData'))).role.partyID,
          (res) => {
            res.responseListObject.forEach((addr) => {
              if (addr.addressType === "permanent") {
                RegionManagementService.getState(
                  "countryId=" + addr.countryId,
                  (res) => {
                    this.setState({
                      stateListForPer: res.responseListObject,
                    });
                  }
                );
                RegionManagementService.getCity(
                  "stateId=" + addr.stateId,
                  (res) => {
                    this.setState({
                      cityListForPer: res.responseListObject,
                    });
                  }
                );
                this.setState({
                  pa_address_id: addr.addressId,
                  pa_address_1: addr.street,
                  pa_address_2: addr.street2,
                  pa_country: addr.countryId,
                  pa_state: addr.stateId,
                  pa_city: addr.cityId,
                  pa_postal_code: addr.postalCode,
                });
              }
              if (addr.addressType === "correspondence") {
                RegionManagementService.getState(
                  "countryId=" + addr.countryId,
                  (res) => {
                    this.setState({
                      stateList: res.responseListObject,
                    });
                  }
                );
                RegionManagementService.getCity(
                  "stateId=" + addr.stateId,
                  (res) => {
                    this.setState({
                      cityList: res.responseListObject,
                    });
                  }
                );
                this.setState({
                  ca_address_id: addr.addressId,
                  ca_address_1: addr.street,
                  ca_address_2: addr.street2,
                  ca_country: addr.countryId,
                  ca_state: addr.stateId,
                  ca_city: addr.cityId,
                  ca_postal_code: addr.postalCode,
                });
              }
            });
            RegionManagementService.getCountry((res) => {
              this.setState({
                countryList: res.responseListObject,
                countryListForPer: res.responseListObject,
              });
            });
            RegisterUserService.getEmployeType((res) => {
              this.setState({
                employeTypeForParents: res.responseListObject,
              });
            });
          }
        );
      }
    });

    RegisterUserService.getCertificateQualificationList((res) => {
    
      if(res.status==="success"){
      this.setState({
        certificateQualificationList: res.responseListObject,
      });
    }
    });

    this.initailizedDateDetails();
    this.tenureinitailizedDateDetails();
    // setTimeout(()=>{
    //   if(this.state.studentQualification&&this.state.studentQualification.length > 0){
    //     console.log("this.state.studentQualification",this.state.studentQualification);
    //     // this.state.studentQualification.map((item,index)=>(
    //     //   this.handleCityList(index,item.stateId)
    //     // ))  
    //       }
    //       // this.setState({loading:true})
    //       // this.setState({loading:false})

    // },1000)
    

   
  }
   
  scrollToSection = (sectionId,e) => {
    const section = document.querySelector(sectionId);
    const tab = document.getElementById(e.target.id);
   console.log("vkd",section,tab)
    if (section && tab) {
      // section.scrollIntoView({ behavior: 'smooth' });
      section.scrollIntoView({ behavior: 'instant' });
      // tab.classList.add('activeTabColor');
      tab.classList.add('active');
      
     if(this.state.activeTab&&this.state.activeTab.classList){
      //  values.activeTab.classList.remove('activeTabColor');
       this.state.activeTab.classList.remove('active');
     }
     this.setState({activeTab:e.target.id}) 
     
      // tab.classList.add('activeTabColor');
      tab.classList.add('active');
    }
  }
  render() {
    // const {
    //   fetchUserProfileData,
    //   fetchUserAddressData,
    //   fetchUserPreferenceData,
    //   fetchUserEmploymentData,
    //   fetchAlertNotificationEvents,
    //   fetchNotificationEvents,
    // } = this.props;
    console.log("this.state",this.state);
    const tabOptions = [
     
      {
        id: 1,
        tabTitle:"Personal",
        title:"Personal",

      },
      {
        id: 2,
        tabTitle: "Education",
        title: "Education",
      },
      {
        id:3,
        tabTitle:"Experience",
        title:"Experience"
      },
      {
        id:4,
        tabTitle:"Preferences",
        title:"Preferences"
      },
      {
        id: 5,
        tabTitle: "Resume",
        title: "Resume",
      },
    ];
    var otherPreference = this.state.otherPreferenceList;
    var mstOtherPreferenceList = this.state.preferenceData ? (this.state.preferenceData?.otherPreference?.length > 0 ? this.state.preferenceData?.otherPreference : []) : [];

    var jobLocations = this.state.preferenceData ? (this.state.preferenceData?.jobLocations?.length > 0 ? this.state.preferenceData?.jobLocations : []) : [];

    var selectedCities = [];
    const states = new Set();

    jobLocations.forEach(location => states.add(location.stateId))
    jobLocations.forEach(location => selectedCities.push(location.locationId))

    var selectedStates = [...states]

    var data = {
      stateIdList: selectedStates
    };
    // ! fetch Selected states cities
    if (this.state.isStatesLoaded && !this.state.isCityLoaded && this.state.preferenceData && (this.state.preferenceData?.jobLocations?.length > 0)) {
      RegionManagementService.getCities(
        data,
        (res) => {
          var cityOptionList = [];
          var responseList = res.responseListObject;
          responseList.forEach((city => {
            cityOptionList.push({ locationId: city.cityId, stateId: city.state.stateId, value: city.cityId, label: sentenceCase(city.cityName) })
          }))
          this.setState({ cityList11: cityOptionList })
        }
      );
      this.setState({ isCityLoaded: true })
    }


    // ! Merge Array
    // ? https://stackoverflow.com/questions/19480008/javascript-merging-objects-by-id
    var preferenceWithData = otherPreference.map((preference) => {
      var haveEqualPreferenceId = (mstOtherPreference) => mstOtherPreference.preferenceId === preference.preferenceId
      var preferenceWithEqualId = mstOtherPreferenceList.find(haveEqualPreferenceId)
      return Object.assign({}, preference, preferenceWithEqualId);
    })

    // // ! Remove null object from Array of object
    // // ? https://bobbyhadz.com/blog/javascript-remove-empty-objects-from-array
    // preferenceWithData = preferenceWithData.filter(element => {
    //   if (Object.keys(element).length !== 0) {
    //     return true;
    //   }

    //   return false;
    // });




    // const languageObject = {
    //   proficiency: "",
    //   language: "",
    //   read: "",
    //   write: "",
    //   speak: "",
    //   atLeastOneChecked: false
    // }
    const skillProficiencyList = [
      {
        label: "Advanced Excel",
        value: 1,
      },
      {
        label: "Powerpoint",
        value: 2,
      },
      {
        label: "Content Writing",
        value: 3,
      },
      {
        label: "Legal Writer",
        value: 4,
      },
      {
        label: "Profesional Business Analyst",
        value: 5,
      },
    ]

    const getErrorMessage = (errors, index, property) => {
      if (typeof errors === 'object' && Array.isArray(errors)) {
        if (errors[index]) {
          return errors[index][property];
        }
        return null;
      }
      return null;
    }
    const qualification = {
      instituteName: "",
      qualificationCategory: "",
      qualificationType: "",
      passingYear: "",
      persuingYear: "",
      grade: "",
    };

    const studentQualification =
      this.state.studentQualification.length > 0
        ? this.state.studentQualification
        : [qualification];

    let containsHSC =
      studentQualification.filter((e) => e.qualificationType === "12th").length >
      0;
      let containsSSC =
      studentQualification.filter((e) => e.qualificationType === "10th").length >
      0;

    if(!this.state.studentQualification.length > 0){
    if (!containsHSC) {
      if (!containsSSC) {
      studentQualification.unshift({
        ...qualification,
        qualificationType: "12th",
      });
    }
    else{
      studentQualification.push({
        ...qualification,
        qualificationType: "12th",
      });

    }
    }

   
    if (!containsSSC) {
      studentQualification.unshift({
        ...qualification,
        qualificationType: "10th",
      });
    }
  }
  // const qualificationTypes = ["10th", "12th","Diploma", "Graduate", "MBA/PGDM", "Postgraduate","Other",""];
  const qualificationTypes = [
    "10th",
    "12th",
    "Graduate",
    "MBA/PGDM",
    "Postgraduate",
    "Any Other Professional Course/ Degree (CA/CS/CFA,etc.)", 
    // "Any Other Certification (short course/ certification)",
    "Any Other Finance Certification (short course/ certification)",
    "Any CIEL/ FinX Certification done",
     "",
  ];
  studentQualification.sort((a, b) => {
  const aIndex = qualificationTypes.indexOf(a.qualificationType);
  const bIndex = qualificationTypes.indexOf(b.qualificationType);
  return aIndex - bIndex;
});
const employment = {
  designation: "",
  companyName: "",
  joiningDate: "",
  salaryCurrency: "",
  annualSalary: "",
  skill: "",
  jobProfile: "",
  noticePeriod: "",
  jobType:""
}


const employmentDetails = this.state.employmentData ? (this.state.employmentData?.employmentDetails?.length > 0 ? this.state.employmentData?.employmentDetails : [{}]) : [{}];

employmentDetails.forEach(employmentDetail => {
  employmentDetail.month = employmentDetail.joiningDate ? parseInt((employmentDetail.joiningDate?.split(" ")[0]).split("/")[1], 10) : "";
  employmentDetail.year = employmentDetail.joiningDate ? parseInt((employmentDetail.joiningDate?.split(" ")[0]).split("/")[2], 10) : "";
  employmentDetail.tenureFromDay = employmentDetail.tenureFromDate ? parseInt((employmentDetail.tenureFromDate?.split(" ")[0]).split("/")[0], 10) : "";
  employmentDetail.tenureFromMonth = employmentDetail.tenureFromDate ? parseInt((employmentDetail.tenureFromDate?.split(" ")[0]).split("/")[1], 10) : "";
  employmentDetail.tenureFromYear = employmentDetail.tenureFromDate ? parseInt((employmentDetail.tenureFromDate?.split(" ")[0]).split("/")[2], 10) : "";
  employmentDetail.tenureToDay = employmentDetail.tenureFromDate ? parseInt((employmentDetail.tenureToDate?.split(" ")[0]).split("/")[0], 10) : "";
  employmentDetail.tenureToMonth = employmentDetail.tenureFromDate ? parseInt((employmentDetail.tenureToDate?.split(" ")[0]).split("/")[1], 10) : "";
  employmentDetail.tenureToYear = employmentDetail.tenureFromDate ? parseInt((employmentDetail.tenureToDate?.split(" ")[0]).split("/")[2], 10) : "";
})
var isFresher=employmentDetails.some(obj => obj["isFresher"] === "Y");
var isExperienced=employmentDetails.some(obj => obj["isFresher"] === "N");
    // let dob_2_validate_message = "";
    // let dob_3_validate_message = "";
    return (
      <Formik
        enableReinitialize={true}
        initialValues={{
          mobileNo: this.state.mobileNo,
          emailID: this.state.emailID,
          gender: this.state.gender?String(this.state.gender):"",
          isActive: this.state.isActive,
          expiryDate: this.state.expiryDate,
          expiryyear: this.state.expiryDate.split("-")[0],
          expiryday: parseInt(this.state.expiryDate.split("-")[2], 10),
          expirymonth: parseInt(this.state.expiryDate.split("-")[1], 10),
          listOfExpiryDay: this.state.listOfExpiryDay,
          listOfExpiryMonth: this.state.listOfExpiryMonth,

          firstName: this.state.firstName,
          middleName: this.state.middleName,
          lastName: this.state.lastName,
          contactNo: this.state.contactNo,
          secondaryEmailID: this.state.secondaryEmailID,
          dob_1: this.state.dob_1,
          year: this.state.dob_1.split("-")[0],
          day: parseInt(this.state.dob_1.split("-")[2], 10),
          month: parseInt(this.state.dob_1.split("-")[1], 10),
          listOfDay: this.state.listOfDay,
          listOfMonth: this.state.listOfMonth,
          listOfTenureFromDay:this.state.listOfTenureFromDay,
          listOfTenureFromMonth:this.state.listOfTenureFromMonth,
          listOfTenureFromYear:this.state.listOfTenureFromYear,
          listOfTenureToDay:this.state.listOfTenureToDay,
          listOfTenureToMonth:this.state.listOfTenureToMonth,
          listOfTenureToYear:this.state.listOfTenureToYear,
          panNumber: this.state.panNumber,
          aadharNumber: this.state.aadharNumber,
          ca_address_1: this.state.ca_address_1,
          ca_address_2: this.state.ca_address_2,
          ca_country: this.state.ca_country,
          ca_state: this.state.ca_state,
          ca_city: this.state.ca_city,
          ca_postal_code: this.state.ca_postal_code,
          pa_address_1: this.state.pa_address_1,
          pa_address_2: this.state.pa_address_2,
          pa_country: this.state.pa_country,
          pa_state: this.state.pa_state,
          pa_city: this.state.pa_city,
          pa_postal_code: this.state.pa_postal_code,
          stateList: this.state.stateList,
          cityList: this.state.cityList,
          stateListForPer: this.state.stateListForPer,
          cityListForPer: this.state.cityListForPer,
          fatherName: this.state.fatherName,
          dob_2: this.state.dob_2,
          fatheryear:this.state.studentFatheryear,
          fatherday:this.state.studentFatherday,
          fathermonth:this.state.studentFathermonth,
          listOfFatherDay: this.state.listOfFatherDay,
          listOfFatherMonth: this.state.listOfFatherMonth,

          dob_3: this.state.dob_3,
          motheryear: this.state.studentMotheryear,
          motherday: this.state.studentMotherday,
          mothermonth: this.state.studentMothermonth,
          listOfMotherDay: this.state.listOfMotherDay,
          listOfMotherMonth: this.state.listOfMotherMonth,

          company_name_1: this.state.company_name_1,
          mother_name: this.state.mother_name,
          company_name_2: this.state.company_name_2,
          employment_type_1: this.state.employment_type_1,
          employment_type_2: this.state.employment_type_2,
          studentQualification: this.state.studentQualification,
          role: this.state.role,
          addressFlag: this.state.addressFlag,
          today: moment(new Date()).format("YYYY-MM-DD"),
          resumeDocumentURL: this.state.resumeDocumentURL,
          resumeVideoURL: this.state.resumeVideoURL,
          linkedInUrl: this.state.linkedInUrl,
          profilePhotoURL: this.state.profilePhotoURL,
          aadharCardURL: this.state.aadharCardURL,
          panCardURL: this.state.panCardURL,
          document: [],
          resumeDocumentName: "",
          panCardDocumentName: "",
          aadharCardDocumentName: "",
          documentSizeCheckForProfileCheck: false,
          documentTypeCheckForProfileImage: false,
          documentTypeCheckForResume: false,
          documentSizeCheckForResume: false,
          documentTypeCheckForAadharImage: false,
          documentSizeCheckForVideoCheck: false,
          documentTypeCheckForVideo: false,
          documentSizeCheckForPanCard: false,
          documentSizeCheckForAadharCard: false,
          documentTypeCheckForPANImage: false,
          loading: false,
          resumeDocumentNameDuringEditName: (this.replaceAll(this.replaceAll(this.replaceAll(this.state.resumeDocumentURL ? (
            this.state.resumeDocumentURL.split("?")[0]).substring(
              (this.state.resumeDocumentURL || "").lastIndexOf(
                "/"
              ) + 1)
            : '', "%29", ""), "%28", ""), "%20", "")),
          downloadResumeAfterSelecting: "",
          resumeDocumentNameDuringEdit: (
            this.state.resumeDocumentURL || ""
          ).substring(
            (this.state.resumeDocumentURL || "").lastIndexOf("/") + 1,
            (this.state.resumeDocumentURL || "").length
          ),
          PartyID: localStorage.getItem("userid-Token"),
          jobLocations: this.state.preferenceData ? this.state.preferenceData.jobLocations : [],
          interestAreas: this.state.preferenceData ? this.state.preferenceData.interestAreas : [],
          skillProficiency: this.state.preferenceData ? this.state.preferenceData.skillProficiency : [],
          // jobRoles: this.state.preferenceData ? this.state.preferenceData.jobRoles : [],
          // keySkills: this.state.preferenceData ? this.state.preferenceData.keySkills : [],
          languageProficiency: this.state.preferenceData ? (this.state.preferenceData?.languageProficiency?.length > 0 ? this.state.preferenceData?.languageProficiency : [{}]) : [{}],
          // twoWheeler: this.state.preferenceData ? this.state.preferenceData.twoWheeler : "",
          // validPassport: this.state.preferenceData ? this.state.preferenceData.validPassport : "",
          // willingRelocate: this.state.preferenceData ? this.state.preferenceData.willingRelocate : "",
          // willingTravel: this.state.preferenceData ? this.state.preferenceData.willingTravel : "",
          // jobRelatedNotification: this.state.preferenceData ? this.state.preferenceData.jobRelatedNotification : "",
          // courseRelatedNotification: this.state.preferenceData ? this.state.preferenceData.courseRelatedNotification : "",
          otherPreference: preferenceWithData,
          // jobRoleList: this.state.jobRoleList,
          // jobKeyskillList: this.state.jobKeyskillList,
          jobKeyskillList: this.state.jobKeyskillList||[
            {
                "keySkillId": 10,
                "keyskill": "Adaptability",
                "parKeySkillID": 9
            },
            {
                "keySkillId": 1001,
                "keyskill": "Analytical",
                "parKeySkillID": 0
            },
            {
                "keySkillId": 303285,
                "keyskill": "AWS certification",
                "parKeySkillID": 0
            },
            {
                "keySkillId": 303752,
                "keyskill": "Communication",
                "parKeySkillID": 0
            },
            {
                "keySkillId": 303316,
                "keyskill": "Core Java",
                "parKeySkillID": 0
            },
            {
                "keySkillId": 4,
                "keyskill": "Creativity",
                "parKeySkillID": 0
            },
            {
                "keySkillId": 1,
                "keyskill": "Effective communication",
                "parKeySkillID": 0
            },
            {
                "keySkillId": 9,
                "keyskill": "Openness",
                "parKeySkillID": 0
            },
            {
                "keySkillId": 8,
                "keyskill": "People skills",
                "parKeySkillID": 4
            },
            {
                "keySkillId": 5,
                "keyskill": "Problem-solving",
                "parKeySkillID": 1
            }
        ],
          jobInterestAreaList: this.state.jobInterestAreaList,
          preferredDomain:this.state.preferenceData ? this.state.preferenceData?.preferredDomainModals?.map((data)=>data.domainID) : [],
          // jobNotificationList: this.state.jobNotificationList,
          // courseNotificationList: this.state.courseNotificationList,
          jobPreferredDomainList:this.state.jobPreferredDomainList?this.state.jobPreferredDomainList:[""],
          // stateList: this.state.stateList,
          // cityList: this.state.cityList,
          selectedStates: selectedStates,
          selectedCities: selectedCities,
          skillProficiencyList: skillProficiencyList,
          isNextDisabled:false,
          isPreviousDisabled:false,
          studentFatherName:this.state.studentFatherName,
          studentFatherCompanyName:this.state.studentFatherCompanyName, 
          studentFatherDOB:this.state.studentFatherDOB, 
          studentFatherEmployementType:this.state.studentFatherEmployementType,
          studentMotherName:this.state.studentMotherName, 
          studentMotherCompanyName:this.state.studentMotherCompanyName,
          studentMotherDOB:this.state.studentMotherDOB,
          studentMotherEmployementType:this.state.studentMotherEmployementType,
          studentFatherEmailID:this.state.studentFatherEmailID, 
          studentMotherEmailID:this.state.studentMotherEmailID, 
          studentFatherPanNumber:this.state.studentFatherPanNumber,
          studentMotherPanNumber:this.state.studentMotherPanNumber,
          studentFatherMobileNo:this.state.studentFatherMobileNo, 
          studentMotherMobileNo:this.state.studentMotherMobileNo,
          studentFatherEducation:this.state.studentFatherEducation,
          studentMotherEducation:this.state.studentMotherEducation,
          maritalStatus:this.state.maritalStatus, 
          // annualFamilyIncome:[NaN,"NaN"].includes(this.state.annualFamilyIncome)?"":[0,"0"].includes(this.state.annualFamilyIncome)?"0":this.state.annualFamilyIncome?this.state.annualFamilyIncome:,
          annualFamilyIncome:this.state.annualFamilyIncome?String(this.state.annualFamilyIncome):"",
          studentMotherday:this.state.studentMotherday,
          studentMothermonth:this.state.studentMothermonth,
          studentMotheryear:this.state.studentMotheryear,
          studentFatherday:this.state.studentFatherday,
          studentFathermonth:this.state.studentFathermonth,
          studentFatheryear:this.state.studentFatheryear,
          studentQualification: studentQualification,
          // listOfMonth: this.state.listOfMonth,
         isNismCertified: studentQualification?studentQualification[0]?.isNismDone
          ? studentQualification[0]?.isNismDone
          : "":"",
        nismCertificateName:studentQualification?studentQualification[0]?.nismExamName
          ? studentQualification[0]?.nismExamName
          : "":"",
        nismCertificateNumber: studentQualification?studentQualification[0]?.nismExamNumber
          ? studentQualification[0]?.nismExamNumber
          : "":"",
        nismCertificationDate: studentQualification?studentQualification[0]?.nismExamDate
          ? studentQualification[0]?.nismExamDate.split("/")[2]+"-"+studentQualification[0]?.nismExamDate.split("/")[1]+"-"+studentQualification[0]?.nismExamDate.split("/")[0]
          : "":"",
        // state: this.state.stateList,
        city: this.state.cityList,
        employmentDetails:isExperienced?employmentDetails:[employment],
        // listOfMonth: this.state.listOfMonth,
        //  isFresher:employmentDetails.some(obj => obj["isFresher"] === "Y")?"Y":"N",
        isFresher: isFresher ? "Y" : isExperienced ? "N" : "",
        // isNextDisabled: false,
        // isPreviousDisabled: false,
        isInternshipDone: employmentDetails[0]?.isInternshipDone
          ? employmentDetails[0]?.isInternshipDone
          : "",
        immediateJoining: employmentDetails[0]?.immediateJoining
        ? employmentDetails[0]?.immediateJoining
        : "",
        internCompanyName: isFresher?(employmentDetails[0]?.companyName
          ? employmentDetails[0]?.companyName
          : ""):"",
        tenure: employmentDetails[0]?.tenure
          ? employmentDetails[0]?.tenure
          : "",
        tenureFromDay: employmentDetails[0]?.tenureFromDay
        ? employmentDetails[0]?.tenureFromDay
        : "",
        tenureFromMonth: employmentDetails[0]?.tenureFromMonth
        ? employmentDetails[0]?.tenureFromMonth
        : "",
        tenureFromYear: employmentDetails[0]?.tenureFromYear
        ? employmentDetails[0]?.tenureFromYear
        : "",
        tenureToDay: employmentDetails[0]?.tenureToDay
        ? employmentDetails[0]?.tenureToDay
        : "",
        tenureToMonth: employmentDetails[0]?.tenureToMonth
        ? employmentDetails[0]?.tenureToMonth
        : "",
        tenureToYear: employmentDetails[0]?.tenureToYear
        ? employmentDetails[0]?.tenureToYear
        : "",        
        internJobProfile: isFresher?(employmentDetails[0]?.jobProfile
          ? employmentDetails[0]?.jobProfile
          : ""):"",
       jobTypes:this.state.employmentData?.jobTypes?this.state.employmentData?.jobTypes:"",
       cityForEducation: this.state.cityList12,
       fatherlistOfMonth: this.state.listOfMonth,
       fatherlistOfDay: this.state.listOfDay,
       motherlistOfMonth: this.state.listOfMonth,
       motherlistOfDay: this.state.listOfDay,
       cityList11:this.state.cityList11,
       totalExperienceList:this.state.totalExperienceList?this.state.totalExperienceList:[],
       annualSalaryList:this.state.annualSalaryList,
       certificateQualificationList:this.state.certificateQualificationList?this.state.certificateQualificationList:[],
       experienceID:employmentDetails[0]?employmentDetails[0].experienceID?employmentDetails[0].experienceID:"":"",
       noticePeriodList:this.state.employmentData?.noticePeriodDetails?this.state.employmentData.noticePeriodDetails:"",
       annualFamilyIncomeList:this.state.annualFamilyIncomeList?this.state.annualFamilyIncomeList:[],
       certiNumber:this.state.certiNumber?this.state.certiNumber:"",
       batchNumber:this.state.batchNumber?this.state.batchNumber:"",
      }}
        validationSchema={Yup.object().shape({
          // //static validations
          // mobileNo: Yup.string()
          //   .required("You must specify a Mobile Number")
          //   .matches(/^[6-9]\d{9}$/, "Please enter the valid mobile number"),
          // emailID: Yup.string()
          //   .required("You must specify a Email ID")
          //   .email("Please enter the valid email ID"),
          // gender: Yup.lazy((values, key) => {
          //   switch (key.parent.role) {
          //     case "Student":
          //       return Yup.string().required("You must specify a Gender");
          //     default:
          //       return Yup.string();
          //   }
          // }),
          // firstName: Yup.string().required("You must specify a First Name"),
          // middleName: Yup.string(),
          // lastName: Yup.string().required("You must specify a Last Name"),
          // contactNo: Yup.string().matches(
          //   /^[6-9]\d{9}$/,
          //   "Please enter the valid mobile number"
          // ),
          // secondaryEmailID: Yup.string().email(
          //   "Please enter the valid email ID"
          // ),
          // ca_address_1: Yup.string().required("You must specify a Address"),
          // ca_address_2: Yup.string(),
          // ca_country: Yup.string().required("You must specify a Country"),
          // ca_state: Yup.string().required("You must specify a State"),
          // ca_city: Yup.string().required("You must specify a City"),
          // ca_postal_code: Yup.string()
          //   .required("You must specify a Pin Code")
          //   .matches(/^\d{6}$/, "Please enter valid postal code"),
          // pa_address_1: Yup.string().required("You must specify a Address"),
          // pa_address_2: Yup.string(),
          // pa_country: Yup.string().required("You must specify a Country"),
          // pa_state: Yup.string().required("You must specify a State"),
          // pa_city: Yup.string().required("You must specify a City"),
          // pa_postal_code: Yup.string()
          //   .required("You must specify a Pin Code")
          //   .matches(/^\d{6}$/, "Please enter valid postal code"),
          // // dob_2: Yup.lazy((values, key) => {
          // //   switch (key.parent.role) {
          // //     case "Student":
          // //       return Yup.string()
          // //         .default(() => "")
          // //         .test("dateOfBirth", dob_2_validate_message, (value) => {
          // //           if (value !== undefined) {
          // //             if (key.parent.dob_1 === undefined) {
          // //               dob_2_validate_message =
          // //                 "please enter student's date of birth";
          // //             } else {
          // //               dob_2_validate_message =
          // //                 "age should be greater than student's age";
          // //             }
          // //           }
          // //           return value !== undefined
          // //             ? moment().diff(moment(value), "years") >
          // //             moment().diff(moment(key.parent.dob_1), "years") - 1
          // //             : "";
          // //         });
          // //     default:
          // //       return Yup.string();
          // //   }
          // // }),

          // // dob_3: Yup.lazy((values, key) => {
          // //   switch (key.parent.role) {
          // //     case "Student":
          // //       return Yup.string()
          // //         .default(() => "")
          // //         .test("dateOfBirth", dob_3_validate_message, (value) => {
          // //           if (value !== undefined) {
          // //             if (key.parent.dob_1 === undefined) {
          // //               dob_3_validate_message =
          // //                 "please enter student's date of birth";
          // //             } else {
          // //               dob_3_validate_message =
          // //                 "age should be greater than student's age";
          // //             }
          // //           }
          // //           return value !== undefined
          // //             ? moment().diff(moment(value), "years") >
          // //             moment().diff(moment(key.parent.dob_1), "years") - 1
          // //             : "";
          // //         });
          // //     default:
          // //       return Yup.string();
          // //   }
          // // }),
          // company_name_1: Yup.string(),
          // company_name_2: Yup.string(),
          // mother_name: Yup.string(),
          // employment_type_1: Yup.string(),
          // employment_type_2: Yup.string(),
          // //dynamic validation starts from here
          // // fatherName: Yup.lazy((values, key) => {
          // //   switch (key.parent.role) {
          // //     case "Student":
          // //       return Yup.string().required(
          // //         "You must specify a Father's name"
          // //       );
          // //     default:
          // //       return Yup.string();
          // //   }
          // // }),
          // // dob_1: Yup.lazy((values, key) => {
          // //   switch (key.parent.role) {
          // //     case "Student":
          // //       return Yup.string()
          // //         .required("You must specify a Date of Birth")
          // //         .default(() => "")
          // //         .test(
          // //           "dateOfBirth",
          // //           "age should be greater then 18 years",
          // //           value => {
          // //             return moment().diff(moment(value), "years") >= 18;
          // //           }
          // //         );
          // //     default:
          // //       return Yup.string();
          // //   }
          // // }),
          // panNumber: Yup.lazy((values, key) => {
          //   switch (key.parent.role) {
          //     case "Student":
          //       return Yup.string().matches(
          //         /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
          //         "Please enter the valid PAN number"
          //       );
          //     default:
          //       return Yup.string();
          //   }
          // }),
          // aadharNumber: Yup.lazy((values, key) => {
          //   switch (key.parent.role) {
          //     case "Student":
          //       return Yup.string()
          //         .required("You must specify a Aadhar number")
          //         .matches(/^\d{12}$/, "Please enter the valid aadhar number");
          //     default:
          //       return Yup.string();
          //   }
          // }),
        })}
        onSubmit={(values, actions) => {
          console.log("Submitted :" + JSON.stringify(values));
          this.props.history.goBack("-1");
          //this.props.history.push("/admin-user-list");
          // actions.setFieldValue((values.loading = true));

          // if (
          //   values["year"] === undefined &&
          //   values["year"] === "" &&
          //   values["month"] === undefined &&
          //   values["month"] === "" &&
          //   values["day"] === undefined &&
          //   values["day"] === ""
          // ) {
          //   warning(
          //     "Birth Date cannot be Blank. Please Select valid date",
          //     warningNotification
          //   );
          // } else {

          //   let formattedBirthDate = "";
          //   let formattedFatherBirthDate = "";
          //   let formattedMotherBirthDate = "";
          //   let formattedexpiryBirthDate = "";

          //   if (
          //     values["year"] !== undefined &&
          //     values["year"] !== "" &&
          //     values["month"] !== undefined &&
          //     values["month"] !== "" &&
          //     values["day"] !== undefined &&
          //     values["day"] !== ""
          //   ) {
          //     let fromdy =
          //       values["day"].length === 1 ? "0" + values["day"] : values["day"];
          //     let frommont =
          //       values["month"].length === 1
          //         ? "0" + values["month"]
          //         : values["month"];
          //     formattedBirthDate =
          //       fromdy + "/" + frommont + "/" + values["year"] + " 00:00:00";
          //   }

          //   if (
          //     values["expiryyear"] !== undefined && values["expiryyear"] !== "" &&
          //     values["expirymonth"] !== undefined && values["expirymonth"] !== "" &&
          //     values["expiryday"] !== undefined && values["expiryday"] !== ""
          //   ) {
          //     let expiryfromdy =
          //       values["expiryday"].length === 1
          //         ? "0" + values["expiryday"]
          //         : values["expiryday"];
          //     let expiryfrommont =
          //       values["expirymonth"].length === 1
          //         ? "0" + values["expirymonth"]
          //         : values["expirymonth"];
          //     formattedexpiryBirthDate =
          //       expiryfromdy +
          //       "/" +
          //       expiryfrommont +
          //       "/" +
          //       values["expiryyear"] +
          //       " 00:00:00";
          //   }

          //   if (
          //     values["fatheryear"] !== undefined && values["fatheryear"] !== "" &&
          //     values["fathermonth"] !== undefined && values["fathermonth"] !== "" &&
          //     values["fatherday"] !== undefined && values["fatherday"] !== ""
          //   ) {
          //     let fatherfromdy =
          //       values["fatherday"].length === 1
          //         ? "0" + values["fatherday"]
          //         : values["fatherday"];
          //     let fatherfrommont =
          //       values["fathermonth"].length === 1
          //         ? "0" + values["fathermonth"]
          //         : values["fathermonth"];
          //     formattedFatherBirthDate =
          //       fatherfromdy +
          //       "/" +
          //       fatherfrommont +
          //       "/" +
          //       values["fatheryear"] +
          //       " 00:00:00";
          //   }

          //   if (
          //     values["motheryear"] !== undefined && values["motheryear"] !== "" &&
          //     values["mothermonth"] !== undefined && values["mothermonth"] !== "" &&
          //     values["motherday"] !== undefined && values["motherday"] !== ""
          //   ) {
          //     let motherfromdy =
          //       values["motherday"].length === 1
          //         ? "0" + values["motherday"]
          //         : values["motherday"];
          //     let motherfrommont =
          //       values["mothermonth"].length === 1
          //         ? "0" + values["mothermonth"]
          //         : values["mothermonth"];
          //     formattedMotherBirthDate =
          //       motherfromdy +
          //       "/" +
          //       motherfrommont +
          //       "/" +
          //       values["motheryear"] +
          //       " 00:00:00";
          //   }

          //   let data = {
          //     roleID: this.state.roleId,
          //     partyID: (this.props.location.state?this.props.location.state:JSON.parse(localStorage.getItem('roleData'))).role.partyID,
          //     userID: (this.props.location.state?this.props.location.state:JSON.parse(localStorage.getItem('roleData'))).role.userId,
          //     mobileNo: values.mobileNo,
          //     emailID: values.emailID,
          //     gender: values.gender,
          //     isActive: values.isActive,
          //     expiryDate: formattedexpiryBirthDate,
          //     // values.expiryDate
          //     // ? moment(values.expiryDate).format("DD/MM/YYYY HH:mm:ss")
          //     // : " ",
          //     firstName: values.firstName,
          //     middleName: values.middleName,
          //     lastName: values.lastName,
          //     contactNo: values.contactNo,
          //     secondaryEmailID: values.secondaryEmailID,
          //     dob: formattedBirthDate,
          //     // values.dob_1
          //     // ? moment(values.dob_1).format("DD/MM/YYYY HH:mm:ss")
          //     // : " ",
          //     panNumber: values.panNumber,
          //     aadharNumber: values.aadharNumber,
          //     address: [
          //       {
          //         addressType: "permanent",
          //         addressId: this.state.pa_address_id,
          //         street: values.pa_address_1,
          //         street2: values.pa_address_2,
          //         cityId: values.pa_city,
          //         stateId: values.pa_state,
          //         countryId: values.pa_country,
          //         postalCode: values.pa_postal_code,
          //       },
          //       {
          //         addressType: "correspondence",
          //         addressId: this.state.ca_address_id,
          //         street: values.ca_address_1,
          //         street2: values.ca_address_2,
          //         cityId: values.ca_city,
          //         stateId: values.ca_state,
          //         countryId: values.ca_country,
          //         postalCode: values.ca_postal_code,
          //       },
          //     ],
          //     studentFatherName: values.fatherName,
          //     studentFatherDOB: formattedFatherBirthDate,
          //     // values.dob_2
          //     // ? moment(values.dob_2).format("DD/MM/YYYY HH:mm:ss")
          //     // : " ",
          //     studentFatherEmployementType: values.employment_type_1,
          //     studentFatherCompanyName: values.company_name_1,
          //     studentMotherName: values.mother_name,
          //     studentMotherDOB: formattedMotherBirthDate,
          //     // values.dob_3
          //     // ? moment(values.dob_3).format("DD/MM/YYYY HH:mm:ss")
          //     // : "",
          //     studentMotherEmployementType: values.employment_type_2,
          //     studentMotherCompanyName: values.company_name_2,
          //     studentQualification: values.studentQualification.filter(
          //       (x) => !!x
          //     ),
          //     document: values.document,
          //     resumeDocumentURL: values.resumeDocumentURL,
          //     profilePhotoURL: values.profilePhotoURL,
          //     resumeVideoURL: values.resumeVideoURL,
          //   };

          //   if (this.state.roleId === 5||this.state.roleId===6) {
          //     data = { ...data, studentID: this.state.studentID };
          //     RegisterUserService.updateUserProfile(data, (cb) => {
          //       if (cb.status === "success") {
          //         success(
          //           "User profile has been updated on FinX successfully",
          //           successNotification
          //         );
          //         actions.setFieldValue((values.loading = false));
          //         this.props.history.push("/admin-user-list");
          //       } else {
          //         actions.setFieldValue((values.loading = false));
          //         error(cb.reasonText, {
          //           ...errorNotification,
          //           container: "top-center",
          //         });
          //       }
          //     });
          //   } else {
          //     editAdminUser(data, (cb) => {
          //       if (cb.status === "success") {
          //         success(
          //           " your profile has been updated on FinX successfully",
          //           successNotification
          //         );
          //         this.props.fetchAdminUser("limit=-1");
          //         this.props.history.push("/admin-user-list");
          //       } else {
          //         error(cb.reasonText, {
          //           ...errorNotification,
          //           container: "top-center",
          //         });
          //       }
          //     });
          //   }
          // }
        }}
        render={({
          errors,
          touched,
          handleSubmit,
          handleChange,
          values,
          setFieldValue,
          ...formikProps
        }) => (
          <React.Fragment>
            {values.loading && (
              <PopUpPortal
                HidePopup={values.loading}
                IsVisible={values.loading}
              />
            )}
    
             <div className="row mt-50 pt-50">
                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 mb-10 ">
                {this.state.show&&(
                  <ul className="tab-group " id="user-profile-tabs">
                    
                    
                    {tabOptions.map((tabOption, i) => 
                    (
                     
                        <li
                      
                          key={i}
                          onClick={() => {
                          this.setState({currentTab:tabOption.id})
                       

                          }}
                          id={tabOption.id}
                          data-check={this.props.currentTab === tabOption.id}
                          className={
                            this.state.currentTab === tabOption.id ? "active" : ""
                          }
                        >
                          {tabOption.tabTitle}
                        </li>                    
                      ))}
                      
                  </ul>
                )}
                </div>
              </div>
          
            
              {/* <pre>{JSON.stringify(values.city,null,2)}</pre> */}
            {/* <section class="dashboard-tab user-profile mt-60"> */}
            <section className="dashboard-tab user-tab mt-150 pt-150">
              <div className="row ">
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 mb-10">
              <Form
                onSubmit={handleSubmit}
                onKeyDown={(onKeyDown) => {
                  if (
                    (onKeyDown.charCode || onKeyDown.keyCode) === 13 &&
                    onKeyDown.target.name !== "ca_country" &&
                    onKeyDown.target.name !== "ca_state" &&
                    onKeyDown.target.name !== "ca_city" &&
                    onKeyDown.target.name !== "pa_country" &&
                    onKeyDown.target.name !== "pa_state" &&
                    onKeyDown.target.name !== "pa_city" &&
                    onKeyDown.target.name !== "employment_type_1" &&
                    onKeyDown.target.name !== "employment_type_2" &&
                    onKeyDown.target.name !== "submitForm" &&
                    onKeyDown.target.name !== "cancelForm"
                  ) {
                    onKeyDown.preventDefault();
                  }
                }}
                className="form-group"
              >
                <div class="">
                  <div class="container">
                    <div class="row">
                    {this.state.currentTab === 1&&
                      <div  class={this.state.currentTab === 1&&"col-md-3 col-lg-3 col-sm-12 col-xs-12"}>
                        <div class="profile-left-sidebar">
                          <div class="profile-sidebar">
                            <div class="table-header">
                              <div class="container-fluid">
                                <div id="topheader">
                                  
                                  {/* <nav data-scroll-header> */}
                                    <ul class="tab">
                                      <li
                                        className="active"
                                      >
                                        <a 
                                        href
                                         id="create-userTypeTab"
                                        
                                        onClick={(e) => {
                                          this.scrollToSection(
                                            "#create-userType",
                                            e

                                          );
                                        }}
                                        // href="#create-userType"
                                        >User Type</a>
                                      </li>
                                      <li
                                    
                                      >
                                        <a 
                                        href
                                        id="create-userTab"
                                        onClick={(e) => {
                                          this.scrollToSection(
                                            "#create-user",
                                            e
                                        
                                          );
                                        }}
                                        // href="#create-user"
                                        >
                                          Personal Details
                                        </a>
                                      </li>
                                      <li 
                                      
                                      >
                                        <a
                                        href
                                        id="create-addressTab"
                                        onClick={(e) => {
                                          this.scrollToSection(
                                            "#create-address",
                                            e
                                          
                                          );
                                        }}
                                        // href="#create-address"
                                        >
                                          Address Details
                                        </a>
                                      </li>
                                      {this.state.show ? (
                                        <li
                                       
                                        >
                                          <a 
                                          href
                                          id="create-parentTab"
                                          onClick={(e) => {
                                            this.scrollToSection(
                                              "#create-parent",
                                              e
                                            
                                              
                                            );
                                          }}
                                          // href="#create-parent"
                                          >
                                            Parent Details
                                          </a>
                                        </li>
                                      ) : (
                                        <div></div>
                                      )}
                                     
                                    
                                    </ul>
                                  {/* </nav> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="table-responsive">
                          <table>
                            <tbody>
                              <tr>
                                <td>UserId</td>
                                <td>
                                  <b>{this.state.partyID}</b>
                                </td>
                              </tr>
                              <tr>
                                <td>Created By</td>
                                <td>
                                  <b>{this.state.createdBy}</b>
                                </td>
                              </tr>
                              <tr>
                                <td>Created On</td>
                                <td>
                                  <b>{this.state.createdDate}</b>
                                </td>
                              </tr>
                              <tr>
                                <td>Last Modified By</td>
                                <td>
                                  <b>{this.state.lastModifiedBy}</b>
                                </td>
                              </tr>
                              <tr>
                                <td>Last Modified On</td>
                                <td>
                                  <b>{this.state.lastModifiedDateTime}</b>
                                </td>
                              </tr>
                              <tr>
                                <td>Last Logged In</td>
                                <td>
                                  <b>{this.state.lastLoginDateTime}</b>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
        }

                      <div 
                      style={{
                          height:"auto",
                          maxHeight: "100vh", /* Set a fixed height */
                          overflowY:"scroll",/* Add a vertical scrollbar */
                        
                      }}
                      
                      class={this.state.currentTab === 1?"col-md-9 col-lg-9 col-sm-12 col-xs-12 pt-130":"col-md-12 col-lg-12 col-sm-12 col-xs-12 pt-130"}>
                      {/* <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12  pt-130"> */}
                        {/* <main class="content-pos-fixed"> */}
                       
                        <div style={{width:"auto",minWidth:"90%", minoverflow:"auto", marginTop:"20px",position:"relative"}} >
                          {/* <main> */}
                          <div class="bg-box">
                            {this.state.currentTab===1&&
                            
                            <section
                              class="create-userType page-section"
                              id="create-userType"
                            >
                              <div class="row">
                                <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                
                                  <h2 class="sub-header">User Type</h2>
                                  <div class="form-group">
                                    <div class="row">
                                      <div class="col-md-4 col-sm-4 col-xs-12">
                                        <label>
                                          Role Type{" "}
                                          <span className="validation"> *</span>
                                        </label>
                                       <Field                                         
                                          as="select"
                                          name="role"
                                          disabled
                                          className={"form-control"}
                                        >
                                          {(this.props.roles || [])
                                            .filter(
                                              (role) =>
                                                role.roleId !== 1 &&
                                                role.isActive === 1
                                            )
                                            .map((role) => (
                                              <option
                                                title={role.roleName}
                                                key={role.roleId}
                                                value={role.roleName}
                                              >
                                                {role.roleName}
                                              </option>
                                            ))}
                                        </Field>
                                      </div>

                                      <div class="col-md-4 col-sm-4 col-xs-12">
                                        <label>
                                          Is Active{" "}
                                          <span className="validation"> *</span>
                                        </label>
                                       <Field  disabled
                                          as="select"
                                          name="isActive"
                                          onChange={handleChange}
                                          className={"form-control"}
                                        >
                                          <option value="1">Active</option>
                                          <option value="0">InActive</option>
                                        </Field>
                                      </div>
                                      {/* {this.state.roleId === 5 ? */}
                                      <div class="col-md-4 col-sm-4 col-xs-12">
                                        <label>User Expiry Date</label>
                                        {/*<Field  disabled
                                          type="date"
                                          className="form-control"
                                          min={this.state.today}
                                          onChange={handleChange}
                                          name="expiryDate"
                                        ></Field> */}
                                        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr">
                                          <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 pl pr">
                                           <Field  disabled
                                              as="select"
                                              name="expiryday"
                                              id="expiryday"
                                              //disabled={values.expiry ? true : false}
                                              onChange={(e) => {
                                                var listOfMonth = [];
                                                setFieldValue(
                                                  (values.expiryday =
                                                    e.target.value)
                                                );
                                                if ([31, '31'].includes(e.target.value)) {
                                                  listOfMonth = [
                                                    { key: 1, value: "Jan" },
                                                    { key: 3, value: "Mar" },
                                                    { key: 5, value: "May" },
                                                    { key: 7, value: "Jul" },
                                                    { key: 8, value: "Aug" },
                                                    { key: 10, value: "Oct" },
                                                    { key: 12, value: "Dec" },
                                                  ];
                                                } else if (
                                                  [30, '30'].includes(e.target.value)
                                                ) {
                                                  listOfMonth = [
                                                    { key: 1, value: "Jan" },
                                                    { key: 3, value: "Mar" },
                                                    { key: 4, value: "Apr" },
                                                    { key: 5, value: "May" },
                                                    { key: 6, value: "Jun" },
                                                    { key: 7, value: "Jul" },
                                                    { key: 8, value: "Aug" },
                                                    { key: 9, value: "Sep" },
                                                    { key: 10, value: "Oct" },
                                                    { key: 11, value: "Nov" },
                                                    { key: 12, value: "Dec" },
                                                  ];
                                                } else if (
                                                  [28, '28', 29, '29'].includes(e.target.value)
                                                ) {
                                                  listOfMonth = [
                                                    { key: 1, value: "Jan" },
                                                    { key: 2, value: "Feb" },
                                                    { key: 3, value: "Mar" },
                                                    { key: 4, value: "Apr" },
                                                    { key: 5, value: "May" },
                                                    { key: 6, value: "Jun" },
                                                    { key: 7, value: "Jul" },
                                                    { key: 8, value: "Aug" },
                                                    { key: 9, value: "Sep" },
                                                    { key: 10, value: "Oct" },
                                                    { key: 11, value: "Nov" },
                                                    { key: 12, value: "Dec" },
                                                  ];
                                                } else {
                                                  listOfMonth = [
                                                    { key: 1, value: "Jan" },
                                                    { key: 2, value: "Feb" },
                                                    { key: 3, value: "Mar" },
                                                    { key: 4, value: "Apr" },
                                                    { key: 5, value: "May" },
                                                    { key: 6, value: "Jun" },
                                                    { key: 7, value: "Jul" },
                                                    { key: 8, value: "Aug" },
                                                    { key: 9, value: "Sep" },
                                                    { key: 10, value: "Oct" },
                                                    { key: 11, value: "Nov" },
                                                    { key: 12, value: "Dec" },
                                                  ];
                                                }
                                                setFieldValue(
                                                  (values.listOfExpiryMonth =
                                                    listOfMonth)
                                                );
                                              }}
                                              className={
                                                "form-control" +
                                                (errors.expiryday && touched.expiryday
                                                  ? "is-invalid"
                                                  : "")
                                              }
                                            >
                                              <option value="">DD</option>
                                              {(values.listOfExpiryDay || []).map(
                                                (d) => (
                                                  <option value={d}>
                                                    {d}
                                                  </option>
                                                )
                                              )}
                                            </Field>
                                          </div>
                                          <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 pl pr">
                                           <Field  disabled
                                              as="select"
                                              name="expirymonth"
                                              id="expirymonth"
                                              //disabled={values.expirymonth ? true : false}
                                              onChange={(e) => {
                                                var listOfDay = [];
                                                setFieldValue(
                                                  (values.expirymonth =
                                                    e.target.value)
                                                );
                                                if ([2, '2'].includes(e.target.value)) {
                                                  listOfDay = [];
                                                  for (
                                                    var i = 1;
                                                    i <= 29;
                                                    i++
                                                  ) {
                                                    listOfDay.push(i);
                                                  }
                                                } else if (
                                                  // e.target.value == 1 ||
                                                  // e.target.value == 3 ||
                                                  // e.target.value == 5 ||
                                                  // e.target.value == 7 ||
                                                  // e.target.value == 8 ||
                                                  // e.target.value == 10 ||
                                                  // e.target.value == 12
                                                  [1, '1', 3, '3', 5, '5', 7, '7', 8, '8', 10, '10', 12, '12',].includes(e.target.value)
                                                ) {
                                                  listOfDay = [];
                                                  for (
                                                    var iod = 1;
                                                    iod <= 31;
                                                    iod++
                                                  ) {
                                                    listOfDay.push(iod);
                                                  }
                                                } else {
                                                  listOfDay = [];
                                                  for (
                                                    var iol = 1;
                                                    iol <= 30;
                                                    iol++
                                                  ) {
                                                    listOfDay.push(iol);
                                                  }
                                                }
                                                setFieldValue(
                                                  (values.listOfExpiryDay =
                                                    listOfDay)
                                                );
                                              }}
                                              className={
                                                "form-control" +
                                                (errors.expirymonth && touched.expirymonth
                                                  ? "is-invalid"
                                                  : "")
                                              }
                                            >
                                              <option value="">MM</option>
                                              {(values.listOfExpiryMonth || []).map(
                                                (m) => (
                                                  <option value={m.key}>
                                                    {m.value}
                                                  </option>
                                                )
                                              )}
                                            </Field>
                                          </div>
                                          <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 pl pr">
                                           <Field  disabled
                                              as="select"
                                              name="expiryyear"
                                              id="expiryyear"
                                              className={
                                                "form-control" +
                                                (errors.expiryyear && touched.expiryyear
                                                  ? "is-invalid"
                                                  : "")
                                              }
                                            //disabled={values.expiryyear ? true : false}
                                            >
                                              <option value="">YYYY</option>
                                              {(
                                                this.state.listOfExpiryYear || []
                                              ).map((year) => (
                                                <option value={year}>
                                                  {year}
                                                </option>
                                              ))}
                                            </Field>
                                          </div>
                                        </div>
                                      </div>
                                      {/* </div> : ''} */}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
        }
        

        {this.state.currentTab===1&&

                            <section
                              class="create-user page-section"
                              id="create-user"
                            >
                              <div class="row">
                                <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                  <h2 class="sub-header">Personal Details</h2>
                                  <div class="form-group">
                                  <div className="row">
                                    <div 
                                     style={{cursor:"not-allowed"}}
                                    className="col-md-4 col-sm-4 col-xs-12">
                                      <label>Upload Profile Image</label>
                                      <div className="profile-detail">
                                        <div className="circle">
                                          {values.profilePhotoURL && (
                                            <img
                                              className="profile-pic"
                                              src={values.profilePhotoURL}
                                              alt="img"
                                            />
                                          )}
                                          {/* <div className="profile">
                                            <i
                                              className="fa fa-user"
                                              aria-hidden="true"
                                            ></i>
                                          </div> */}
                                        </div>
                                      </div>
                                      <div className="col-md-12 col-sm-12 hidden-xs">
                                        <div
                                         style={{cursor:"not-allowed"}}
                                          //  onClick={
                                          //   ()=>{
                                          //     warning("You Dont Have Access To Edit the Profile ,Read Only",warningNotification)
                                          // }
                                          //   }
                                        className="profile-add">
                                          <a 
                                           
                                          className="icon btn-file" href>
                                            <i
                                            style={{cursor:"not-allowed"}}
                                              className="fa fa-plus-circle"
                                              aria-hidden="true"
                                            ></i>
                                            {/* <FileBase64
                                              multiple={true}
                                              onChange={handleChange}
                                              onDone={(event) => {
                                                if (
                                                  [
                                                    "image/jpg",
                                                    "image/jpeg",
                                                    "image/png",
                                                  ].indexOf(event[0].type) < 0
                                                ) {
                                                  setFieldValue(
                                                    (values.documentTypeCheckForProfileImage = true)
                                                  );
                                                } else if (
                                                  event[0].file.size <= 1000000
                                                ) {
                                                  values.document.push({
                                                    documentHash:
                                                      event[0].base64,
                                                    documentType:
                                                      "ProfilePhoto",
                                                    documentName: event[0].name,
                                                  });
                                                  setFieldValue(
                                                    (values.documentTypeCheckForProfileImage = false)
                                                  );
                                                  setFieldValue(
                                                    (values.documentSizeCheckForProfileCheck = false)
                                                  );
                                                  values.profilePhotoURL =
                                                    event[0].base64;
                                                  setFieldValue(
                                                    (values.profilePhotoURL =
                                                      event[0].base64)
                                                  );
                                                } else {
                                                  setFieldValue(
                                                    (values.documentSizeCheckForProfileCheck = true)
                                                  );
                                                }
                                              }}
                                            /> */}
                                          </a>
                                          <a href>
                                            {" "}
                                            <h4
                                             style={{cursor:"not-allowed"}}
                                            >Add Image</h4>
                                          </a>
                                          {/* <span className="icon">
                                          <i
                                            className="fa fa-times-circle"
                                            aria-hidden="true"
                                          ></i>
                                        </span>
                                        <h4>Remove Image</h4> */}
                                          <div className="col-md-12 col-sm-12">
                                            <span class="file-size-limit">
                                              Supported Formats: .jpg, .jpeg,
                                              .png only. <br />
                                              File Size: Max 1 MB
                                            </span>
                                          </div>
                                          {values.documentSizeCheckForProfileCheck ? (
                                            <p style={{ color: "red" }}>
                                              File Size is too large(Maximum
                                              File Size:1MB).
                                            </p>
                                          ) : (
                                            ""
                                          )}
                                          {values.documentTypeCheckForProfileImage ? (
                                            <p style={{ color: "red" }}>
                                              Invalid image format
                                            </p>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                          
                                  <div class="row">
                                      <div class="col-md-4 col-sm-4 col-xs-12">
                                        <label>
                                          Mobile No{" "}
                                          <span className="validation"> *</span>
                                        </label>
                                       <Field 
                                       title={values.mobileNo}
                                          type="text"
                                          id="mobileNo"
                                          name="mobileNo"
                                          onChange={handleChange}
                                          disabled
                                          className={
                                            "form-control" +
                                            (errors.mobileNo && touched.mobileNo
                                              ? " is-invalid"
                                              : "")
                                          }
                                          placeholder="Mobile No"
                                        />
                                        <ErrorMessage
                                          name="mobileNo"
                                          className="validation"
                                          component="div"
                                        />
                                      </div>
                                      <div class="col-md-4 col-sm-4 col-xs-12">
                                        <label>
                                          Email Id{" "}
                                          <span className="validation"> *</span>
                                        </label>
                                       <Field
                                       title={values.emailID}
                                          type="text"
                                          name="emailID"
                                          id="emailID"
                                          disabled
                                          onChange={handleChange}
                                          className={
                                            "form-control" +
                                            (errors.emailID && touched.emailID
                                              ? " is-invalid"
                                              : "")
                                          }
                                          placeholder="Email ID"
                                        />
                                        <ErrorMessage
                                          name="emailID"
                                          className="validation"
                                          component="div"
                                        />
                                      </div>
                                      {/* {this.state.show && (
                                        <div class="col-md-4 col-sm-4 col-xs-12">
                                          <label>
                                            Gender{" "}
                                            <span className="validation">
                                              {" "}
                                              *
                                            </span>
                                          </label>
                                         <Field 
                                          disabled
                                          title={values.gender}
                                            as="select"
                                            name="gender"
                                            id="gender"
                                            onChange={handleChange}
                                            className={
                                              "form-control" +
                                              (errors.gender && touched.gender
                                                ? " is-invalid"
                                                : "")
                                            }
                                          >
                                            <option value="">--Select--</option>
                                            <option value="1">Male</option>
                                            <option value="2">Female</option>
                                            <option value="3">Other</option>
                                          </Field>
                                          <ErrorMessage
                                            name="gender"
                                            component="div"
                                            className="validation"
                                          />
                                        </div>
                                      )} */}
                                    </div>
                                    <div class="row">
                                      <div class="col-md-4 col-sm-4 col-xs-12">
                                        <label>
                                          First Name{" "}
                                          <span className="validation"> *</span>
                                        </label>
                                       <Field  disabled
                                          type="text"
                                          title={values.firstName}
                                          name="firstName"
                                          id="firstName"
                                          autoComplete="firstName"
                                          onChange={handleChange}
                                          className={
                                            "form-control" +
                                            (errors.firstName &&
                                              touched.firstName
                                              ? " is-invalid"
                                              : "")
                                          }
                                          placeholder="First Name"
                                        />
                                        <ErrorMessage
                                          name="firstName"
                                          className="validation "
                                          component="div"
                                        />
                                      </div>
                                      {/* <div class="col-md-4 col-sm-4 col-xs-12">
                                        <label>Middle Name</label>
                                       <Field  disabled
                                          type="text"
                                          title={values.middleName}
                                          name="middleName"
                                          onChange={handleChange}
                                          autoComplete="middleName"
                                          className={
                                            "form-control" +
                                            (errors.middleName &&
                                              touched.middleName
                                              ? " is-invalid"
                                              : "")
                                          }
                                          placeholder="Middle Name"
                                        />
                                        <ErrorMessage
                                          name="middleName"
                                          className="validation"
                                          component="div"
                                        />
                                      </div> */}
                                      <div class="col-md-4 col-sm-4 col-xs-12">
                                        <label>
                                          Last Name{" "}
                                          <span className="validation"> *</span>
                                        </label>
                                       <Field  disabled
                                          type="text"
                                          name="lastName"
                                          title={values.lastName}
                                          autoComplete="lastName"
                                          id="lastName"
                                          onChange={handleChange}
                                          className={
                                            "form-control" +
                                            (errors.lastName && touched.lastName
                                              ? " is-invalid"
                                              : "")
                                          }
                                          placeholder="Last Name"
                                        />
                                        <ErrorMessage
                                          name="lastName"
                                          className="validation"
                                          component="div"
                                        />
                                      </div>
                                      {this.state.show && (
                                        <div class="col-md-4 col-sm-4 col-xs-12">
                                          <label>
                                            Birth Date{" "}
                                            <span className="validation">
                                              {" "}
                                              *
                                            </span>
                                          </label>

                                          {/*<Field  disabled
                                              type="date"
                                              name="dob_1"
                                              max={this.state.today}
                                              disabled={values.role === "Student"}
                                              onChange={handleChange}
                                              className={
                                                "form-control" +
                                                (errors.dob_1 && touched.dob_1
                                                  ? " is-invalid"
                                                  : "")
                                              }
                                            /> */}
                                          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr">
                                            <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 pl pr">
                                             <Field  disabled
                                                as="select"
                                                name="day"
                                                id="day"
                                                //disabled={values.day ? true : false}
                                                onChange={(e) => {
                                                  var listOfMonth = [];
                                                  setFieldValue(
                                                    (values.day =
                                                      e.target.value)
                                                  );
                                                  if ([31, '31'].includes(e.target.value)) {
                                                    listOfMonth = [
                                                      { key: 1, value: "Jan" },
                                                      { key: 3, value: "Mar" },
                                                      { key: 5, value: "May" },
                                                      { key: 7, value: "Jul" },
                                                      { key: 8, value: "Aug" },
                                                      { key: 10, value: "Oct" },
                                                      { key: 12, value: "Dec" },
                                                    ];
                                                  } else if (
                                                    [30, '30'].includes(e.target.value)
                                                  ) {
                                                    listOfMonth = [
                                                      { key: 1, value: "Jan" },
                                                      { key: 3, value: "Mar" },
                                                      { key: 4, value: "Apr" },
                                                      { key: 5, value: "May" },
                                                      { key: 6, value: "Jun" },
                                                      { key: 7, value: "Jul" },
                                                      { key: 8, value: "Aug" },
                                                      { key: 9, value: "Sep" },
                                                      { key: 10, value: "Oct" },
                                                      { key: 11, value: "Nov" },
                                                      { key: 12, value: "Dec" },
                                                    ];
                                                  } else if (
                                                    [28, '28', 29, '29'].includes(e.target.value)
                                                  ) {
                                                    listOfMonth = [
                                                      { key: 1, value: "Jan" },
                                                      { key: 2, value: "Feb" },
                                                      { key: 3, value: "Mar" },
                                                      { key: 4, value: "Apr" },
                                                      { key: 5, value: "May" },
                                                      { key: 6, value: "Jun" },
                                                      { key: 7, value: "Jul" },
                                                      { key: 8, value: "Aug" },
                                                      { key: 9, value: "Sep" },
                                                      { key: 10, value: "Oct" },
                                                      { key: 11, value: "Nov" },
                                                      { key: 12, value: "Dec" },
                                                    ];
                                                  } else {
                                                    listOfMonth = [
                                                      { key: 1, value: "Jan" },
                                                      { key: 2, value: "Feb" },
                                                      { key: 3, value: "Mar" },
                                                      { key: 4, value: "Apr" },
                                                      { key: 5, value: "May" },
                                                      { key: 6, value: "Jun" },
                                                      { key: 7, value: "Jul" },
                                                      { key: 8, value: "Aug" },
                                                      { key: 9, value: "Sep" },
                                                      { key: 10, value: "Oct" },
                                                      { key: 11, value: "Nov" },
                                                      { key: 12, value: "Dec" },
                                                    ];
                                                  }
                                                  setFieldValue(
                                                    (values.listOfMonth =
                                                      listOfMonth)
                                                  );
                                                }}
                                                className={
                                                  "form-control" +
                                                  (errors.day && touched.day
                                                    ? "is-invalid"
                                                    : "")
                                                }
                                              >
                                                <option value="">DD</option>
                                                {(values.listOfDay || []).map(
                                                  (d) => (
                                                    <option value={d}>
                                                      {d}
                                                    </option>
                                                  )
                                                )}
                                              </Field>
                                            </div>
                                            <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 pl pr">
                                             <Field  disabled
                                                as="select"
                                                name="month"
                                                id="month"
                                                //disabled={values.month ? true : false}
                                                onChange={(e) => {
                                                  var listOfDay = [];
                                                  setFieldValue(
                                                    (values.month =
                                                      e.target.value)
                                                  );
                                                  if ([2, '2'].includes(e.target.value)) {
                                                    listOfDay = [];
                                                    for (
                                                      var i = 1;
                                                      i <= 29;
                                                      i++
                                                    ) {
                                                      listOfDay.push(i);
                                                    }
                                                  } else if (
                                                    // e.target.value == 1 ||
                                                    // e.target.value == 3 ||
                                                    // e.target.value == 5 ||
                                                    // e.target.value == 7 ||
                                                    // e.target.value == 8 ||
                                                    // e.target.value == 10 ||
                                                    // e.target.value == 12
                                                    [1, '1', 3, '3', 5, '5', 7, '7', 8, '8', 10, '10', 12, '12',].includes(e.target.value)
                                                  ) {
                                                    listOfDay = [];
                                                    for (
                                                      var iod = 1;
                                                      iod <= 31;
                                                      iod++
                                                    ) {
                                                      listOfDay.push(iod);
                                                    }
                                                  } else {
                                                    listOfDay = [];
                                                    for (
                                                      var iol = 1;
                                                      iol <= 30;
                                                      iol++
                                                    ) {
                                                      listOfDay.push(iol);
                                                    }
                                                  }
                                                  setFieldValue(
                                                    (values.listOfDay =
                                                      listOfDay)
                                                  );
                                                }}
                                                className={
                                                  "form-control" +
                                                  (errors.month && touched.month
                                                    ? "is-invalid"
                                                    : "")
                                                }
                                              >
                                                <option value="">MM</option>
                                                {(values.listOfMonth || []).map(
                                                  (m) => (
                                                    <option value={m.key}>
                                                      {m.value}
                                                    </option>
                                                  )
                                                )}
                                              </Field>
                                            </div>
                                            <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 pl pr">
                                             <Field  disabled
                                                as="select"
                                                name="year"
                                                id="year"
                                                className={
                                                  "form-control" +
                                                  (errors.year && touched.year
                                                    ? "is-invalid"
                                                    : "")
                                                }
                                              >
                                                <option value="">YYYY</option>
                                                {(
                                                  this.state.listOfYear || []
                                                ).map((year) => (
                                                  <option value={year}>
                                                    {year}
                                                  </option>
                                                ))}
                                              </Field>
                                            </div>
                                          </div>
                                          <ErrorMessage
                                            name="dob_1"
                                            className="validation"
                                            component="div"
                                          />
                                        </div>
                                      )}
                                    </div>
                                    <div class="row">
                                      {/* <div class="col-md-4 col-sm-4 col-xs-12">
                                        <label>Secondary Contact No</label>
                                       <Field  disabled
                                          type="text"
                                          name="contactNo"
                                          id="contactNo"
                                          title={values.contactNo}
                                          maxlength="10"
                                          autoComplete="contactNo"
                                          onChange={handleChange}
                                          className={
                                            "form-control" +
                                            (errors.contactNo &&
                                              touched.contactNo
                                              ? " is-invalid"
                                              : "")
                                          }
                                          placeholder="Mobile Number"
                                        />
                                        <ErrorMessage
                                          name="contactNo"
                                          className="validation"
                                          component="div"
                                        />
                                      </div>
                                      <div class="col-md-4 col-sm-4 col-xs-12"> */}
                                        {/* <label>Secondary Email ID</label>
                                       <Field  disabled
                                          type="text"
                                          name="secondaryEmailID"
                                          id="secondaryEmailID"
                                          title={values.secondaryEmailID}
                                          autoComplete="secondaryEmailID"
                                          onChange={handleChange}
                                          className={
                                            "form-control" +
                                            (errors.secondaryEmailID &&
                                              touched.secondaryEmailID
                                              ? " is-invalid"
                                              : "")
                                          }
                                          placeholder="Email ID"
                                        />
                                        <ErrorMessage
                                          name="secondaryEmailID"
                                          className="validation"
                                          component="div"
                                        />
                                      </div> */}
                                  
                                    </div>
                                    {this.state.show && (
                                      <div class="row">
                                        <div class="col-md-4 col-sm-4 col-xs-12">
                                          <label>Pan No </label>
                                         <Field  
                                           title={values.panNumber}
                                            type="text"
                                            name="panNumber"
                                            id="panNumber"
                                            maxlength="10"
                                            disabled={values.role === "Student"}
                                            onChange={handleChange}
                                            className={
                                              "form-control" +
                                              (errors.panNumber &&
                                                touched.panNumber
                                                ? " is-invalid"
                                                : "")
                                            }
                                            placeholder="Pan number"
                                          />
                                          <div className="col-md-12 col-sm-12">
                                            <span class="file-size-limit">
                                              PAN is compulsory for NISM
                                              registration
                                            </span>
                                          </div>
                                          <ErrorMessage
                                            name="panNumber"
                                            className="validation"
                                            component="div"
                                          />
                                        </div>
                                          {this.state.show && (
                                        <div class="col-md-4 col-sm-4 col-xs-12">
                                          <label>
                                            Gender{" "}
                                            <span className="validation">
                                              {" "}
                                              *
                                            </span>
                                          </label>
                                         <Field 
                                          disabled
                                          title={values.gender}
                                            as="select"
                                            name="gender"
                                            id="gender"
                                            onChange={handleChange}
                                            className={
                                              "form-control" +
                                              (errors.gender && touched.gender
                                                ? " is-invalid"
                                                : "")
                                            }
                                          >
                                            <option value="">--Select--</option>
                                            <option value="1">Male</option>
                                            <option value="2">Female</option>
                                            <option value="3">Other</option>
                                          </Field>
                                          <ErrorMessage
                                            name="gender"
                                            component="div"
                                            className="validation"
                                          />
                                        </div>
                                      )}
                                        

                                        {/* <div class="col-md-4 col-sm-4 col-xs-12">
                                          <label>
                                            Aadhar No{" "}
                                            <span className="validation">
                                              {" "}
                                              *
                                            </span>
                                          </label>
                                         <Field 
                                            type="text"
                                            name="aadharNumber"
                                            title={values.aadharNumber}
                                            id="aadharNumber"
                                            maxlength="12"
                                            disabled={
                                              values.role === "Student"
                                                ? values.aadharNumber.length >
                                                  12
                                                  ? true
                                                  : false
                                                : false
                                            }
                                            disabled
                                          
                                            onChange={handleChange}
                                            onBlur={(event) => {
                                              LoginService.TokenUser((res) => {
                                                localStorage.setItem(
                                                  "jwt-token",
                                                  res.responseObject
                                                );
                                              });
                                              RegisterUserService.checkPAN(
                                                "studentID=" +
                                                this.state.studentID +
                                                "&panNumber=" +
                                                "&aadharNumber=" +
                                                event.target.value,
                                                (res) => {
                                                  if (res.status === "fail") {
                                                    setFieldValue(
                                                      (values.aadharNumber = "")
                                                    );
                                                    error(res.reasonText, {
                                                      ...errorNotification,
                                                      container: "top-center",
                                                    });
                                                  }
                                                }
                                              );
                                            }}
                                            className={
                                              "form-control" +
                                              (errors.aadharNumber &&
                                                touched.aadharNumber
                                                ? " is-invalid"
                                                : "")
                                            }
                                            placeholder="Aadhar number"
                                          />
                                          <ErrorMessage
                                            name="aadharNumber"
                                            className="validation"
                                            component="div"
                                          />
                                        </div>
                                    */}
                                        <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>Marital Status</label>
                                      <Field
                                        disabled
                                        as="select"
                                        name="maritalStatus"
                                        onChange={handleChange}
                                        autoComplete="maritalStatus"
                                        className="form-control"
                                      >
                                        <option value="" defaultValue>
                                          -- Select --
                                        </option>
                                        <option value="Married">Married</option>
                                        <option value="Single">Single</option>
                                        <option value="Divorced">
                                          Divorced
                                        </option>
                                        <option value="Widowed">Widowed</option>
                                      </Field>
                                      {/* <ErrorMessage
                                        name="maritalStatus"
                                        className="validation"
                                        component="div"
                                      /> */}
                                    </div>
                               
                                    {/* <div className="row">
                                    <div className="col-md-8 col-sm-8 col-xs-12">
                                    <div className="col-md-12 col-sm-12 col-xs-12 col-lg-12 ">
                                      <label>
                                        Annual Family Income(lpa){" "}
                                        
                                      </label>
                                      </div>
                                      <div className="col-md-6 col-sm-6 col-xs-10 col-lg-6 ">

                                      <Field
                                        disabled
                                        type="text"
                                        title={values.annualFamilyIncome}
                                        name="annualFamilyIncome"
                                        id="annualFamilyIncome"
                                        onChange={handleChange}
                                        maxLength={10}
                                        autoComplete="annualFamilyIncome"
                                        className={
                                          "form-control " +
                                          (errors.annualFamilyIncome &&
                                          touched.annualFamilyIncome
                                          ? " is-invalid"
                                          : "")
                                        }
                                        placeholder="Annual Family Income"
                                        />

                                         </div>
                                         <div className="col-md-6 col-sm-6 col-xs-2 col-lg-6 p m">
                                          <Tooltip
                                                style={{float:"left"}}
                                                trigger="click"
                                                interactive={true}
                                                title= "<h5>If you need a loan to fund your education, it's essential for your parents to have a valid PAN</h5>"
                                                size="big"
                                              > */}
                                          {/* <i
                                            style={{color:'darkblue'}}
                                            className="fa fa-info discountTooltip"
                                            aria-hidden="true"
                                          ></i> */}
                                   
                                              {/* <img 
                                                style={{
                                                   maxWidth:"30px",maxHeight:"80px",width:"23px",height:"23px", marginLeft:"-20px" ,marginTop:"4px"
  
                                                }}
                                              
                                              src={Logo} alt="Info Icon" />                 
                                            </Tooltip>
                                            </div>
                                 <div className="col-md-12 col-sm-12 col-xs-12 col-lg-12">
                                      <ErrorMessage
                                        name="annualFamilyIncome"
                                        className="validation "
                                        component="div"
                                      />
                                      </div>
                                    </div>
                                  </div> */}
                          
                                      </div>
                                      
                                    )}
                                    <div class="col-md-4 col-sm-4 col-xs-12"></div>
                                    <div class="col-md-12 col-sm-12 col-xs-12"></div>
                                    {this.state.show && (
                                      <div class="row">
                                        <div 
                                        style={{cursor:"not-allowed"}}
                                        className="col-md-4 col-sm-4 col-xs-12">
                                          <label>Upload PAN</label>
                                          <div className="profile-detail">
                                            <div className="circle">
                                            {values.panCardURL&&
                                              <img
                                                className="profile-pic"
                                                src={values.panCardURL}
                                                alt="img"
                                              />
                                            }
                                              {/* <div className="profile">
                                                <i
                                                  className="fa fa-user"
                                                  aria-hidden="true"
                                                ></i>
                                              </div> */}
                                            </div>
                                          </div>
                                          <div
                                          style={{cursor:"not-allowed"}}
                                            // onClick={
                                            //   ()=>{
                                            //     warning("You Dont Have Access To Edit the Profile ,Read Only",warningNotification)
                                            // }
                                            //   }
                                          className="profile-add">
                                            <span
                                            style={{cursor:"not-allowed"}}
                                            className="icon btn-file text-center">
                                              <i
                                                style={{cursor:"not-allowed"}}
                                                className="fa fa-plus-circle"
                                                aria-hidden="true"
                                              ></i>
                                              {/* <FileBase64
                                              
                                                multiple={true}
                                                name="panCardURL"
                                                onChange={handleChange}
                                                onDone={(event) => {
                                                  if (
                                                    [
                                                      "image/jpg",
                                                      "image/jpeg",
                                                      "image/png",
                                                    ].indexOf(event[0].type) < 0
                                                  ) {
                                                    setFieldValue(
                                                      (values.documentTypeCheckForPANImage = true)
                                                    );
                                                  } else if (
                                                    event[0].file.size <=
                                                    5000000
                                                  ) {
                                                    values.document.push({
                                                      documentHash:
                                                        event[0].base64,
                                                      documentType: "PanCard",
                                                      documentName:
                                                        event[0].name,
                                                    });
                                                    setFieldValue(
                                                      (values.documentTypeCheckForPANImage = false)
                                                    );
                                                    setFieldValue(
                                                      (values.documentSizeCheckForPanCard = false)
                                                    );
                                                    setFieldValue(
                                                      (values.panCardDocumentName =
                                                        event[0].name)
                                                    );
                                                    setFieldValue(
                                                      (values.panCardURL =
                                                        event[0].base64)
                                                    );
                                                  } else {
                                                    setFieldValue(
                                                      (values.documentSizeCheckForPanCard = true)
                                                    );
                                                  }
                                                }}
                                              /> */}
                                            </span>
                                            <h4>Add PAN</h4>
                                            {/* <span className="icon">
                                              <i
                                                className="fa fa-times-circle"
                                                aria-hidden="true"
                                              ></i>
                                            </span> */}
                                            {/* <h4>Remove PAN</h4> */}
                                            <div className="col-md-12 col-sm-12">
                                              <span class="file-size-limit">
                                                Supported Formats: .jpg, .jpeg,
                                                .png only. <br />
                                                File Size: Max 5 MB
                                              </span>
                                            </div>
                                            {values.documentSizeCheckForPanCard ? (
                                              <p style={{ color: "red" }}>
                                                File Size is too large(Maximum
                                                File Size:5MB).
                                              </p>
                                            ) : (
                                              ""
                                            )}
                                            {values.documentTypeCheckForPANImage ? (
                                              <p style={{ color: "red" }}>
                                                Invalid image format
                                              </p>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                        </div>
                                        {/* <div className="col-md-4 col-sm-4 col-xs-12">
                                          <label>Upload Aadhaar</label>
                                          <div className="profile-detail">
                                            <div className="circle">
                                            {values.aadharCardURL&&
                                              <img
                                                className="profile-pic"
                                                src={values.aadharCardURL}
                                                alt="img"
                                              />
                                            }
                                              {/* <div className="profile">
                                                <i
                                                  className="fa fa-user"
                                                  aria-hidden="true"
                                                ></i>
                                              </div> */}
                                            {/* </div>
                                          </div>
                                          <div 
                                           onClick={
                                            ()=>{
                                              warning("You Dont Have Access To Edit the Profile ,Read Only",warningNotification)
                                          }
                                            }
                                          className="profile-add">
                                            <span className="icon btn-file text-center">
                                              <i
                                                className="fa fa-plus-circle"
                                                aria-hidden="true"
                                               
                                              ></i> */}
                                              {/* <FileBase64
                                                multiple={true}
                                               
                                                name="aadharCardURL"
                                                onChange={handleChange}
                                                onDone={(event) => {
                                                  if (
                                                    [
                                                      "image/jpg",
                                                      "image/jpeg",
                                                      "image/png",
                                                    ].indexOf(event[0].type) < 0
                                                  ) {
                                                    setFieldValue(
                                                      (values.documentTypeCheckForAadharImage = true)
                                                    );
                                                  } else if (
                                                    event[0].file.size <=
                                                    5000000
                                                  ) {
                                                    values.document.push({
                                                      documentHash:
                                                        event[0].base64,
                                                      documentType:
                                                        "AadharCard",
                                                      documentName:
                                                        event[0].name,
                                                    });
                                                    setFieldValue(
                                                      (values.documentTypeCheckForAadharImage = false)
                                                    );
                                                    setFieldValue(
                                                      (values.documentSizeCheckForAadharCard = false)
                                                    );
                                                    setFieldValue(
                                                      (values.aadharCardDocumentName =
                                                        event[0].name)
                                                    );
                                                    setFieldValue(
                                                      (values.aadharCardURL =
                                                        event[0].base64)
                                                    );
                                                  } else {
                                                    setFieldValue(
                                                      (values.documentSizeCheckForAadharCard = true)
                                                    );
                                                  }
                                                }}
                                              /> */}
                                            {/* </span> */}
                                            {/* <h4>Add Aadhaar</h4> */}
                                            {/* <span className="icon">
                                              <i
                                                className="fa fa-times-circle"
                                                aria-hidden="true"
                                              ></i>
                                            </span> */}
                                            {/* <h4>Remove</h4> */}
                                            {/* <div className="col-md-12 col-sm-12">
                                              <span class="file-size-limit">
                                                Supported Formats: .jpg, .jpeg,
                                                .png only. <br />
                                                File Size: Max 5 MB
                                              </span>
                                            </div>
                                            {values.documentSizeCheckForAadharCard ? (
                                              <p style={{ color: "red" }}>
                                                File Size is too large(Maximum
                                                File Size:5MB).
                                              </p>
                                            ) : (
                                              ""
                                            )}
                                            {values.documentTypeCheckForAadharImage ? (
                                              <p style={{ color: "red" }}>
                                                Invalid image format
                                              </p>
                                            ) : (
                                              ""
                                            )}
                                          </div> */}
                                        </div> 
                                      // </div>
                                    )}
                                    <div class="col-md-4 col-sm-4 col-xs-12"></div>
                                  </div>
                                </div>
                              </div>
                            </section>
                }
                {this.state.currentTab===1&&
                        <section
                              class="create-address page-section"
                              id="create-address"
                            >
                              <h2 class="sub-header">Address Details</h2>
                              <div class="address-border">
                                <div class="form-group">
                                  <div class="row">
                                    <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                      <h5 class="address-heading">
                                        Correspondence Address
                                      </h5>
                                    </div>
                                    <div class="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        Address 1{" "}
                                        <span className="validation"> *</span>
                                      </label>
                                     <Field  disabled
                                        type="text"
                                        name="ca_address_1"
                                        title={values.ca_address_1}
                                        id="ca_address_1"
                                        autoComplete="ca_address_1"
                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.ca_address_1 &&
                                            touched.ca_address_1
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Address"
                                      />
                                      <ErrorMessage
                                        name="ca_address_1"
                                        className="validation"
                                        component="div"
                                      />
                                    </div>
                                    <div class="col-md-4 col-sm-4 col-xs-12">
                                      <label>Address 2</label>
                                     <Field  disabled
                                        type="text"
                                        name="ca_address_2"
                                        title={values.ca_address_2}
                                        autoComplete="ca_address_2"
                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.ca_address_2 &&
                                            touched.ca_address_2
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Address"
                                      />
                                      <ErrorMessage
                                        name="ca_address_2"
                                        className="validation"
                                        component="div"
                                      />
                                    </div>
                                    <div class="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        Country{" "}
                                        <span className="validation"> *</span>
                                      </label>
                                     <Field  disabled
                                        as="select"
                                        name="ca_country"
                                        id="ca_country"
                                        onChange={(event) => {
                                          LoginService.TokenUser((res) => {
                                            localStorage.setItem(
                                              "jwt-token",
                                              res.responseObject
                                            );
                                          });
                                          if (event.target.value !== "") {
                                            setFieldValue(
                                              (values.ca_country =
                                                event.target.value)
                                            );

                                            values.stateList = [];
                                            values.cityList = [];
                                            RegionManagementService.getState(
                                              "countryId=" + values.ca_country,
                                              (res) => {
                                                setFieldValue(
                                                  (values.stateList =
                                                    res.responseListObject)
                                                );
                                              }
                                            );
                                          }
                                        }}
                                        className={
                                          "form-control" +
                                          (errors.ca_country &&
                                            touched.ca_country
                                            ? " is-invalid"
                                            : "")
                                        }
                                      >
                                        <option value="0">--Select--</option>
                                        {this.state.countryList.map((team) =>
                                          team.isActive ? (
                                            <option
                                              key={team.countryId}
                                              value={team.countryId}
                                            >
                                              {pascalCase(team.countryName)}
                                            </option>
                                          ) : (
                                            ""
                                          )
                                        )}
                                      </Field>
                                      <ErrorMessage
                                        name="ca_country"
                                        component="div"
                                        className="validation"
                                      />
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        State{" "}
                                        <span className="validation"> *</span>
                                      </label>
                                    <Field  disabled
                                        as="select"
                                        name="ca_state"
                                        id="ca_state"
                                        onChange={(event) => {
                                          LoginService.TokenUser((res) => {
                                            localStorage.setItem(
                                              "jwt-token",
                                              res.responseObject
                                            );
                                          });
                                          if (event.target.value !== "") {
                                            setFieldValue(
                                              (values.ca_state =
                                                event.target.value)
                                            );

                                            RegionManagementService.getCity(
                                              "stateId=" + values.ca_state,
                                              (res) => {
                                                setFieldValue(
                                                  (values.cityList =
                                                    res.responseListObject)
                                                );
                                              }
                                            );
                                          }
                                        }}
                                        className={
                                          "form-control" +
                                          (errors.ca_state && touched.ca_state
                                            ? " is-invalid"
                                            : "")
                                        }
                                      >
                                        <option value="0">--Select--</option>
                                        {(values.stateList || []).map(
                                          (team) => (
                                            <option
                                              key={team.stateId}
                                              value={team.stateId}
                                            >
                                              {pascalCase(team.stateName)}
                                            </option>
                                          )
                                        )}
                                      </Field>
                                      <ErrorMessage
                                        name="ca_state"
                                        component="div"
                                        className="validation"
                                      />
                                    </div>
                                    <div class="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        City{" "}
                                        <span className="validation"> *</span>
                                      </label>
                                     <Field  disabled
                                        as="select"
                                        name="ca_city"
                                        id="ca_city"
                                        onChange={(event) => {
                                          if (
                                            event.target.value !== undefined
                                          ) {
                                            setFieldValue(
                                              (values.ca_city =
                                                event.target.value)
                                            );
                                          }
                                        }}
                                        className={
                                          "form-control" +
                                          (errors.ca_city && touched.ca_city
                                            ? " is-invalid"
                                            : "")
                                        }
                                      >
                                        <option value="0">--Select--</option>
                                        {(values.cityList || []).map((team) => (
                                          <option
                                            key={team.cityId}
                                            value={team.cityId}
                                          >
                                            {/* {pascalCase(team.cityName)} */}
                                            {team?.cityName}
                                          </option>
                                        ))}
                                      </Field>
                                      <ErrorMessage
                                        name="ca_city"
                                        component="div"
                                        className="validation"
                                      />
                                    </div>
                                    <div class="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        Pin{" "}
                                        <span className="validation"> *</span>
                                      </label>
                                     <Field  disabled
                                        type="text"
                                        name="ca_postal_code"
                                        title={values.ca_postal_code}
                                        id="ca_postal_code"
                                        maxlength="6"
                                        autoComplete="ca_postal_code"
                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.ca_postal_code &&
                                            touched.ca_postal_code
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Postal Code"
                                      />
                                      <ErrorMessage
                                        name="ca_postal_code"
                                        className="validation"
                                        component="div"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="address-border">
                                <div class="form-group">
                                  <div class="row">
                                    <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                      <div class="row row-no-margin">
                                        <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                        <div className="col-md-4 col-lg-4 col-sm-4 col-xs-12">
                                          <h5 className="address-heading" style={{marginTop:"15px"}}>
                                            Permanent Address{" "}
                                          </h5>
                                        </div>
                                        <div className="col-md-8 col-lg-8 col-sm-8 col-xs-12">
                                          <div
                                            className="form-check "
                                            style={{
                                              display: "inline-flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            <Field
                                               disabled
                                              className="preference-check-input"
                                              type="checkbox"
                                              name="sameAsAbove"
                                              checked={values.addressFlag}
                                              onClick={(event) => {
                                                if (event.target.checked) {
                                                  values.stateListForPer =
                                                    values.stateListForCor;
                                                  values.cityListForPer =
                                                    values.cityListForCor;
                                                  values.perStreet =
                                                    values.corStreet;
                                                  values.perStreet2 =
                                                    values.corStreet2;
                                                  values.percountryId =
                                                    values.corcountryId;
                                                  values.perstateId =
                                                    values.corstateId;
                                                  values.percityId =
                                                    values.corcityId;
                                                  values.perPostalCode =
                                                    values.corPostalCode;
                                                  values.addressFlag =
                                                    "checked";
                                                } else {
                                                  values.perStreet = "";
                                                  values.perStreet2 = "";
                                                  values.percountryId = "";
                                                  values.perstateId = "";
                                                  values.percityId = "";
                                                  values.perPostalCode = "";
                                                  values.addressFlag = "";
                                                  values.stateListForPer = [];
                                                  values.cityListForPer = [];
                                                }
                                              }}
                                            />
                                            <label
                                              className="form-check-label"
                                              htmlFor="gridCheck"
                                            >
                                              &nbsp;&nbsp;Same as Above
                                            </label>
                                          </div>
                                        </div>
                                      </div> 
                                      </div>{" "}
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div class="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        Address 1{" "}
                                        <span className="validation"> *</span>
                                      </label>
                                     <Field  disabled
                                        type="text"
                                        name="pa_address_1"
                                        id="pa_address_1"
                                        title={values.pa_address_1}
                                        autoComplete="pa_address_1"
                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.pa_address_1 &&
                                            touched.pa_address_1
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Address"
                                      />
                                      <ErrorMessage
                                        name="pa_address_1"
                                        className="validation"
                                        component="div"
                                      />
                                    </div>
                                    <div class="col-md-4 col-sm-4 col-xs-12">
                                      <label>Address 2</label>
                                     <Field  disabled
                                        type="text"
                                        name="pa_address_2"
                                        autoComplete="pa_address_2"
                                        title={values.pa_address_2}
                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.pa_address_2 &&
                                            touched.pa_address_2
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Address"
                                      />
                                      <ErrorMessage
                                        name="pa_address_2"
                                        className="validation"
                                        component="div"
                                      />
                                    </div>
                                    <div class="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        Country{" "}
                                        <span className="validation"> *</span>
                                      </label>
                                     <Field  disabled
                                        as="select"
                                        name="pa_country"
                                        
                                        id="pa_country"
                                        onChange={(event) => {
                                          LoginService.TokenUser((res) => {
                                            localStorage.setItem(
                                              "jwt-token",
                                              res.responseObject
                                            );
                                          });
                                          if (event.target.value !== "") {
                                            setFieldValue(
                                              (values.pa_country =
                                                event.target.value)
                                            );

                                            values.stateListForPer = [];
                                            values.cityListForPer = [];
                                            RegionManagementService.getState(
                                              "countryId=" + values.pa_country,
                                              (res) => {
                                                values.stateListForPer =
                                                  res.responseListObject;
                                              }
                                            );
                                          }
                                        }}
                                        className={
                                          "form-control" +
                                          (errors.pa_country &&
                                            touched.pa_country
                                            ? " is-invalid"
                                            : "")
                                        }
                                      >
                                        <option value="0">--Select--</option>
                                        {this.state.countryListForPer.map(
                                          (team) =>
                                            team.isActive ? (
                                              <option
                                                key={team.countryId}
                                                value={team.countryId}
                                              >
                                                {pascalCase(team.countryName)}
                                              </option>
                                            ) : (
                                              ""
                                            )
                                        )}
                                      </Field>
                                      <ErrorMessage
                                        name="pa_country"
                                        component="div"
                                        className="validation"
                                      />
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        State{" "}
                                        <span className="validation"> *</span>
                                      </label>
                                     <Field  disabled
                                        as="select"
                                        name="pa_state"

                                        id="pa_state"
                                        onChange={(event) => {
                                          LoginService.TokenUser((res) => {
                                            localStorage.setItem(
                                              "jwt-token",
                                              res.responseObject
                                            );
                                          });
                                          if (
                                            event.target.value !== undefined
                                          ) {
                                            setFieldValue(
                                              (values.pa_state =
                                                event.target.value)
                                            );

                                            RegionManagementService.getCity(
                                              "stateId=" + values.pa_state,
                                              (res) => {
                                                values.cityListForPer =
                                                  res.responseListObject;
                                              }
                                            );
                                          }
                                        }}
                                        className={
                                          "form-control" +
                                          (errors.pa_state && touched.pa_state
                                            ? " is-invalid"
                                            : "")
                                        }
                                      >
                                        <option value="0">--Select--</option>
                                        {(values.stateListForPer || []).map(
                                          (team) => (
                                            <option
                                              key={team.stateId}
                                              value={team.stateId}
                                            >
                                              {pascalCase(team.stateName)}
                                            </option>
                                          )
                                        )}
                                      </Field>
                                      <ErrorMessage
                                        name="pa_state"
                                        component="div"
                                        className="validation"
                                      />
                                    </div>
                                    <div class="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        City{" "}
                                        <span className="validation"> *</span>
                                      </label>
                                     <Field  disabled
                                        as="select"
                                        name="pa_city"

                                        id="pa_city"
                                        onChange={(event) => {
                                          if (
                                            event.target.value !== undefined
                                          ) {
                                            setFieldValue(
                                              (values.pa_city =
                                                event.target.value)
                                            );
                                          }
                                        }}
                                        className={
                                          "form-control" +
                                          (errors.pa_city && touched.pa_city
                                            ? " is-invalid"
                                            : "")
                                        }
                                      >
                                        <option value="0">--Select--</option>
                                        {(values.cityListForPer || []).map(
                                          (team) => (
                                            <option
                                              key={team.cityId}
                                              value={team.cityId}
                                            >
                                              {pascalCase(team.cityName)}
                                            </option>
                                          )
                                        )}
                                      </Field>
                                      <ErrorMessage
                                        name="pa_city"
                                        component="div"
                                        className="validation"
                                      />
                                    </div>

                                    <div class="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        Pin{" "}
                                        <span className="validation"> *</span>{" "}
                                      </label>
                                     <Field  disabled
                                        type="text"
                                        name="pa_postal_code"
                                        id="pa_postal_code"
                                        title={values.pa_postal_code}
                                        maxlength="6"
                                        autoComplete="pa_postal_code"
                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.pa_postal_code &&
                                            touched.pa_postal_code
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Postal Code"
                                      />
                                      <ErrorMessage
                                        name="pa_postal_code"
                                        className="validation"
                                        component="div"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
        }
                            {this.state.currentTab === 1 && (
                            this.state.show && (
                              <section
                              className="create-parent page-section"
                              id="create-parent"
                            >
                              <div className="row">
                                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                  <h2 className="sub-header">Parent Details</h2>
                                  <div className="address-border">
                                    <div className="form-group">
                                      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr">
                                        <h5 className="address-heading">
                                          Father/Guardian Details
                                        </h5>
                                      </div>
                                      <div className="form-group">
                                        <div className="row">
                                          <div className="col-md-4 col-sm-4 col-xs-12">
                                            <label>Name </label>
                                            <Field
                                              disabled
                                              type="text"
                                              name="studentFatherName"
                                              title={values.studentFatherName}
                                              id="studentFatherName"
                                              maxLength={255}
                                              onChange={handleChange}
                                              autoComplete="studentFatherName"
                                              className="form-control"
                                              placeholder="Enter Name"
                                            />
                                            <ErrorMessage
                                              name="studentFatherName"
                                              className="validation"
                                              component="div"
                                            />
                                          </div>
                                          <div className="col-md-4 col-sm-4 col-xs-12">
                                            <label>Birth Date</label>
                                            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr">
                                              <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 pl pr">
                                                <Field
                                                disabled
                                                  as="select"
                                                  name="studentFatherday"
                                                  id="studentFatherday"
                                                  onChange={(e) => {
                                                    var listOfMonth = [];
                                                    setFieldValue(
                                                      (values.studentFatherday =
                                                        e.target.value)
                                                    );
                                                    if (
                                                      [31, "31"].includes(
                                                        e.target.value
                                                      )
                                                    ) {
                                                      listOfMonth = [
                                                        { key: 1, value: "Jan" },
                                                        { key: 3, value: "Mar" },
                                                        { key: 5, value: "May" },
                                                        { key: 7, value: "Jul" },
                                                        { key: 8, value: "Aug" },
                                                        { key: 10, value: "Oct" },
                                                        { key: 12, value: "Dec" },
                                                      ];
                                                    } else if (
                                                      [30, "30"].includes(
                                                        e.target.value
                                                      )
                                                    ) {
                                                      listOfMonth = [
                                                        { key: 1, value: "Jan" },
                                                        { key: 3, value: "Mar" },
                                                        { key: 4, value: "Apr" },
                                                        { key: 5, value: "May" },
                                                        { key: 6, value: "Jun" },
                                                        { key: 7, value: "Jul" },
                                                        { key: 8, value: "Aug" },
                                                        { key: 9, value: "Sep" },
                                                        { key: 10, value: "Oct" },
                                                        { key: 11, value: "Nov" },
                                                        { key: 12, value: "Dec" },
                                                      ];
                                                    } else if (
                                                      [
                                                        28,
                                                        "28",
                                                        29,
                                                        "29",
                                                      ].includes(e.target.value)
                                                    ) {
                                                      listOfMonth = [
                                                        { key: 1, value: "Jan" },
                                                        { key: 2, value: "Feb" },
                                                        { key: 3, value: "Mar" },
                                                        { key: 4, value: "Apr" },
                                                        { key: 5, value: "May" },
                                                        { key: 6, value: "Jun" },
                                                        { key: 7, value: "Jul" },
                                                        { key: 8, value: "Aug" },
                                                        { key: 9, value: "Sep" },
                                                        { key: 10, value: "Oct" },
                                                        { key: 11, value: "Nov" },
                                                        { key: 12, value: "Dec" },
                                                      ];
                                                    } else {
                                                      listOfMonth = [
                                                        { key: 1, value: "Jan" },
                                                        { key: 2, value: "Feb" },
                                                        { key: 3, value: "Mar" },
                                                        { key: 4, value: "Apr" },
                                                        { key: 5, value: "May" },
                                                        { key: 6, value: "Jun" },
                                                        { key: 7, value: "Jul" },
                                                        { key: 8, value: "Aug" },
                                                        { key: 9, value: "Sep" },
                                                        { key: 10, value: "Oct" },
                                                        { key: 11, value: "Nov" },
                                                        { key: 12, value: "Dec" },
                                                      ];
                                                    }
                                                    setFieldValue(
                                                      (values.fatherlistOfMonth = listOfMonth)
                                                    );
  
                                                    // this.setState({
                                                    //   listOfMonth: listOfMonth
                                                    // })
                                                  }}
                                                  className={
                                                    "form-control " +
                                                    (errors.day && touched.day
                                                      ? "is-invalid"
                                                      : "")
                                                  }
                                                >
                                                  <option value="">DD</option>
                                                  {(
                                                    values.fatherlistOfDay || []
                                                  ).map((d) => (
                                                    <option key={d} value={d}>
                                                      {d}
                                                    </option>
                                                  ))}
                                                </Field>
                                              </div>
                                              <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 pl pr">
                                                <Field
                                                disabled
                                                  as="select"
                                                  name="studentFathermonth"
                                                  id="studentFathermonth"
                                                  onChange={(e) => {
                                                    var listOfDay = [];
                                                    setFieldValue(
                                                      (values.studentFathermonth =
                                                        e.target.value)
                                                    );
                                                    if (e.target.value === 2) {
                                                      listOfDay = [];
                                                      for (
                                                        var i = 1;
                                                        i <= 29;
                                                        i++
                                                      ) {
                                                        listOfDay.push(i);
                                                      }
                                                    } else if (
                                                      [
                                                        1,
                                                        "1",
                                                        3,
                                                        "3",
                                                        5,
                                                        "5",
                                                        7,
                                                        "7",
                                                        8,
                                                        "8",
                                                        10,
                                                        "10",
                                                        12,
                                                        "12",
                                                      ].includes(e.target.value)
                                                    ) {
                                                      listOfDay = [];
                                                      for (
                                                        var fi = 1;
                                                        fi <= 31;
                                                        fi++
                                                      ) {
                                                        listOfDay.push(fi);
                                                      }
                                                    } else {
                                                      listOfDay = [];
                                                      for (
                                                        var foi = 1;
                                                        foi <= 30;
                                                        foi++
                                                      ) {
                                                        listOfDay.push(foi);
                                                      }
                                                    }
                                                    setFieldValue(
                                                      (values.fatherlistOfDay = listOfDay)
                                                    );
                                                  }}
                                                  className={
                                                    "form-control " +
                                                    (errors.month && touched.month
                                                      ? "is-invalid"
                                                      : "")
                                                  }
                                                >
                                                  <option value="">MM</option>
                                                  {(
                                                    values.fatherlistOfMonth || []
                                                  ).map((m) => (
                                                    <option
                                                      key={m.key}
                                                      value={m.key}
                                                    >
                                                      {m.value}
                                                    </option>
                                                  ))}
                                                </Field>
                                              </div>
                                              <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 pl pr">
                                                 <Field  disabled
                                                    as="select"
                                                    name="fatheryear"
                                                    id="fatheryear"
                                                    className={
                                                      "form-control" +
                                                      (errors.fatheryear && touched.fatheryear
                                                        ? "is-invalid"
                                                        : "")
                                                    }
                                                  //disabled={values.fatheryear ? true : false}
                                                  >
                                                    <option value="">YYYY</option>
                                                    {(
                                                      this.state.listOfFatherYear || []
                                                    ).map((year) => (
                                                      <option value={year}>
                                                        {year}
                                                      </option>
                                                    ))}
                                                  </Field>
                                                </div>
                                              </div>
                                          </div>
                                          <div className="col-md-4 col-sm-4 col-xs-12">
                                            <label>Occupation Type</label>
                                            <Field
                                            disabled
                                              as="select"
                                              name="studentFatherEmployementType"
                                              onChange={(event) => {
                                                setFieldValue(
                                                  (values.studentFatherEmployementType =
                                                    event.target.value)
                                                );
                                                if (
                                                  event.target.value === "6" ||
                                                  event.target.value === "8"
                                                ) {
                                                  setFieldValue(
                                                    (values.studentFatherCompanyName =
                                                      "")
                                                  );
                                                }
                                              }}
                                              id="state"
                                              className={
                                                "form-control" +
                                                (errors.studentFatherEmployementType &&
                                                touched.studentFatherEmployementType
                                                  ? " is-invalid"
                                                  : "")
                                              }
                                            >
                                              <option value="">
                                                ---Select----
                                              </option>
                                              {(
                                                this.state
                                                  .employeTypeForParents || []
                                              ).map((team) => (
                                                <option
                                                  key={team.codeValueId}
                                                  value={team.codeValueId}
                                                >
                                                  {team.codeValue}
                                                </option>
                                              ))}
                                            </Field>
                                            <ErrorMessage
                                              name="studentFatherEmployementType"
                                              component="div"
                                              className="validation"
                                            />
                                          </div>
                                          </div>
                                          <div className="row">
                                          <div className="col-md-4 col-sm-4 col-xs-12">
                                            <label>Mobile No</label>
                                            <Field
                                            disabled
                                              type="text"
                                              name="studentFatherMobileNo"
                                              onChange={handleChange}
                                              title={values.studentFatherMobileNo}
                                              className="form-control"
                                              placeholder="Enter Mobile No"
                                            />
                                            <ErrorMessage
                                              name="studentFatherMobileNo"
                                              className="validation"
                                              component="div"
                                            />
                                          </div>
                                          <div className="col-md-4 col-sm-4 col-xs-12">
                                            <label>Email ID</label>
                                            <Field
                                            disabled
                                              type="text"
                                              title={values.studentFatherEmailID}
                                              name="studentFatherEmailID"
                                              onChange={handleChange}
                                              className="form-control"
                                              placeholder="Enter Email ID"
                                            />
                                            <ErrorMessage
                                              name="studentFatherEmailID"
                                              className="validation"
                                              component="div"
                                            />
                                          </div>                                  
                                         <div className="col-md-4 col-sm-4 col-xs-12">
                                            <label>
                                              Educational BackGround
                                             
                                            </label>
                                            <Field
                                            disabled
                                              as="select"
                                              name="studentFatherEducation"
                                              id="studentFatherEducation"
                                              onChange={handleChange}
                                              className={
                                                "form-control" +
                                                (errors.studentFatherEducation &&
                                                touched.studentFatherEducation
                                                  ? " is-invalid"
                                                  : "")
                                              }
                                            >
                                              <option value="0">
                                                ---Select----
                                              </option>
                                              <option value="Not a Graduate">Not a Graduate</option>
                                              <option value="Graduate and Above">Graduate and Above</option>
                                            </Field>
                                            <ErrorMessage
                                              name="studentFatherEducation"
                                              component="div"
                                              className="validation"
                                            />
                                          </div>
                                         </div>
                                        
                                        <div className="row">
                                        <div className="col-md-4 col-sm-4 col-xs-12">
                                            <label>Pan</label>
                                            <Field
                                            disabled
                                              type="text"
                                              name="studentFatherPanNumber"
                                              title={values.studentFatherPanNumber}
                                              maxLength="10"
                                              onChange={handleChange}
                                              className="form-control"
                                              placeholder="Enter PAN NO"
                                            />
                                            <ErrorMessage
                                              name="studentFatherPanNumber"
                                              className="validation"
                                              component="div"
                                            />
                                            <span className="file-size-limit">
                                              If you need a loan to fund your
                                              education, it's essential for your
                                              parents to have a valid PAN
                                            </span>
                                          </div>
                                        
                                        
                                        </div>
  
                                        {/* <div className="row">
                                          {values.studentFatherEmployementType ===
                                            "6" ||
                                            values.studentFatherEmployementType ===
                                            "8" ||
                                            values.studentFatherEmployementType ===
                                            6 ||
                                            values.studentFatherEmployementType ===
                                            8 ? (
                                            ""
                                          ) : (
                                            <div className="col-md-4 col-sm-4 col-xs-12">
                                              <label>Company Name </label>
                                              <Field
                                                type="text"
                                                name="studentFatherCompanyName"
                                                onChange={handleChange}
                                                autoComplete="studentFatherCompanyName"
                                                className="form-control"
                                                placeholder="Company Name"
                                              />
                                            </div>
                                          )}
                                        </div> */}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="address-border">
                                    <div className="form-group">
                                      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr">
                                        <h5 className="address-heading">
                                          Mother/Guardian Details
                                        </h5>
                                      </div>
                                      <div className="row">
                                        <div className="col-md-4 col-sm-4 col-xs-12">
                                          <label>Name </label>
                                          <Field
                                          disabled
                                            type="text"
                                            title={values.studentMotherName}
                                            name="studentMotherName"
                                            maxLength={255}
                                            onChange={handleChange}
                                            autoComplete="studentMotherName"
                                            className="form-control"
                                            placeholder="Enter Name"
                                          />
                                          <ErrorMessage
                                            name="studentMotherName"
                                            className="validation"
                                            component="div"
                                          />
                                        </div>
                                        <div className="col-md-4 col-sm-4 col-xs-12">
                                          <label>Birth Date</label>
  
                                          {/* <Field
                                              type="date"
                                              max={this.state.today}
                                              name="studentMotherDOB"
                                              id="studentMotherDOB"
                                              onChange={handleChange}
                                              className="form-control"
                                              placeholder=""
                                            />
                                            <ErrorMessage
                                              name="studentMotherDOB"
                                              component="div"
                                              className="validation"
                                            /> */}
                                          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr">
                                            <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 pl pr">
                                              <Field
                                              disabled
                                                as="select"
                                                name="studentMotherday"
                                                id="studentMotherday"
                                                onChange={(e) => {
                                                  var listOfMonth = [];
                                                  setFieldValue(
                                                    (values.studentMotherday =
                                                      e.target.value)
                                                  );
                                                  if (
                                                    [31, "31"].includes(
                                                      e.target.value
                                                    )
                                                  ) {
                                                    listOfMonth = [
                                                      { key: 1, value: "Jan" },
                                                      { key: 3, value: "Mar" },
                                                      { key: 5, value: "May" },
                                                      { key: 7, value: "Jul" },
                                                      { key: 8, value: "Aug" },
                                                      { key: 10, value: "Oct" },
                                                      { key: 12, value: "Dec" },
                                                    ];
                                                  } else if (
                                                    [30, "30"].includes(
                                                      e.target.value
                                                    )
                                                  ) {
                                                    listOfMonth = [
                                                      { key: 1, value: "Jan" },
                                                      { key: 3, value: "Mar" },
                                                      { key: 4, value: "Apr" },
                                                      { key: 5, value: "May" },
                                                      { key: 6, value: "Jun" },
                                                      { key: 7, value: "Jul" },
                                                      { key: 8, value: "Aug" },
                                                      { key: 9, value: "Sep" },
                                                      { key: 10, value: "Oct" },
                                                      { key: 11, value: "Nov" },
                                                      { key: 12, value: "Dec" },
                                                    ];
                                                  } else if (
                                                    [28, "28", 29, "29"].includes(
                                                      e.target.value
                                                    )
                                                  ) {
                                                    listOfMonth = [
                                                      { key: 1, value: "Jan" },
                                                      { key: 2, value: "Feb" },
                                                      { key: 3, value: "Mar" },
                                                      { key: 4, value: "Apr" },
                                                      { key: 5, value: "May" },
                                                      { key: 6, value: "Jun" },
                                                      { key: 7, value: "Jul" },
                                                      { key: 8, value: "Aug" },
                                                      { key: 9, value: "Sep" },
                                                      { key: 10, value: "Oct" },
                                                      { key: 11, value: "Nov" },
                                                      { key: 12, value: "Dec" },
                                                    ];
                                                  } else {
                                                    listOfMonth = [
                                                      { key: 1, value: "Jan" },
                                                      { key: 2, value: "Feb" },
                                                      { key: 3, value: "Mar" },
                                                      { key: 4, value: "Apr" },
                                                      { key: 5, value: "May" },
                                                      { key: 6, value: "Jun" },
                                                      { key: 7, value: "Jul" },
                                                      { key: 8, value: "Aug" },
                                                      { key: 9, value: "Sep" },
                                                      { key: 10, value: "Oct" },
                                                      { key: 11, value: "Nov" },
                                                      { key: 12, value: "Dec" },
                                                    ];
                                                  }
                                                  setFieldValue(
                                                    (values.motherlistOfMonth = listOfMonth)
                                                  );
  
                                                  // this.setState({
                                                  //   listOfMonth: listOfMonth
                                                  // })
                                                }}
                                                className={
                                                  "form-control " +
                                                  (errors.day && touched.day
                                                    ? "is-invalid"
                                                    : "")
                                                }
                                              >
                                                <option value="">DD</option>
                                                {(
                                                  values.motherlistOfDay || []
                                                ).map((d) => (
                                                  <option key={d} value={d}>
                                                    {d}
                                                  </option>
                                                ))}
                                              </Field>
                                            </div>
                                            <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 pl pr">
                                              <Field
                                              disabled
                                                as="select"
                                                name="studentMothermonth"
                                                id="studentMothermonth"
                                                onChange={(e) => {
                                                  var listOfDay = [];
                                                  setFieldValue(
                                                    (values.studentMothermonth =
                                                      e.target.value)
                                                  );
                                                  if (e.target.value === 2) {
                                                    listOfDay = [];
                                                    for (
                                                      var i = 1;
                                                      i <= 29;
                                                      i++
                                                    ) {
                                                      listOfDay.push(i);
                                                    }
                                                  } else if (
                                                    [
                                                      1,
                                                      "1",
                                                      3,
                                                      "3",
                                                      5,
                                                      "5",
                                                      7,
                                                      "7",
                                                      8,
                                                      "8",
                                                      10,
                                                      "10",
                                                      12,
                                                      "12",
                                                    ].includes(e.target.value)
                                                  ) {
                                                    listOfDay = [];
                                                    for (
                                                      var mi = 1;
                                                      mi <= 31;
                                                      mi++
                                                    ) {
                                                      listOfDay.push(mi);
                                                    }
                                                  } else {
                                                    listOfDay = [];
                                                    for (
                                                      var moi = 1;
                                                      moi <= 30;
                                                      moi++
                                                    ) {
                                                      listOfDay.push(moi);
                                                    }
                                                  }
                                                  setFieldValue(
                                                    (values.motherlistOfDay = listOfDay)
                                                  );
                                                }}
                                                className={
                                                  "form-control " +
                                                  (errors.month && touched.month
                                                    ? "is-invalid"
                                                    : "")
                                                }
                                              >
                                                <option value="">MM</option>
                                                {(
                                                  values.motherlistOfMonth || []
                                                ).map((m) => (
                                                  <option
                                                    key={m.key}
                                                    value={m.key}
                                                  >
                                                    {m.value}
                                                  </option>
                                                ))}
                                              </Field>
                                            </div>
                                            <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4^ pl pr">
                                               <Field  disabled
                                                  as="select"
                                                  name="motheryear"
                                                  id="motheryear"
                                                  className={
                                                    "form-control" +
                                                    (errors.motheryear && touched.motheryear
                                                      ? "is-invalid"
                                                      : "")
                                                  }
                                                //disabled={values.motheryear ? true : false}
                                                >
                                                  <option value="">YYYY</option>
                                                  {(
                                                    this.state.listOfMotherYear || []
                                                  ).map((year) => (
                                                    <option value={year}>
                                                      {year}
                                                    </option>
                                                  ))}
                                                </Field>
                                              </div>

                                          </div>
                                        </div>
                                        <div className="col-md-4 col-sm-4 col-xs-12">
                                          <label>Occupation Type</label>
                                          <Field
                                          disabled
                                            as="select"
                                            name="studentMotherEmployementType"
                                            onChange={(event) => {
                                              setFieldValue(
                                                (values.studentMotherEmployementType =
                                                  event.target.value)
                                              );
                                              if (
                                                event.target.value === "6" ||
                                                event.target.value === "8"
                                              ) {
                                                setFieldValue(
                                                  (values.studentMotherCompanyName =
                                                    "")
                                                );
                                              }
                                            }}
                                            id="state"
                                            className={
                                              "form-control" +
                                              (errors.studentMotherEmployementType &&
                                              touched.studentMotherEmployementType
                                                ? " is-invalid"
                                                : "")
                                            }
                                          >
                                            <option value="">
                                              ---Select----
                                            </option>
                                            {(
                                              this.state.employeTypeForParents ||
                                              []
                                            ).map((team) => (
                                              <option
                                                key={team.codeValueId}
                                                value={team.codeValueId}
                                              >
                                                {team.codeValue}
                                              </option>
                                            ))}
                                          </Field>
                                          <ErrorMessage
                                            name="studentMotherEmployementType"
                                            component="div"
                                            className="validation"
                                          />
                                        </div>
                                        </div>
                                        <div className="row">
                                        <div className="col-md-4 col-sm-4 col-xs-12">
                                          <label>Mobile No</label>
                                          <Field
                                          disabled
                                            type="text"
                                            name="studentMotherMobileNo"
                                            title={values.studentMotherMobileNo}
                                            onChange={handleChange}
                                            className="form-control"
                                            placeholder="Enter Mobile No"
                                          />
                                          <ErrorMessage
                                            name="studentMotherMobileNo"
                                            className="validation"
                                            component="div"
                                          />
                                        </div>
                                        <div className="col-md-4 col-sm-4 col-xs-12">
                                          <label>Email ID</label>
                                          <Field
                                          disabled
                                            type="text"
                                            name="studentMotherEmailID"   
                                            title={values.studentMotherEmailID}
                                            onChange={handleChange}
                                            className="form-control"
                                            placeholder="Enter Email ID"
                                          />
                                          <ErrorMessage
                                            name="studentMotherEmailID"
                                            className="validation"
                                            component="div"
                                          />
                                        </div>
                                        <div className="col-md-4 col-sm-4 col-xs-12">
                                          <label>
                                            Educational BackGround
                                            
                                          </label>
                                          <Field
                                          disabled
                                            as="select"
                                            name="studentMotherEducation"
                                            id="studentMotherEducation"
                                            onChange={handleChange}
                                            className={
                                              "form-control" +
                                              (errors.studentMotherEducation &&
                                              touched.studentMotherEducation
                                                ? " is-invalid"
                                                : "")
                                            }
                                          >
                                            <option value="0">
                                              ---Select----
                                            </option>
                                            <option value="Not a Graduate">Not a Graduate</option>
                                            <option value="Graduate and Above">Graduate and Above</option>
                                          </Field>
                                          <ErrorMessage
                                            name="studentMotherEducation"
                                            component="div"
                                            className="validation"
                                          />
                                        </div>
                                      </div>
  
                                      <div className="row">
                                      <div className="col-md-4 col-sm-4 col-xs-12">
                                          <label>Pan</label>
                                          <Field
                                          disabled
                                            type="text"
                                            name="studentMotherPanNumber"
                                            
                                            title={values.studentMotherPanNumber}
                                            maxLength="10"
                                            onChange={handleChange}
                                            className="form-control"
                                            placeholder="Enter PAN NO"
                                          />
                                          <ErrorMessage
                                            name="studentMotherPanNumber"
                                            className="validation"
                                            component="div"
                                          />
                                          <span className="file-size-limit">
                                            If you need a loan to fund your
                                            education, it's essential for your
                                            parents to have a valid PAN
                                          </span>
                                        </div>
                                      
                                      
                                      </div>
                                      {/* <div className="row">
                                        {values.studentMotherEmployementType ===
                                          "6" ||
                                          values.studentMotherEmployementType ===
                                          "8" ||
                                          values.studentMotherEmployementType ===
                                          6 ||
                                          values.studentMotherEmployementType ===
                                          8 ? (
                                          ""
                                        ) : (
                                          <div className="col-md-4 col-sm-4 col-xs-12">
                                            <label>Company Name </label>
                                            <Field
                                              type="text"
                                              name="studentMotherCompanyName"
                                              onChange={handleChange}
                                              autoComplete="studentMotherCompanyName"
                                              className="form-control"
                                              placeholder="Company Name"
                                            />
                                          </div>
                                        )}
                                      </div> */}
                                    </div>
                                  </div>
                                  <div className="address-border">
                                    <div className="form-group">
                                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr">
                                      <h5 className="address-heading">
                                        Annual Family Income
                                      </h5>
                                    </div>
                                      <div className="row">
                                    <div className="col-md-8 col-sm-8 col-xs-12">
                                    <div className="col-md-12 col-sm-12 col-xs-12 col-lg-12 ">
                                      <label>
                                        Annual Family Income(inr){" "}
                                        
                                      </label>
                                      </div>
                                      <div className="col-md-6 col-sm-6 col-xs-10 col-lg-6 ">

                                      <Field
                                        disabled
                                        as="select"
                                        title={values.annualFamilyIncome}
                                        name="annualFamilyIncome"
                                        id="annualFamilyIncome"
                                        onChange={handleChange}
                                        // maxLength={10}
                                        // autoComplete="annualFamilyIncome"
                                        className={
                                          "form-control " +
                                          (errors.annualFamilyIncome &&
                                          touched.annualFamilyIncome
                                          ? " is-invalid"
                                          : "")
                                        }
                                        placeholder="Annual Family Income"
                                        >
                                              <option value="">--Select--</option>
                                        {(values.annualFamilyIncomeList || []).map(
                                          item => (
                                            <option
                                              key={item.incomeId}
                                              value={item.incomeId}
                                            >
                                              {item.incomeRange}
                                            </option>
                                          )
                                        )}
                                      </Field>

                                         </div>
                                         <div className="col-md-6 col-sm-6 col-xs-2 col-lg-6 p m">
                                          <Tooltip
                                                style={{float:"left"}}
                                                trigger="click"
                                                interactive={true}
                                                title= "<h5>If you are interested in scholarships or CSR-sponsored programs, kindly provide your annual family income for necessary considerations.</h5>"
                                                size="big"
                                              >
                                                <img 
                                                style={{
                                                   maxWidth:"30px",maxHeight:"80px",width:"23px",height:"23px", marginLeft:"-20px" ,marginTop:"4px"
  
                                                }}
                                              
                                              src={Logo} alt="Info Icon" />                 
                                            </Tooltip>
                                            </div>
                                 <div className="col-md-12 col-sm-12 col-xs-12 col-lg-12">
                                      <ErrorMessage
                                        name="annualFamilyIncome"
                                        className="validation "
                                        component="div"
                                      />
                                      </div>
                                    </div>
                                  </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                              )
                            )}
                             {this.state.currentTab === 2 && (
                            this.state.show && (
                              <section
                                class="create-qualification page-section"
                                id="create-qualification"
                                style={{maxWidth:"100%",width:"100%"}}
                              >
                             
                      
                             <div className="row"
                             
                             >
                <div className="col-lg-12 col-md-12 col-sm-6 col-xs-12">
                  <h2 className="sub-header">Educational Details</h2>
                </div>
                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  {/* <h2 className="sub-header">Education Details</h2> */}
                  <div className="">
                    <FieldArray 
                      name="studentQualification"
                      onChange={handleChange}
                      render={(arrayHelpers) => (
                        <div>
                          {values.studentQualification &&
                          values.studentQualification.length > 0 ? (
                            <div className="table-row table-responsive mb-20">
                              <table className="table table-bordered table-hover">
                                <thead>
                                  <tr>
                                    <th
                                      className="text-center"
                                      style={{
                                        minWidth: "200px",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      College/Institute Name
                                      <span className="validation"> *</span>
                                    </th>
                                    <th
                                      className="text-center"
                                      style={{
                                        minWidth: "200px",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      Course Name
                                    </th>
                                    <th
                                      className="text-center"
                                      style={{
                                        minWidth: "200px",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                       University/Board
                                    </th>

                                    <th
                                      className="text-center"
                                      style={{
                                        minWidth: "200px",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      University Location
                                      <tr>
                                        <th
                                          className="text-center"
                                          style={{
                                            minWidth: "100px",
                                            verticalAlign: "middle",
                                          }}
                                        >
                                          State
                                        </th>
                                        <th
                                          className="text-center"
                                          style={{
                                            minWidth: "100px",
                                            verticalAlign: "middle",
                                          }}
                                        >
                                          City
                                        </th>
                                      </tr>
                                    </th>
                                    <th
                                      className="text-center"
                                      style={{
                                        minWidth: "200px",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      Qualification Category
                                      {/* <span className="validation"> *</span> */}
                                    </th>
                                    <th
                                      className="text-center"
                                      style={{
                                        minWidth: "200px",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      Passing Year
                                      <span className="validation"> *</span>
                                    </th>
                                    {/* <th
                                      className="text-center"
                                      style={{
                                        minWidth: "200px",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      Pursuing Year
                                    </th> */}
                                    <th
                                      className="text-center"
                                      style={{
                                        minWidth: "150px",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      Percentage
                                      <span className="validation"> *</span>
                                      <span className="file-size-limit">Please provide the percentage equivalent of CGPA.</span>
                                    </th>
                                    <th
                                      className="text-center"
                                      style={{
                                        minWidth: "300px",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      Certificate
                                      <div className="col-md-12 col-sm-12">
                                        <span className="file-size-limit">
                                          Supported Formats: .png,.jpg, .jpeg,
                                          .pdf only. File Size: Max 2 MB
                                        </span>
                                      </div>
                                    </th>
                                    {/* <th
                                      className="text-center"
                                      style={{
                                        minWidth: "100px",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      Action
                                    </th> */}
                                  </tr>
                                </thead>
                                <tbody>
                                  {values.studentQualification.map(
                                    (friend, index) => (
                                      <tr key={index}>
                                        <td>
                                          <Field
                                          disabled
                                            name={`studentQualification.${index}.instituteName`}
                                            
                                            title={values.studentQualification[index].instituteName}
                                            id={`studentQualification.${index}.instituteName`}
                                            className="form-control"
                                            onChange={handleChange}
                                            value={friend.instituteName ?? ""}
                                          />
                                          <div className="validation">
                                            {getErrorMessage(
                                              errors.studentQualification,
                                              index,
                                              "instituteName"
                                            )}
                                          </div>
                                        </td>

                                        <td>
                                          <Field
                                            disabled
                                        
                                            name={`studentQualification.${index}.qualificationCategory`}
                                            id={`studentQualification.${index}.qualificationCategory`}
                                            title={values.studentQualification[index].qualificationCategory}
                                            className="form-control"
                                            onChange={handleChange}
                                            value={
                                              friend.qualificationCategory ?? ""
                                            }
                                          />
                                          <div className="validation">
                                            {getErrorMessage(
                                              errors.studentQualification,
                                              index,
                                              "qualificationCategory"
                                            )}
                                          </div>
                                        </td>
                                        <td>
                                          <Field
                                          disabled
                                            name={`studentQualification.${index}.university`}
                                            id={`studentQualification.${index}.university`}
                                            title={values.studentQualification[index].university}
                                            className="form-control"
                                            onChange={handleChange}
                                            maxLength={255}
                                            value={friend.university ?? ""}
                                          />
                                          <div className="validation">
                                            {getErrorMessage(
                                              errors.studentQualification,
                                              index,
                                              "university"
                                            )}
                                          </div>
                                        </td>
                                        <td>
                                          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr">
                                            <div className="col-md-6 col-lg-6 col-sm-6 col-xs-6 pl pr">
                                              <Field
                                              disabled
                                                as="select"
                                                name={`studentQualification.${index}.stateId`}
                                                id={`studentQualification.${index}.stateId`}
                                                onChange={(event) => {
                                                  handleChange(event);

                                                  // this.handleCityList(index,event.target.value);

                                                  let data={
                                                    stateIdList: [event.target.value]
                                                  }
                                                  
                                                  RegionManagementService.getCities(
                                                    data,
                                                    (res) => {
                                                  //     let cityOptionList =values.city;
                                                  //     const beforeIndex = cityOptionList? cityOptionList.slice(0, index):[];
                                                  //     const afterIndex = cityOptionList? cityOptionList.slice(index+1):[];
                                                      
                                                     
                                                  //     let cityList=res.responseListObject;
                                                  //     cityList.forEach((item) => {
                                                  //       item.cityName = item.cityName
                                                  //         .split(' ')
                                                  //         .map((word) => {
                                                  //           return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                                                  //         })
                                                  //         .join(' ');
                                                  //     });
                                                  //     cityOptionList = [...beforeIndex,cityList, ...afterIndex];

                                                  // setFieldValue("city",cityOptionList);
                                                  let cityOptionList = values.city || []; // add a check to ensure cityOptionList is not undefined
                                                  const beforeIndex = cityOptionList ? cityOptionList.slice(0, index) : [];
                                                  const afterIndex = cityOptionList ? cityOptionList.slice(index + 1) : [];

                                                  let cityList = res.responseListObject;
                                                  cityList.forEach((item) => {
                                                    item.cityName = item.cityName
                                                      .split(' ')
                                                      .map((word) => {
                                                        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                                                      })
                                                      .join(' ');
                                                  });

                                                  cityOptionList = [...beforeIndex,cityList, ...afterIndex];
                                                  // cityOptionList.splice(index, 1, ...cityList);

                                                  setFieldValue("city", cityOptionList);

                                                    }
                                                  );
                                                }}
                                                className="form-control"
                                              >
                                                <option value="">State</option>
                                                {(values.state || []).map(
                                                  (m) => (
                                                    <option
                                                      key={m.stateId}
                                                      value={m.stateId}
                                                    >
                                                      {m.stateName}
                                                    </option>
                                                  )
                                                )}
                                              </Field>
                                            </div>
                                            <div className="col-md-6 col-lg-6 col-sm-6 col-xs-6 pl pr">
                                              <Field
                                              disabled
                                                as="select"
                                                name={`studentQualification.${index}.cityId`}
                                                id={`studentQualification.${index}.cityId`}
                                                onChange={handleChange}
                                                className="form-control"
                                              >
                                                <option value="">City</option>
                                                {(
                                                 ( values.cityForEducation&&values.cityForEducation[index] )|| []
                                                )?.map((m) => (
                                                  <option
                                                    key={m.cityId}
                                                    value={m.cityId}
                                                  >
                                                    {m.cityName}
                                                  </option>
                                                ))}
                                              </Field>
                                            </div>
                                          </div>
                                          <div className="validation">
                                            {getErrorMessage(
                                              errors.studentQualification,
                                              index,
                                              "stateId"
                                            )}
                                          </div>
                                          <div className="validation">
                                            {getErrorMessage(
                                              errors.studentQualification,
                                              index,
                                              "cityId"
                                            )}
                                          </div>
                                        </td>
                                        <td>
                                          <Field

                                            as="select"
                                            name={`studentQualification.${index}.qualificationType`}
                                            id={`studentQualification.${index}.qualificationType`}
                                            className="form-control"
                                            disabled
                                            onChange={(event) => {
                                              if (
                                                values.studentQualification.find(
                                                  (d) =>
                                                    d.qualificationType ===
                                                    event.target.value
                                                )
                                              ) {
                                                //
                                                warning(
                                                  "Already Selected ,Choose Another Qualification",
                                                  warningNotification
                                                );
                                              } else if (
                                                event.target.value === "12th"
                                              ) {
                                                if (
                                                  values.studentQualification.find(
                                                    (d) =>
                                                      d.qualificationType ===
                                                        "10th" && index === 1
                                                  )
                                                ) {
                                                  setFieldValue(
                                                    (friend.qualificationType =
                                                      event.target.value)
                                                  );
                                                } else {
                                                  warning(
                                                    "Please ADD Educatinal Details In Order ",
                                                    warningNotification
                                                  );
                                                }
                                              } else if (
                                                event.target.value === "Diploma"
                                              ) {
                                                if (
                                                  values.studentQualification.find(
                                                    (d) =>
                                                      d.qualificationType ===
                                                        "10th" && index === 1
                                                  )
                                                ) {
                                                  setFieldValue(
                                                    (friend.qualificationType =
                                                      event.target.value)
                                                  );
                                                } else {
                                                  warning(
                                                    "Please ADD Educatinal Details In Order ",
                                                    warningNotification
                                                  );
                                                }
                                              } else if (
                                                event.target.value ===
                                                "Graduate"
                                              ) {
                                                if (
                                                  values.studentQualification.find(
                                                    (d) =>
                                                      d.qualificationType ===
                                                      "10th"
                                                  ) &&
                                                  values.studentQualification.find(
                                                    (d) =>
                                                      d.qualificationType ===
                                                      "12th"
                                                  ) &&
                                                  index === 2
                                                ) {
                                                  setFieldValue(
                                                    (friend.qualificationType =
                                                      event.target.value)
                                                  );
                                                } else {
                                                  warning(
                                                    "Please ADD Educatinal Details In Order ",
                                                    warningNotification
                                                  );
                                                }
                                              } else if (
                                                event.target.value === "MBA/PGDM"
                                              ) {
                                                if (
                                                  values.studentQualification.find(
                                                    (d) =>
                                                      d.qualificationType ===
                                                      "10th"
                                                  ) &&
                                                  values.studentQualification.find(
                                                    (d) =>
                                                      d.qualificationType ===
                                                      "12th"
                                                  ) &&
                                                  values.studentQualification.find(
                                                    (d) =>
                                                      d.qualificationType ===
                                                      "Graduate"
                                                  ) &&
                                                  (index === 4 || index === 3)
                                                ) {
                                                  setFieldValue(
                                                    (friend.qualificationType =
                                                      event.target.value)
                                                  );
                                                } else {
                                                  warning(
                                                    "Please ADD Educatinal Details In Order ",
                                                    warningNotification
                                                  );
                                                }
                                              } else if (
                                                event.target.value === "Postgraduate"
                                              ) {
                                                if (
                                                  values.studentQualification.find(
                                                    (d) =>
                                                      d.qualificationType ===
                                                      "10th"
                                                  ) &&
                                                  values.studentQualification.find(
                                                    (d) =>
                                                      d.qualificationType ===
                                                      "12th"
                                                  ) &&
                                                  values.studentQualification.find(
                                                    (d) =>
                                                      d.qualificationType ===
                                                      "Graduate"
                                                  ) &&
                                                  (index === 4 || index === 3)
                                                ) {
                                                  setFieldValue(
                                                    (friend.qualificationType =
                                                      event.target.value)
                                                  );
                                                } else {
                                                  warning(
                                                    "Please ADD Educatinal Details In Order ",
                                                    warningNotification
                                                  );
                                                }
                                              } else {
                                                // this.setState({
                                                //   studyCategory: [
                                                //     ...this.state
                                                //       .studyCategory,
                                                //     event.target.value,
                                                //   ],
                                                // });
                                                setFieldValue(
                                                  (friend.qualificationType =
                                                    event.target.value)
                                                );
                                              }
                                            }}
                                            // onChange={(event) => {
                                            //   if (index===0) {
                                            //     if (
                                            //       event.target.value === "10th"
                                            //     ) {
                                            //       this.setState({
                                            //         studyCategory: [
                                            //           ...this.state
                                            //             .studyCategory,
                                            //           event.target.value,
                                            //         ],
                                            //       });
                                            //       setFieldValue(
                                            //         (friend.qualificationType =
                                            //           event.target.value)
                                            //       );
                                            //     } else {
                                            //       if (
                                            //         event.target.value === "12th"
                                            //       ) {
                                            //         warning(
                                            //           "Please ADD Details Of X before XII",
                                            //           warningNotification
                                            //         );
                                            //       }
                                            //     }
                                            //   } else {
                                            //     console.log(
                                            //       "vkd",
                                            //       values.studentQualification
                                            //     );
                                            //     if (
                                            //       values.studentQualification.find(
                                            //         (d) =>
                                            //           d.qualificationType ===
                                            //           event.target.value
                                            //       )
                                            //     ) {
                                            //       //
                                            //       warning(
                                            //         "Already Selected ,Choose Another Qualification",
                                            //         warningNotification
                                            //       );
                                            //       console.log("already exists");
                                            //     } else {
                                            //       this.setState({
                                            //         studyCategory: [
                                            //           ...this.state
                                            //             .studyCategory,
                                            //           event.target.value,
                                            //         ],
                                            //       });
                                            //       setFieldValue(
                                            //         (friend.qualificationType =
                                            //           event.target.value)
                                            //       );
                                            //     }
                                            //   }

                                            //   // if (
                                            //   //   event.target
                                            //   //     .value ===
                                            //   //   "Graduate" ||
                                            //   //   event.target
                                            //   //     .value ===
                                            //   //   "Graduate"
                                            //   // ) {
                                            //   //   setFieldValue(
                                            //   //     (friend.passingYear =
                                            //   //       "")
                                            //   //   );
                                            //   // } else {
                                            //   //   setFieldValue(
                                            //   //     (friend.persuingYear =
                                            //   //       "")
                                            //   //   );
                                            //   // }
                                            // }}
                                          >
                                            <option value="">
                                              Select Education
                                            </option>

                                            {/* <option value="10th">X</option>
                                            <option value="12th">XII</option>
                                            <option value="Diploma">
                                              Diploma
                                            </option>
                                            <option value="Graduate">
                                              Graduation
                                            </option>
                                            <option value="MBA/PGDM">
                                              Post Graduation
                                            </option>
                                            <option value="Postgraduate">
                                              Postgraduate
                                            </option>
                                            <option value="Other">
                                              Any Other Certification
                                            </option> */}
                                             <option value="">
                                              Select Education
                                            </option>
                                            <option value="10th">10th</option>
                                            <option value="12th">12th</option>
                                            {/* <option value="Diploma">
                                              Diploma
                                            </option> */}
                                            <option value="Graduate">
                                            Graduate
                                            </option>
                                            <option value="MBA/PGDM">
                                              MBA/PGDM
                                            </option>
                                            <option value="Postgraduate">
                                            Post Graduate
                                            </option>
                                            
                                           <option value="Any Other Finance Certification (short course/ certification)">Any Other Finance Certification (short course/ certification)</option>
                                           <option value="Any Other Professional Course/ Degree (CA/CS/CFA,etc.)">Any Other Professional Course/ Degree (CA/CS/CFA,etc.)</option> 
                                           {/* <option value="Any Other Certification (short course/ certification)">Any Other Certification (short course/ certification)</option> */}
                                          <option value="Any CIEL/ FinX Certification done">Any CIEL/ FinX Certification done</option> 
                                          </Field>
                                          <div className="validation">
                                            {getErrorMessage(
                                              errors.studentQualification,
                                              index,
                                              "qualificationType"
                                            )}
                                          </div>
                                        </td>
                                        <td>
                                          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr">
                                            <div className="col-md-5 col-lg-5 col-sm-5 col-xs-5 pl pr">
                                              <Field
                                              disabled
                                                as="select"
                                                name={`studentQualification.${index}.passingMonth`}
                                                onChange={handleChange}
                                                className="form-control"
                                              >
                                                <option value="">MM</option>
                                                {(values.listOfMonth || []).map(
                                                  (m) => (
                                                    <option
                                                      key={m.key}
                                                      value={m.key}
                                                    >
                                                      {m.value}
                                                    </option>
                                                  )
                                                )}
                                              </Field>
                                            </div>
                                            <div className="col-md-7 col-lg-7 col-sm-7 col-xs-7 pl pr">
                                              <Field
                                              disabled
                                                as="select"
                                                name={`studentQualification.${index}.passingYear`}
                                                onChange={handleChange}
                                                className="form-control"
                                              >
                                                <option value="">YYYY</option>
                                                {(
                                                  this.state.listOfYear2 || []
                                                ).map((year) => (
                                                  <option
                                                    key={year}
                                                    value={year}
                                                  >
                                                    {year}
                                                  </option>
                                                ))}
                                              </Field>
                                            </div>
                                          </div>
                                          <div className="validation">
                                            {getErrorMessage(
                                              errors.studentQualification,
                                              index,
                                              "passingMonth"
                                            )}
                                          </div>
                                          <div className="validation">
                                            {getErrorMessage(
                                              errors.studentQualification,
                                              index,
                                              "passingYear"
                                            )}
                                          </div>
                                          {/* <Field
                                          as="select"
                                          className="form-control"
                                          name={`studentQualification.${index}.passingYear`}
                                          id={`studentQualification.${index}.passingYear`}
                                          type="number"
                                          disabled={
                                            friend.qualificationType ==
                                              "Graduate" ||
                                              friend.qualificationType ==
                                              "Graduate"
                                              ? true
                                              : false
                                          }
                                          value={
                                            friend.qualificationType ==
                                              "Graduate" ||
                                              friend.qualificationType ==
                                              "Graduate"
                                              ? ""
                                              : friend.passingYear
                                          }
                                        >
                                          <option value="">
                                            Select
                                          </option>
                                          {(
                                            this.state
                                              .listOfYear ||
                                            []
                                          ).map((ugyear) => (
                                            <option
                                              key={ugyear}
                                              value={ugyear}
                                            >
                                              {ugyear}
                                            </option>
                                          ))}
                                        </Field> */}
                                        </td>
                                        {/* <td> */}
                                        {/* disabled={
                                          friend.qualificationType ==
                                            "MBA/PGDM" ||
                                            friend.qualificationType ==
                                            "Postgraduate"
                                            ? true
                                            : false
                                        } */}
                                        {/* value={
                                            friend.qualificationType ==
                                              "MBA/PGDM" ||
                                              friend.qualificationType ==
                                              "Postgraduate"
                                              ? ""
                                              : friend.persuingYear
                                          } */}
                                        {/* <Field
                                            as="select"
                                            className="form-control"
                                            name={`studentQualification.${index}.persuingYear`}
                                            id={`studentQualification.${index}.persuingYear`}
                                            value={friend.persuingYear}
                                          >
                                            <option value="">--Select--</option>
                                            <option value="1">1st</option>
                                            <option value="2">2nd</option>
                                            <option value="3">3rd</option>
                                            <option value="4">4th</option>
                                          </Field>
                                        </td> */}
                                        <td>
                                        <div style={{display:"flex",justifyContent:"space-around",alignItems:"center"}}>
                                          <div>
                                          <Field
                                          disabled
                                            className="form-control"
                                            title={values.studentQualification[index].grade}
                                            name={`studentQualification.${index}.grade`}
                                            id={`studentQualification.${index}.grade`}
                                            value={friend.grade}
                                            /></div>
                                            <div className="percentage">%</div></div>  
                                          <div className="validation">
                                            {getErrorMessage(
                                              errors.studentQualification,
                                              index,
                                              "grade"
                                            )}
                                          </div>
                                        </td>
                                        <td>
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                            }}
                                          >
                                            <div
                                             style={{cursor:"not-allowed",padding: 0 }}
                                              // onClick={
                                              //   ()=>{
                                              //     warning("You Dont Have Access To Edit the Profile ,Read Only",warningNotification)
                                              // }
                                              //   }
                                              className="Resume profile-add text-center"
                                              
                                            >
                                              {friend.certificateDocumentNameDuringEdit !==
                                              "" ? (
                                                <span>
                                                  {
                                                    friend.certificateDocumentNameDuringEditName
                                                  }
                                                </span>
                                              ) : friend.certificateDocumentName ? (
                                                <span>
                                                  {
                                                    friend.certificateDocumentName
                                                  }
                                                </span>
                                              ) : (
                                                <span>
                                                  <span className="icon">
                                                    <i
                                                      className="fa fa-times-circle"
                                                      aria-hidden="true"
                                                    ></i>
                                                  </span>
                                                  <h4>No File Chosen</h4>
                                                </span>
                                              )}

                                              <div
                                                  style={{cursor:"not-allowed"}}
                                              >
                                                <a
                                                  href
                                                  style={{cursor:"not-allowed"}}
                                                  className="icon btn-file text-center"
                                                  
                                                >
                                                  <i
                                                      style={{cursor:"not-allowed"}}
                                                    className="fa fa-paperclip color_magento"
                                                    aria-hidden="true"
                                                  ></i>
                                                  {friend.documentSizeCheckForcertificate ? (
                                                    <p style={{ color: "red" }}>
                                                      File Size is too
                                                      large(Maximum File Size:
                                                      2MB).
                                                    </p>
                                                  ) : (
                                                    ""
                                                  )}
                                                  {friend.documentTypeCheckForCertificate ? (
                                                    <p style={{ color: "red" }}>
                                                      Invalid Format
                                                    </p>
                                                  ) : (
                                                    ""
                                                  )}
                                                  {/* <FileBase64
                                                    multiple={true}
                                                    name={`studentQualification.${index}.certificateUrl`}
                                                    onChange={handleChange}
                                                    onDone={(event) => {
                                                      const checkType = event[0].name.split(
                                                        "."
                                                      );
                                                      if (
                                                        [
                                                          "pdf",
                                                          "jpeg",
                                                          "png",
                                                          "jpg",
                                                        ].indexOf(
                                                          checkType[1]
                                                        ) < 0
                                                      ) {
                                                        setFieldValue(
                                                          (friend.documentTypeCheckForCertificate = true)
                                                        );
                                                      } else if (
                                                        event[0].file.size <=
                                                        2000000
                                                      ) {
                                                        setFieldValue(
                                                          (friend.certificate = {
                                                            documentHash:
                                                              event[0].base64,
                                                            documentType:
                                                              "CertificateDocument",
                                                            documentName:
                                                              event[0].name,
                                                          })
                                                        );
                                                        setFieldValue(
                                                          (friend.documentTypeCheckForCertificate = false)
                                                        );
                                                        setFieldValue(
                                                          (friend.documentSizeCheckForcertificate = false)
                                                        );
                                                        setFieldValue(
                                                          (friend.certificateDocumentName =
                                                            event[0].name)
                                                        );
                                                        setFieldValue(
                                                          (friend.certificateDocumentNameDuringEdit =
                                                            "")
                                                        );
                                                        setFieldValue(
                                                          (friend.downloadCertificateAfterSelecting =
                                                            event[0].base64)
                                                        );
                                                      } else {
                                                        setFieldValue(
                                                          (friend.documentSizeCheckForcertificate = true)
                                                        );
                                                      }
                                                    }}
                                                  /> */}
                                                </a>
                                              </div>
                                            </div>
                                            <div
                                              // onClick={
                                              //   ()=>{
                                              //     warning("You Dont Have Access To Edit the Profile ,Read Only",warningNotification)
                                              // }
                                              //   }
                                          
                                              className="profile-add"
                                              style={{
                                                textAlign: "center",
                                                padding: 0,
                                                cursor:"not-allowed"
                                              }}
                                            >
                                              <span
                                              //  onClick={
                                              //   ()=>{
                                              //     warning("You Dont Have Access To Edit the Profile ,Read Only",warningNotification)
                                              // }
                                                // }
                                                style={{cursor:"not-allowed"}}
                                              className="icon btn-file">
                                                {friend.downloadCertificateAfterSelecting ? (
                                                  <a
                                                    href
                                                    // href={
                                                    //   friend.downloadCertificateAfterSelecting
                                                    // }
                                                    style={{cursor:"not-allowed"}}
                                                    className="download"
                                                    // download={
                                                    //   friend.certificateDocumentName
                                                    // }
                                                  >
                                                    <i
                                                        style={{cursor:"not-allowed"}}
                                                      className="fa fa-download"
                                                      aria-hidden="true"
                                                    ></i>
                                                    <h4
                                                    style={{cursor:"not-allowed"}}
                                                    >Download</h4>
                                                  </a>
                                                ) : (
                                                    friend.certificateUrl || ""
                                                  ).includes("pdf") ? (
                                                  <a
                                                  href
                                                  style={{cursor:"not-allowed"}}
                                                    // href={friend.certificateUrl}
                                                    className="download"
                                                    // target="_blank"
                                                    rel="noopener noreferrer"
                                                  >
                                                    <i
                                                        style={{cursor:"not-allowed"}}
                                                      className="fa fa-download"
                                                      aria-hidden="true"
                                                    ></i>
                                                    <h4>Download</h4>
                                                  </a>
                                                ) : friend.certificateUrl ? (
                                                  <a
                                                  href
                                                  style={{cursor:"not-allowed"}}
                                                    // href={friend.certificateUrl}
                                                    className="download"
                                                  >
                                                    <i
                                                        style={{cursor:"not-allowed"}}
                                                      className="fa fa-download"
                                                      aria-hidden="true"
                                                    ></i>
                                                    <h4
                                                        style={{cursor:"not-allowed"}}
                                                    >Download</h4>
                                                  </a>
                                                ) : (
                                                  <span>
                                                    <i
                                                        style={{cursor:"not-allowed"}}
                                                      className="fa fa-download"
                                                      aria-hidden="true"
                                                    ></i>
                                                    <h4
                                                        style={{cursor:"not-allowed"}}
                                                    >Download</h4>
                                                  </span>
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                        </td>
                                        {/* <td
                                          style={{
                                            textAlign: "center",
                                            verticalAlign: "middle",
                                          }}
                                        > */}
                                          {/* {values.studentQualification.length <
                                          5 ? (
                                            <button
                                              type="button"
                                              className="btn-8 ml-5 mr-5 mt-10"
                                              // onClick={async () => {
                                              //   const curErrors = await formikProps.validateForm();
                                              //   if (
                                              //     curErrors.studentQualification
                                              //   ) {
                                              //     if (
                                              //       curErrors
                                              //         .studentQualification[
                                              //         index
                                              //       ]
                                              //     ) {
                                              //       const curErrorsKeys = Object.keys(
                                              //         curErrors
                                              //           .studentQualification[
                                              //           index
                                              //         ]
                                              //       );
                                              //       if (curErrorsKeys.length) {
                                              //         const el = document.getElementById(
                                              //           `studentQualification.${index}.${curErrorsKeys[0]}`
                                              //         );
                                              //         if (el) el.focus();
                                              //       }
                                              //     } else {
                                              //       arrayHelpers.push(
                                              //         qualification
                                              //       );
                                              //     }
                                              //   } else {
                                              //     arrayHelpers.push(
                                              //       qualification
                                              //     );
                                              //   }
                                              // }}
                                              onClick={
                                                ()=>{
                                                  warning("You Dont Have Access To Edit the Profile ,Read Only",warningNotification)
                                              }
                                                }
                                            >
                                              <i
                                                class="fa fa-plus"
                                                aria-hidden="true"
                                              ></i>
                                            </button>
                                          ) : (
                                            ""
                                          )}
                                          {values.studentQualification.length <=
                                          1 ? (
                                            ""
                                          ) : (
                                            <button
                                              type="button"
                                              className="btn-8 ml-5 mr-5 mt-10"
                                              // onClick={() => {
                                              //   arrayHelpers.remove(index);
                                              //   // values.studentQualification.splice(index,1);
                                              //   console.log(
                                              //     "vamsi",
                                              //     values.studentQualification
                                              //   );
                                              // }}
                                              onClick={
                                                ()=>{
                                                  warning("You Dont Have Access To Edit the Profile ,Read Only",warningNotification)
                                              }
                                                }
                                            >
                                              <i
                                                class="fa fa-minus"
                                                aria-hidden="true"
                                              ></i>
                                            </button>
                                          )} */}
                                        {/* </td> */}
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>
                          ) : (
                            <button
                              type="button"
                              style={{cursor:"not-allowed"}}
                              className="btn-4"
                              // onClick={() => arrayHelpers.push("")}
                              // onClick={
                              //   ()=>{
                              //     warning("You Dont Have Access To Edit the Profile ,Read Only",warningNotification)
                              // }
                              //   }
                            >
                              Add a Qualification
                            </button>
                          )}
                        </div>
                      )}
                    />
                  </div>
                </div>
              </div>
              <div className="row mb-10">
                <div class="col-md-4 col-sm-6 col-xs-12">
                <label>
                  HAVE YOU DONE ANY FINX/ CIEL/ CPBFI CERTIFICATION?
                    <span className="validation">
                      {" "}
                      *
                    </span>
                  </label>
                  <Field
                  disabled
                    as="select"
                    name="qualiCertiID"
                    id="qualiCertiID"
                    className="form-control "
                    onChange={handleChange}
                    style={{ border: "1px solid #fbc583" }}
                    value={this.state.qualiCertiID}
                  >
                    <option value="">Select Certificate</option>
                    {(values.certificateQualificationList || []).map(
                      (item) => (
                        <option
                          key={item.qualiCertiID}
                          value={item.qualiCertiID}
                        >
                          {item.qualiCertiName}
                        </option>
                      )
                    )}
                  </Field>
                <ErrorMessage
                name="qualiCertiID"
                className="validation "
                component="div"
              />
                </div>
                {[4,"4"].includes(this.state.qualiCertiID) && (
                  <div className=" col-md-4 col-sm-6 col-xs-12">
                    <label>
                    BFS ID
                      <span className="validation"> *</span>{" "}
                      <br/>
                      <br/>
                    </label>
                    <Field
                      type="text"
                      name="certiNumber"
                      id="certiNumber"
                      maxLength={50}
                      onChange={handleChange}
                      disabled
                      autoComplete="certiNumber"
                      style={{ border: "1px solid #fbc583" }}
                      className={
                        "form-control  " +
                        (errors.certiNumber &&
                        touched.certiNumber
                          ? " is-invalid"
                          : "")
                      }
                      placeholder="BFS ID"
                      
                    />
                    <ErrorMessage
                      name="certiNumber"
                      className="validation"
                      component="div"
                    />
                  </div>
                )}
                {[4,"4"].includes(this.state.qualiCertiID) && (
                  <div className=" col-md-4 col-sm-6 col-xs-12">
                    <label>
                    Batch Number
                      <span className="validation"> *</span>{" "}
                      <br/>
                      <br/>
                    </label>
                    <Field
                      type="text"
                      name="batchNumber"
                      id="batchNumber"
                      maxLength={50}
                      onChange={handleChange}
                      disabled
                      autoComplete="batchNumber"
                      style={{ border: "1px solid #fbc583" }}
                      className={
                        "form-control  " +
                        (errors.batchNumber &&
                        touched.batchNumber
                          ? " is-invalid"
                          : "")
                      }
                      placeholder="Batch Number"
                      
                    />
                    <ErrorMessage
                      name="batchNumber"
                      className="validation"
                      component="div"
                    />
                  </div>
                )}
              </div>
               <div className="row" style={{ marginBottom: "40px" }}>
                <div class="col-md-12 col-sm-12 col-xs-12">
                  <label>Any Regulatory Certification done?(NISM/IRDAI/Any Other)</label>
                  <div>
                    <span
                      className="mr-20"
                      style={{
                        display: "inline-flex",
                        alignItems: "flex-end",
                      }}
                    >
                      <Field
                      disabled
                        type="radio"
                        className={
                          "form-control " +
                          (errors.isNismCertified && touched.isNismCertified
                            ? " is-invalid "
                            : " ") +
                          "employement-radio-input mr-10"
                        }
                        onChange={() => {
                          setFieldValue("isNismCertified", "Y");
                        }}
                        name="isNismCertified"
                        value="Y"
                      title={values.isNismCertified}
                        id="isNismCertified"
                        defaultChecked={values.isNismCertified === "Y"}
                      />{" "}
                      Yes
                    </span>
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "flex-end",
                      }}
                    >
                      <Field
                      disabled
                        type="radio"
                        className={
                          "form-control " +
                          (errors.isNismCertified && touched.isNismCertified
                            ? " is-invalid "
                            : " ") +
                          "employement-radio-input mr-10"
                        }
                        onChange={() => {
                          setFieldValue("isNismCertified", "N");
                        }}
                        name="isNismCertified"
                        value="N"
                        id="isNismCertified"
                        defaultChecked={values.isNismCertified === "N"}
                      />{" "}
                      No
                    </span>
                  </div>
                  <ErrorMessage
                    name="isNismCertified"
                    className="validation "
                    component="div"
                  />
                  {/* <div className="validation">
                          {getErrorMessage(
                            errors.employmentDetails,
                            index,
                            "isCurrentCompany"
                            )}
                          </div> */}
                </div>

                {values.isNismCertified === "Y" && (
                  <div className=" col-md-4 col-sm-6 col-xs-12">
                    <label>
                      Name of the Exam
                      <span className="validation"> *</span>{" "}
                    </label>
                    <Field
                    disabled
                      type="text"
                      name="nismCertificateName"
                      title={values.nismCertificateName}
                      id="nismCertificateName"
                      maxLength={255}
                      onChange={handleChange}
                      autoComplete="nismCertificateName"
                      style={{ border: "1px solid #fbc583" }}
                      className={
                        "form-control  " +
                        (errors.nismCertificateName &&
                        touched.nismCertificateName
                          ? " is-invalid"
                          : "")
                      }
                      placeholder="Name of the Exam"
                      // style={{ border: "1px solid #fbc5b3"}}
                    />
                    <ErrorMessage
                      name="nismCertificateName"
                      className="validation"
                      component="div"
                    />
                  </div>
                )}

                {values.isNismCertified === "Y" && (
                  <div className=" col-md-4 col-sm-6 col-xs-12">
                    <label>
                    PAN/Registration Number
                      <span className="validation"> *</span>{" "}
                    </label>
                    <Field
                    disabled
                      type="text"
                      name="nismCertificateNumber"
                      id="nismCertificateNumber"
                      title={values.nismCertificateNumber}
                      onChange={handleChange}
                      autoComplete="nismCertificateNumber"
                      style={{ border: "1px solid #fbc583" }}
                      maxLength={255}
                      className={
                        "form-control " +
                        (errors.nismCertificateNumber &&
                        touched.nismCertificateNumber
                          ? " is-invalid"
                          : "")
                      }
                      placeholder="PAN/Registration Number"
                      // style={{ border: "1px solid #fbc5b3"}}
                    />
                    <ErrorMessage
                      name="nismCertificateNumber"
                      className="validation"
                      component="div"
                    />
                  </div>
                )}

                {values.isNismCertified === "Y" && (
                  <div className="col-md-4 col-sm-6 col-xs-12">
                    <label>
                      Date of Completion 
                      {/* <span className="validation"> *</span> */}
                    </label>
                    <Field
                    disabled
                      type="date"
                      name="nismCertificationDate"
                      id="nismCertificationDate"
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      style={{ border: "1px solid #fbc583" }}
                      value={values.nismCertificationDate}
                      title={values.nismCertificationDate}
                      placeholder="Event Start Date"
                      className={
                        "form-control " +
                        (errors.nismCertificationDate &&
                        touched.nismCertificationDate
                          ? " is-invalid"
                          : "")
                      }
                    />
                    <ErrorMessage
                      name="nismCertificationDate"
                      className="validation"
                      component="div"
                    />
                  </div>
                )}
              </div>

                       </section>       
                           
                            ))}
               {this.state.currentTab === 3&& (  
               <section
               
              //  style={{width:"50%"}}
               className="orange-border" id="create-qualification">
              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <h2 className="sub-header">Experience Details</h2>
                </div>
                 
                <div class="col-md-6 col-sm-6 col-xs-6">
                  <label>
                    Experience Type
                    <span className="validation"> *</span>
                  </label>
                  <div>
                    <span
                      className="mr-20"
                      style={{
                        display: "inline-flex",
                        alignItems: "flex-end",
                      }}
                    >
                      <Field
                        disabled
                        type="radio"
                        className={
                          "form-control " +
                          (errors.isFresher && touched.isFresher
                            ? " is-invalid "
                            : " ") +
                          "employement-radio-input mr-10"
                        }
                        onChange={() => {
                          //  setFieldValue("employmentDetails",[])
                          setFieldValue("employmentDetails", [
                            {
                              designation: "",
                              companyName: "",
                              joiningDate: "",
                              salaryCurrency: "",
                              annualSalary: "",
                              skill: "",
                              jobProfile: "",
                              noticePeriod: "",
                            },
                          ]);

                          setFieldValue("isFresher", "Y");
                        }}
                        name="isFresher"
                        value="Y"
                        id="isFresher"
                        defaultChecked={values.isFresher === "Y"}
                      />{" "}
                      Fresher
                    </span>
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "flex-end",
                      }}
                    >
                      <Field
                      disabled
                        type="radio"
                        className={
                          "form-control " +
                          (errors.isFresher && touched.isFresher
                            ? " is-invalid "
                            : " ") +
                          "employement-radio-input mr-10"
                        }
                        onChange={() => {
                          setFieldValue("isFresher", "N");

                          setFieldValue("isInternshipDone", "");
                          setFieldValue("internCompanyName", "");
                          setFieldValue("internJobProfile", "");
                          setFieldValue("tenure", "");
                        }}
                        name="isFresher"
                        value="N"
                        id="isFresher"
                        defaultChecked={values.isFresher === "N"}
                      />{" "}
                      Experienced
                    </span>
                  </div>
                  {/* <ErrorMessage
                          name="isFresher"
                          className="validation "
                          component="div"
                        /> */}
                  {/* <div className="validation">
                          {getErrorMessage(
                            errors.employmentDetails,
                            index,
                            "isCurrentCompany"
                            )}
                          </div> */}
                </div>
              </div>
              {values.isFresher === "N" && (
                                   <div className="row mb-10">
                                        <div class="col-md-4 col-sm-4 col-xs-12">
                                          <label>
                                            Total Experience
                                            <span className="validation">
                                              {" "}
                                              *
                                            </span>
                                          </label>
                                          <Field
                                          disabled
                                            as="select"
                                            name="experienceID"
                                            id="experienceID"
                                            className="form-control "
                                            onChange={handleChange}
                                            style={{ border: "1px solid #fbc583" }}
                                            value={values.experienceID}
                                          >
                                            <option value="">--SELECT--</option>
                                            {(values.totalExperienceList || []).map(
                                              (item) => (
                                                <option
                                                  key={item.experienceID}
                                                  value={item.experienceID}
                                                >
                                                  {item.experienceName}
                                                </option>
                                              )
                                            )}
                                          </Field>
                                        <ErrorMessage
                                        name="experienceID"
                                        className="validation "
                                        component="div"
                                      />
                                        </div>
                                      </div>
              )}

              {values.isFresher === "N" && (
                <div className="row">
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    {/* <h2 className="sub-header">

                  Experience Details
                </h2> */}
                    <div className="">
                      <FieldArray
                      disabled
                        name="employmentDetails"
                        onChange={handleChange}
                        render={(arrayHelpers) => (
                          <div>
                            {values.employmentDetails &&
                            values.employmentDetails.length > 0 ? (
                              <div>
                                {values.employmentDetails.map(
                                  (employmentDetail, index) => (
                                    <div className="create-user" key={index}>
                                      {/* <div className="orange-border" > */}
                                      <div className="row">
                                        <div class="col-md-4 col-sm-4 col-xs-12">
                                          <label>
                                            Type Of Job
                                            <span className="validation">
                                              {" "}
                                              *
                                            </span>
                                          </label>
                                          <Field
                                          disabled
                                            as="select"
                                            name={`employmentDetails.${index}.jobTypeId`}
                                            title={values.employmentDetails[index].jobTypeId}
                                            id={`employmentDetails.${index}.jobTypeId`}
                                            onChange={handleChange}
                                            value={employmentDetail.jobTypeId}
                                            className="form-control"
                                          >
                                            <option value="">--SELECT--</option>
                                            {(values.jobTypes || []).map(
                                              (item) => (
                                                <option
                                                  key={item.jobTypeId}
                                                  value={item.jobTypeId}
                                                >
                                                  {item.jobTypeName}
                                                </option>
                                              )
                                            )}
                                          </Field>
                                          {/* <div className="validation">
                                            {getErrorMessage(
                                              errors.employmentDetails,
                                              index,
                                              "jobTypeId"
                                            )}
                                          </div> */}
                                        </div>
                                      </div>

                                      <div class="row ">
                                        <div class="col-md-4 col-sm-4 col-xs-12">
                                          <label>
                                            Designation
                                            <span className="validation">
                                              {" "}
                                              *
                                            </span>
                                          </label>
                                          <Field
                                          disabled
                                            name={`employmentDetails.${index}.designation`}
                                            title={values.employmentDetails[index].designation}
                                            className="form-control"
                                            onChange={handleChange}
                                            maxLength={100}
                                            value={employmentDetail.designation}
                                            placeholder="Enter Designation"
                                            // style={{border:"1px solid #fbce97"}}
                                          />
                                          {/* <div className="validation">
                                            {getErrorMessage(
                                              errors.employmentDetails,
                                              index,
                                              "designation"
                                            )}
                                          </div> */}
                                        </div>
                                        <div class="col-md-4 col-sm-4 col-xs-12">
                                          <label>Company Name

                                          <span className="validation"> *</span>{" "}
                                          </label>
                                          <Field
                                          disabled
                                            name={`employmentDetails.${index}.companyName`}
                                            title={values.employmentDetails[index].companyName}
                                            className="form-control"
                                            maxLength={100}
                                            onChange={handleChange}
                                            value={employmentDetail.companyName}
                                            placeholder="Enter Company Name"
                                          />
                                          {/* <div className="validation">
                                            {getErrorMessage(
                                              errors.employmentDetails,
                                              index,
                                              "companyName"
                                            )}
                                          </div> */}
                                        </div>
                                        <div class="col-md-4 col-sm-4 col-xs-12">
                                          <label>
                                            Joining Date
                                            <span className="validation">
                                              {" "}
                                              *
                                            </span>
                                          </label>
                                          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr">
                                            <div className="col-md-5 col-lg-5 col-sm-5 col-xs-5 pl pr">
                                              <Field
                                              
                                                as="select"
                                                name={`employmentDetails.${index}.month`}
                                                onChange={handleChange}
                                                className={
                                                  "form-control" +
                                                  (errors.month && touched.month
                                                    ? "is-invalid"
                                                    : "")
                                                }
                                                // disabled={
                                                //   values.disabledForCielops
                                                // }
                                                disabled
                                              >
                                                <option value="">MM</option>
                                                {(values.listOfMonth || []).map(
                                                  (m) => (
                                                    <option
                                                      key={m.key}
                                                      value={m.key}
                                                    >
                                                      {m.value}
                                                    </option>
                                                  )
                                                )}
                                              </Field>
                                            </div>
                                            <div className="col-md-7 col-lg-7 col-sm-7 col-xs-7 pl pr">
                                              <Field
                                              disabled
                                                as="select"
                                                name={`employmentDetails.${index}.year`}
                                                onChange={handleChange}
                                                className="form-control"
                                              >
                                                <option value="">YYYY</option>
                                                {(
                                                  this.state.listOfYear2 || []
                                                ).map((year) => (
                                                  <option
                                                    key={year}
                                                    value={year}
                                                  >
                                                    {year}
                                                  </option>
                                                ))}
                                              </Field>
                                            </div>
                                          </div>
                                          {/* <div className="validation">
                                            {getErrorMessage(
                                              errors.employmentDetails,
                                              index,
                                              "month"
                                            )}
                                          </div>
                                          <div className="validation">
                                            {getErrorMessage(
                                              errors.employmentDetails,
                                              index,
                                              "year"
                                            )}
                                          </div> */}
                                        </div>
                                      </div>

                                      <div class="row">
                                        <div class="col-md-4 col-sm-4 col-xs-12">
                                          <label>
                                            Annual Salary
                                            <span className="validation">
                                              {" "}
                                              *
                                            </span>
                                          </label>
                                          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr">
                                            <div className="col-md-5 col-lg-5 col-sm-5 col-xs-5 pl pr">
                                              <Field
                                              disabled
                                                as="select"
                                                title={values.employmentDetails[index].salaryCurrency}
                                                name={`employmentDetails.${index}.salaryCurrency`}
                                                className="form-control"
                                                onChange={handleChange}
                                              >
                                                <option value="">
                                                  Select Currency
                                                </option>
                                                <option value="INR">
                                                  &#8377; INR
                                                </option>
                                                <option value="USD">
                                                  $ USD
                                                </option>
                                              </Field>
                                            </div>
                                            <div class="col-md-7 col-sm-7 col-xs-7 pl pr">
                                              <Field
                                              as="select"
                                              disabled
                                              title={values.employmentDetails[index].annualSalary}
                                                name={`employmentDetails.${index}.annualSalary`}
                                                className="form-control"
                                                onChange={handleChange}
                                                value={
                                                  employmentDetail.annualSalary
                                                }
                                                placeholder="Enter Salary"
                                              >
                                                <option value="">---Select---</option>
                                                {(values.annualSalaryList || []).map(
                                                  (item) => (
                                                    <option
                                                      key={item.salaryID}
                                                      value={item.salaryID}
                                                    >
                                                      {item.salaryRange}
                                                    </option>
                                                  )
                                                )}
                                              </Field>
                                            </div>
                                          </div>
                                          {/* <div className="validation">
                                            {getErrorMessage(
                                              errors.employmentDetails,
                                              index,
                                              "salaryCurrency"
                                            )}
                                          </div>
                                          <div className="validation">
                                            {getErrorMessage(
                                              errors.employmentDetails,
                                              index,
                                              "annualSalary"
                                            )}
                                          </div> */}
                                        </div>
                                        <div class="col-md-4 col-sm-4 col-xs-12">
                                          <label>
                                            Skill Used
                                            {/* <span className="validation">
                                              {" "}
                                              *
                                            </span> */}
                                          </label>
                                          <Field
                                          disabled
                                            name={`employmentDetails.${index}.skill`}
                                            title={values.employmentDetails[index].skill}
                                            className="form-control"
                                            onChange={handleChange}
                                            value={employmentDetail.skill}
                                            placeholder="Enter Skill Used"
                                          />
                                          {/* <div className="validation">
                                            {getErrorMessage(
                                              errors.employmentDetails,
                                              index,
                                              "skill"
                                            )}
                                          </div> */}
                                        </div>
                                        <div class="col-md-4 col-sm-4 col-xs-12">
                                          <label>Job Profile</label>
                                          <Field
                                          disabled
                                            name={`employmentDetails.${index}.jobProfile`}
                                            title={values.employmentDetails[index].jobProfile}
                                            as="textarea"
                                            className="form-control"
                                            onChange={handleChange}
                                            maxLength="100"
                                            value={employmentDetail.jobProfile}
                                            placeholder="Enter Job Profile"
                                          />
                                        </div>
                                      
                                      </div>

                                      <div class="row">
                                        
                                        <div class="col-md-4 col-sm-4 col-xs-12">
                                          <label>
                                            Is this your current company?
                                            <span className="validation">
                                              {" "}
                                              *
                                            </span>
                                          </label>
                                          <div>
                                            <span
                                              className="mr-20"
                                              style={{
                                                display: "inline-flex",
                                                alignItems: "flex-end",
                                              }}
                                            >
                                              <Field
                                              disabled
                                                type="radio"
                                                className="employement-radio-input mr-10"
                                                name={`employmentDetails.${index}.isCurrentCompany`}
                                                value="Y"
                                                defaultChecked={
                                                  employmentDetail.isCurrentCompany ===
                                                  "Y"
                                                }
                                              />{" "}
                                              Yes
                                            </span>
                                            <span
                                              style={{
                                                display: "inline-flex",
                                                alignItems: "flex-end",
                                              }}
                                            >
                                              <Field
                                                disabled
                                                type="radio"
                                                className="employement-radio-input mr-10"
                                                name={`employmentDetails.${index}.isCurrentCompany`}
                                                value="N"
                                                defaultChecked={
                                                  employmentDetail.isCurrentCompany !==
                                                  "Y"
                                                }
                                              />{" "}
                                              No
                                            </span>
                                          </div>
                                          {/* <div className="validation">
                                            {getErrorMessage(
                                              errors.employmentDetails,
                                              index,
                                              "isCurrentCompany"
                                            )}
                                          </div> */}
                                        </div>
                                        <div class="col-md-4 col-sm-4 col-xs-12">
                                          <label>Notice Period</label>
                                          <Field
                                          disabled
                                            as="select"
                                            name={`employmentDetails.${index}.noticePeriod`}
                                            title={values.employmentDetails[index].noticePeriod}
                                            className="form-control"
                                            onChange={handleChange}
                                          >
                                            <option value="">
                                              Select Notice Period
                                            </option>
                                            {/* <option value="15 Days or less">
                                              15 Days or less
                                            </option>
                                            <option value="1 Month">
                                              1 Month
                                            </option>
                                            <option value="2 Months">
                                              2 Months
                                            </option>
                                            <option value="3 Months">
                                              3 Months
                                            </option>
                                            <option value="More than 3 Months">
                                              More than 3 Months
                                            </option> */}
                                             {(values.noticePeriodList||[]).map((item)=>(
                                              <option
                                              key={item.noticePeriodID}
                                              value={item.noticePeriodID}
                                              >
                                            {item.noticePeriodName}
                                              </option>
                                            ))}
                                          
                                          </Field>
                                        </div>
                                        <div class="col-md-4 col-sm-4 col-xs-12">
                                          {/* <label>Add/Remove</label> */}
                                          <div>
                                            {/* {values.employmentDetails.length <
                                              3 &&
                                            index ===
                                              values.employmentDetails.length -
                                                1 ? (
                                              <button
                                                type="button"
                                                className="btn-8 ml-5 mr-5 mt-10"
                                                onClick={async () => {
                                                //   const curErrors = await formikProps.validateForm();
                                                //   if (
                                                //     curErrors.employmentDetails
                                                //   ) {
                                                //     if (
                                                //       curErrors
                                                //         .employmentDetails[
                                                //         index
                                                //       ]
                                                //     ) {
                                                //       const curErrorsKeys = Object.keys(
                                                //         curErrors
                                                //           .employmentDetails[
                                                //           index
                                                //         ]
                                                //       );
                                                //       if (
                                                //         curErrorsKeys.length
                                                //       ) {
                                                //         const el = document.getElementById(
                                                //           `employmentDetails.${index}.${curErrorsKeys[0]}`
                                                //         );
                                                //         if (el) el.focus();
                                                //       }
                                                //     } else {
                                                //       arrayHelpers.push(
                                                //         employment
                                                //       );
                                                //     }
                                                //   } else {
                                                //     arrayHelpers.push(
                                                //       employment
                                                //     );
                                                //   }
                                                warning("You Dont Have Access To Edit the Profile ,Read Only",warningNotification)
                                                }}
                                              >
                                                <i
                                                  class="fa fa-plus"
                                                  aria-hidden="true"
                                                ></i>
                                              </button>
                                            ) : (
                                              ""
                                            )}
                                            {values.employmentDetails.length <=
                                            1 ? (
                                              ""
                                            ) : (
                                              <button
                                                type="button"
                                                className="btn-8 ml-5 mr-5 mt-10"
                                                // onClick={() =>
                                                //   arrayHelpers.remove(index)
                                                // }
                                                onClick={
                                                  ()=>{
                                                    warning("You Dont Have Access To Edit the Profile ,Read Only",warningNotification)
                                                }
                                                  }
                                              >
                                                <i
                                                  class="fa fa-minus"
                                                  aria-hidden="true"
                                                ></i>
                                              </button>
                                            )} */}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )
                                )}
                              </div>
                            ) : (
                              <button
                                type="button"
                                className="btn-4"
                                // onClick={() => 
                                //   // arrayHelpers.push(employment)
                                //   warning("You Dont Have Access To Edit the Profile ,Read Only",warningNotification)
                                // }
                                style={{cursor:"not-allowed"}}
                              >
                                Add a Employment
                              </button>
                            )}
                          </div>
                        )}
                      />
                    </div>
                  </div>
                </div>
              )}

              {values.isFresher === "Y" && (
                <>
                <div className="row">
                  <div class="col-md-12 col-sm-12 col-xs-12">
                    <label>Have You done any Internship?</label>

                    <span className="validation"> *</span>

                    <div>
                      <span
                        className="mr-20"
                        style={{
                          display: "inline-flex",
                          alignItems: "flex-end",
                        }}
                      >
                        <Field
                        disabled
                          type="radio"
                          className={
                            "form-control " +
                            (errors.isInternshipDone && touched.isInternshipDone
                              ? " is-invalid "
                              : " ") +
                            "employement-radio-input mr-10"
                          }
                          onChange={() => {
                            setFieldValue("isInternshipDone", "Y");
                          }}
                          name="isInternshipDone"
                          value="Y"
                          id="isInternshipDone"
                          defaultChecked={values.isInternshipDone === "Y"}
                        />{" "}
                        Yes
                      </span>
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "flex-end",
                        }}
                      >
                        <Field
                         disabled
                          type="radio"
                          className={
                            "form-control " +
                            (errors.isInternshipDone && touched.isInternshipDone
                              ? " is-invalid "
                              : " ") +
                            "employement-radio-input mr-10"
                          }
                          onChange={() => {
                            setFieldValue("isInternshipDone", "N");
                            setFieldValue("internCompanyName", "");
                            setFieldValue("internJobProfile", "");
                            setFieldValue("tenure", "");
                          }}
                          name="isInternshipDone"
                          value="N"
                          id="isInternshipDone"
                          defaultChecked={values.isInternshipDone === "N"}
                        />{" "}
                        No
                      </span>
                    </div>
                    <ErrorMessage
                      name="isInternshipDone"
                      className="validation "
                      component="div"
                    />
                    {/* <div className="validation">
                          {getErrorMessage(
                            errors.employmentDetails,
                            index,
                            "isCurrentCompany"
                            )}
                          </div> */}
                  </div>

                  {values.isInternshipDone === "Y" && (
                    <div className=" col-md-4 col-sm-4 col-xs-12">
                      <label>
                        Company Name
                       
                      </label>
                      <Field
                      disabled
                        type="text"
                        title={values.internCompanyName}
                        name="internCompanyName"
                        id="internCompanyName"
                        onChange={handleChange}
                        maxLength={100}
                        style={{ border: "1px solid #fbc583" }}
                        autoComplete="internCompanyName"
                        className={
                          "form-control  " +
                          (errors.internCompanyName && touched.internCompanyName
                            ? " is-invalid"
                            : "")
                        }
                        placeholder="Company Name"
                        // style={{ border: "1px solid #fbc5b3"}}
                      />
                      <ErrorMessage
                        name="internCompanyName"
                        className="validation"
                        component="div"
                      />
                    </div>
                  )}

                  {values.isInternshipDone === "Y" && (
                    <>
                    <div className=" col-md-4 col-sm-4 col-xs-12">
                      <label>Tenure</label>
                      <Field
                      disabled
                        type="text"
                        name="tenure"
                        title={values.tenure}
                        id="tenure"
                      
                        maxLength={255}
                        onChange={handleChange}
                        style={{ border: "1px solid #fbc583" }}
                        autoComplete="tenure"
                        className={
                          "form-control " +
                          (errors.tenure && touched.tenure ? " is-invalid" : "")
                        }
                        placeholder="tenure"
                        // style={{ border: "1px solid #fbc5b3"}}
                      />
                      <ErrorMessage
                        name="tenure"
                        className="validation"
                        component="div"
                      />
                    </div>
                    <div className="col-md-4 col-sm-4 col-xs-12">
                      <label>Tenure From
                      <span className="validation"> *</span>
                      </label>
                      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr">
                        <div className="col-md-3 col-lg-3 col-sm-3 col-xs-3 pl pr">
                          <Field
                            disabled
                            style={{ border: "1px solid #fbc583" }}
                            as="select"
                            name="tenureFromDay"
                            id="tenureFromDay"
                            className="form-control"
                            title={values.tenureFromDay}
                            value={values.tenureFromDay}
                          >
                            <option value="">DD</option>
                            {(values.listOfTenureFromDay || []).map(
                              (d) => (
                                <option value={d}> {d} </option>
                              )
                            )}
                          </Field>
                        </div>
                        <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 pl pr">
                          <Field
                            disabled
                            style={{ border: "1px solid #fbc583" }}
                            as="select"
                            name="tenureFromMonth"
                            id="tenureFromMonth"
                            className="form-control"
                            title={values.tenureFromMonth}
                            value={values.tenureFromMonth}
                          >
                            <option value="">MM</option>
                            {(values.listOfTenureFromMonth || []).map(
                              (m) => (
                                <option value={m.key}>
                                  {m.value}
                                </option>
                              )
                            )}
                          </Field>
                        </div>
                        <div className="col-md-5 col-lg-5 col-sm-5 col-xs-5 pl pr">
                          <Field
                            disabled
                            style={{ border: "1px solid #fbc583" }}
                            as="select"
                            name="tenureFromYear"
                            id="tenureFromYear"
                            className="form-control"
                            title={values.tenureFromYear}
                            value={values.tenureFromYear}
                          >
                            <option value="">YYYY</option>
                            {(values.listOfTenureFromYear || []).map(
                              (year) => (
                                <option value={year}>
                                  {year}
                                </option>
                              )
                            )}
                          </Field>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-4 col-xs-12">
                      <label>Tenure To
                      <span className="validation"> *</span>
                      </label>
                      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr">
                        <div className="col-md-3 col-lg-3 col-sm-3 col-xs-3 pl pr">
                          <Field
                            disabled
                            style={{ border: "1px solid #fbc583" }}
                            as="select"
                            name="tenureToDay"
                            id="tenureToDay"
                            className="form-control"
                            title={values.tenureToDay}
                            value={values.tenureToDay}
                          >
                            <option value="">DD</option>
                            {(values.listOfTenureToDay || []).map(
                              (d) => (
                                <option value={d}> {d} </option>
                              )
                            )}
                          </Field>
                        </div>
                        <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 pl pr">
                          <Field
                            disabled
                            style={{ border: "1px solid #fbc583" }}
                            as="select"
                            name="tenureToMonth"
                            id="tenureToMonth"
                            className="form-control"
                            title={values.tenureToMonth}
                            value={values.tenureToMonth}
                          >
                            <option value="">MM</option>
                            {(values.listOfTenureToMonth || []).map(
                              (m) => (
                                <option value={m.key}>
                                  {m.value}
                                </option>
                              )
                            )}
                          </Field>
                        </div>
                        <div className="col-md-5 col-lg-5 col-sm-5 col-xs-5 pl pr">
                          <Field
                            disabled
                            style={{ border: "1px solid #fbc583" }}
                            as="select"
                            name="tenureToYear"
                            id="tenureToYear"
                            className="form-control"
                            title={values.tenureToYear}
                            value={values.tenureToYear}
                          >
                            <option value="">YYYY</option>
                            {(values.listOfTenureToYear || []).map(
                              (year) => (
                                <option value={year}>
                                  {year}
                                </option>
                              )
                            )}
                          </Field>
                        </div>
                      </div>
                    </div>
                    </>
                  )}

                  {values.isInternshipDone === "Y" && (
                    <div className="col-md-4 col-sm-6 col-xs-12">
                      <label>Job Profile / Project
                         {/* <span className="validation"> *</span> */}
                      </label>
                      <Field
                      disabled
                        as="textarea"
                        title={values.internJobProfile}
                        maxLength={100}
                        rows="3"
                        // cols="50"
                        name="internJobProfile"
                        id="internJobProfile"
                        style={{ border: "1px solid #fbc583" }}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        value={values.internJobProfile}
                        placeholder="Job Profile / Project"
                        className={
                          "form-control " +
                          (errors.internJobProfile && touched.internJobProfile
                            ? " is-invalid"
                            : "")
                        }
                      />
                      <ErrorMessage
                        name="internJobProfile"
                        className="validation"
                        component="div"
                      />
                    </div>
                  )}
                </div>
                <div className="row" style={{ marginBottom: "25px" }}>
                <div class="col-md-12 col-sm-12 col-xs-12">
                  <label>Are you available for Immediate Joining?</label>
                  <span className="validation"> *</span>
                  <div>
                    <span
                      className="mr-20"
                      style={{
                        display: "inline-flex",
                        alignItems: "flex-end",
                      }}
                    >
                      <Field
                        disabled
                        type="radio"
                        className="form-control employement-radio-input mr-10"
                        name="immediateJoining"
                        value="Y"
                        id="immediateJoining"
                        defaultChecked={values.immediateJoining === "Y"}
                      />{" "}
                      Yes
                    </span>
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "flex-end",
                      }}
                    >
                      <Field
                        disabled
                        type="radio"
                        className="form-control employement-radio-input mr-10"
                        name="immediateJoining"
                        value="N"
                        id="immediateJoining"
                        defaultChecked={values.immediateJoining === "N"}
                      />{" "}
                      No
                    </span>
                  </div>
                </div>
              </div>
              </>
              )}
              {/* <UserProfileNavigations
                {...this.props}
                handleNextTabClick={() => {
                  setFieldValue((values.nav = "NEXT"));
                  if (!values.isNextDisabled) {
                    handleSubmit();
                  }
                }}
                handlePreviousTabClick={() => {
                  setFieldValue((values.nav = "PREV"));
                  if (!values.isPreviousDisabled) {
                    handleSubmit();
                  }
                }}
                handleFinalSubmitBtnClick={handleSubmit}
              /> */}
            </section>
                            )}
           
                   {this.state.currentTab===4&&(
                 
                  <section className="orange-border">

                
                  <div className="row ">

                 
                  <div className="col-lg-12 col-md-12 col-sm-6 col-xs-12">
                    <h2 className="sub-header">Preferences</h2>
                  </div>
                  <div className="row">
                  </div>
                
                    <div
                    style={{cursor:"not-allowed"}}
                    className="col-md-4 col-sm-4 col-xs-12">
                      <label>Job Location <small>(at max 3 selection)</small>   <span className="validation"> *</span></label>
                      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr">

                        <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12 pl pr">
                          {/* <label>States <small>(at max 3 selection)</small></label> */}
                          {/* <Field
                              as="select"
                              name={`selectedStates`}
                              className="form-control"
                              onChange={(event) => {


                                var selectedStates = [];
                                for (var option of event.target.options) {
                                  if (option.selected) {
                                    selectedStates.push(option.value);
                                  }
                                }
                                var last_valid_selection = null;

                                if ($(this).val().length > 3) {

                                  $(this).val(last_valid_selection);
                                } else {
                                  last_valid_selection = $(this).val();
                                }
                                console.log(selectedStates)
                                LoginService.TokenUser((res) => {
                                  localStorage.setItem(
                                    "jwt-token",
                                    res.responseObject
                                  );
                                });
                                if (event.target.value !== undefined) {
                                  setFieldValue(values.selectedStates = selectedStates);
                                  var data = {
                                    stateIdList: selectedStates
                                  };
                                  console.log(data)
                                  RegionManagementService.getCities(
                                    // "states=" + JSON.stringify(selectedStates),
                                    data,
                                    (res) => {
                                      setFieldValue(
                                        (values.cityList =
                                          res.responseListObject)
                                      );
                                    }
                                  );
                                }
                              }}
                              multiple
                            >
                              <option value="" defaultValue disabled >Select State</option>
                              {(values.stateList || []).map(
                                (team) => (
                                  <option
                                    key={team.stateId}
                                    value={team.stateId}
                                  >
                                    {sentenceCase(team.stateName)}
                                  </option>
                                )
                              )}
                            </Field> */}
                          <Field
                            disabled
                            
                            name="selectedStates"
                            options={createOptions(values.stateList ? values.stateList : [], 'stateId', 'stateName')}
                            component={CustomSelect}
                            placeholder="Select States..."
                            isMulti={true}
                            handleCallback={() => {
                              if (values.selectedStates.length) {
                                LoginService.TokenUser((res) => {
                                  localStorage.setItem(
                                    "jwt-token",
                                    res.responseObject
                                  );
                                });
                                var data = {
                                  stateIdList: values.selectedStates
                                };
                                // console.log(JSON.stringify(data, null, 2))
                                RegionManagementService.getCities(
                                  data,
                                  (res) => {
                                    var cityOptionList = [];
                                    var responseList = res.responseListObject;
                                    responseList.forEach((city => {
                                      cityOptionList.push({ locationId: city.cityId, stateId: city.state.stateId, value: city.cityId, label: sentenceCase(city.cityName) })
                                    }))
                                    // console.log("cityOptionList : " + JSON.stringify(cityOptionList, null, 2))
                                    setFieldValue(values.cityList11 = cityOptionList);
                                  }
                                );
                              }
                            }}
                            error={errors.selectedStates}
                          />
                        </div>
                        <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12 pl pr">
                          {/* <label>Cities <small>(at max 3 selection)</small></label> */}
                          {/* <Field
                              as="select"
                              name={`selectedCities`}
                              className="form-control"
                              // onChange={handleChange}
                              onChange={(event) => {

                                var jobLocations = [];
                                var selectedCities = [];
                                for (var option of event.target.options) {
                                  if (option.selected) {
                                    selectedCities.push(option.value)
                                    jobLocations.push({ locationId: option.value, stateId: option.getAttribute('data-stateid') });
                                  }
                                }
                                if (event.target.value !== undefined) {
                                  setFieldValue(values.jobLocations = jobLocations);
                                  setFieldValue(values.selectedCities = selectedCities);
                                }
                              }}
                              multiple
                            >
                              <option value="" defaultValue disabled >Select City</option>
                              {(values.cityList || []).map(
                                (team) => (
                                  <option
                                    key={team.cityId}
                                    value={team.cityId}
                                    data-stateid={team.state.stateId}
                                  >
                                    {sentenceCase(team.cityName)}
                                  </option>
                                )
                              )}
                            </Field> */}
                          <Field
                          disabled
                        
                          // isDisabled={true}
                            name="selectedCities"
                            options={values.cityList11}
                            component={CustomSelect}
                            placeholder="Select Cities..."
                            isMulti={true}
                            error={errors.selectedCities}
                            handleCallback={(options, form) => {
                              var jobLocations = [];
                              options.forEach((op) => {
                                jobLocations.push({ locationId: op.locationId, stateId: op.stateId });
                              })
                              // console.log(JSON.stringify(jobLocations, null, 2))
                              form.setFieldValue('jobLocations', jobLocations)
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    {/* <div className="col-md-4 col-sm-4 col-xs-12">
                      <label>Roles / Designation <small>(at max 3 selection)</small></label> */}
                      {/* <Field
                          as="select"
                          name={`jobRoles`}
                          className="form-control"
                          onChange={handleChange}
                          multiple
                        >
                          <option value="" defaultValue disabled >---Select----</option>
                          {(values.jobRoleList || []).map(
                            (team) => (
                              <option
                                key={team.roleId}
                                value={team.roleId}
                              >
                                {sentenceCase(team.roleName)}
                              </option>
                            )
                          )}
                        </Field> */}
                      {/* <Field
                        name="jobRoles"
                        options={createOptions(values.jobRoleList, 'roleId', 'roleName')}
                        component={CustomSelect}
                        placeholder="Select Job Roles"
                        isMulti={true}
                        error={errors.jobRoles}
                      />
                    </div> */}

                    <div 
                    style={{cursor:"not-allowed"}}
                    className="col-md-4 col-sm-4 col-xs-12">
                      <label>Skill Proficiency <small>(at max 3 selection)</small></label>
                      {/* <Field
                          as="select"
                          name={`skillProficiency`}
                          className="form-control"
                          onChange={handleChange}
                          multiple
                        >
                          <option value="" defaultValue disabled >---Select----</option>
                          <option value="1">Advanced Excel</option>
                          <option value="2">Powerpoint</option>
                          <option value="3">Access</option>
                          <option value="4">Advance Content Writing</option>
                        </Field> */}
                         <Field
                        name="skillProficiency"
                        options={createOptions(values.jobKeyskillList, 'keySkillId', 'keyskill')}
                        component={CustomSelect}
                        placeholder="Select Skill Proficiency"
                        isMulti={true}
                        error={errors.skillProficiency}
                      />
                      {/* <Field
                      disabled
                        name="skillProficiency"
                        options={values.skillProficiencyList}
                        component={CustomSelect}
                        placeholder="Select Key Proficiency"
                        isMulti={true}
                        error={errors.skillProficiency}
                      /> */}
                    </div>
                    <div 
                    style={{cursor:"not-allowed"}}
                    className={values.interestAreas.length>3?"col-md-6 col-sm-6 col-xs-12":"col-md-4 col-sm-4 col-xs-12"}>
                      <label>Interest Areas <small>(at max 5 selection)</small></label>
                      {/* <Field
                          as="select"
                          name={`interestAreas`}
                          className="form-control"
                          onChange={handleChange}
                          multiple
                        >
                          <option value="" defaultValue disabled>---Select----</option>
                          {(values.jobInterestAreaList || []).map(
                            (team) => (
                              <option
                                key={team.interestAreaId}
                                value={team.interestAreaId}
                              >
                                {sentenceCase(team.interestArea)}
                              </option>
                            )
                          )}
                        </Field> */}
                      <Field
                      disabled
                        name="interestAreas"
                        options={createOptions(values.jobInterestAreaList, 'interestAreaId', 'interestArea')}
                        component={CustomSelect}
                        placeholder="Select Interest Areas"
                        isMulti={true}
                        error={errors.interestAreas}
                        onMouseEnter={this.handleMouseEnter}
                      />
                    </div>
                  </div>

                  <div className="row">

                    {/* <div className="col-md-4 col-sm-4 col-xs-12">
                      <label>Key Skill <small>(at max 5 selection)</small></label> */}
                      {/* <Field
                          as="select"
                          name={`keySkills`}
                          className="form-control"
                          onChange={handleChange}
                          multiple
                        >
                          <option value="" defaultValue disabled >---Select----</option>
                          {(values.jobKeyskillList || []).map(
                            (team) => (
                              <option
                                key={team.keySkillId}
                                value={team.keySkillId}
                              >
                                {sentenceCase(team.keyskill)}
                              </option>
                            )
                          )}
                        </Field> */}
                      {/* <Field
                        name="keySkills"
                        options={createOptions(values.jobKeyskillList, 'keySkillId', 'keyskill')}
                        component={CustomSelect}
                        placeholder="Select Key Skills"
                        isMulti={true}
                        error={errors.keySkills}
                      />
                    </div> */}

                    <div 
                    style={{cursor:"not-allowed"}}
                    className={values.preferredDomain.length>3?"col-md-6 col-sm-6 col-xs-12":"col-md-4 col-sm-4 col-xs-12"}>
                      <label>Preferred Domain <small>(at max 5 selection)</small></label>
                      {/* <Field
                          as="select"
                          name={`interestAreas`}
                          className="form-control"
                          onChange={handleChange}
                          multiple
                        >
                          <option value="" defaultValue disabled>---Select----</option>
                          {(values.jobInterestAreaList || []).map(
                            (team) => (
                              <option
                                key={team.interestAreaId}
                                value={team.interestAreaId}
                              >
                                {sentenceCase(team.interestArea)}
                              </option>
                            )
                          )}
                        </Field> */}
                      <Field
                      disabled
                        name="preferredDomain"
                       
                        id="preferredDomain"
                        options={createOptions(values.jobPreferredDomainList, 'domainID', 'domainName')}
                        component={CustomSelect}
                        placeholder="Select Preferred Domain"
                        isMulti={true}
                        error={errors.preferredDomain}
                        onMouseEnter={this.handleMouseEnter}
                      />
                    </div>
                  </div>

                  <div className="row">
                    {/* <div className="col-md-4 col-sm-4 col-xs-12">
                    </div> */}

                    <div className="col-md-12 col-sm-12 col-xs-12">
                      <section
                        className=""
                        id="create-qualification"
                      >
                        <div className="row">
                          <div className="col-md-8 col-lg-8 col-sm-12 col-xs-12">
                            <label>Language Proficiency</label>

                            <div className="">
                              <FieldArray
                              disabled
                                name="languageProficiency"
                                onChange={handleChange}
                                render={(arrayHelpers) => (
                                  <div>
                                    {values.languageProficiency && values.languageProficiency.length > 0 ? (
                                      <div className="table-row table-responsive">
                                        <table
                                          className="table table-bordered table-hover"
                                          id=""
                                        >
                                          <thead>
                                            <tr>
                                              <th className="text-center">
                                                Language
                                                <span className="validation"> *</span>
                                              </th>
                                              <th className="text-center">
                                                Proficiency<span className="validation"> *</span>
                                              </th>
                                              <th className="text-center">
                                                Read
                                              </th>
                                              <th className="text-center">
                                                Write
                                              </th>
                                              <th className="text-center">
                                                Speak
                                              </th>
                                              {/* <th className="text-center">
                                                Action
                                              </th> */}
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {values.languageProficiency.map(
                                              (friend, index) => (
                                                <tr key={index}>
                                                  <td>
                                                    <Field
                                                    disabled
                                                      name={`languageProficiency.${index}.language`}
                                                      title={values.languageProficiency[index].language}
                                                      className="form-control"
                                                      onChange={handleChange}
                                                      maxLength='50'
                                                      value={
                                                        friend.language
                                                      }
                                                    />
                                                    {/* <div className="validation">{getErrorMessage(errors.languageProficiency, index, 'language')}</div>
                                                    <div className="validation">
                                                      {getErrorMessage(errors.languageProficiency, index, 'read') ? getErrorMessage(errors.languageProficiency, index, 'read') : (getErrorMessage(errors.languageProficiency, index, 'write') ? getErrorMessage(errors.languageProficiency, index, 'write') : (getErrorMessage(errors.languageProficiency, index, 'speak') ? getErrorMessage(errors.languageProficiency, index, 'speak') : null))}
                                                    </div> */}
                                                  </td>
                                                  <td>
                                                    <Field
                                                    disabled
                                                      as="select"
                                                      name={`languageProficiency.${index}.proficiency`}
                                                      className="form-control"
                                                      onChange={handleChange}
                                                    >
                                                      <option value="" defaultValue >
                                                        -- Select --
                                                      </option>
                                                      <option value="Expert">
                                                        Expert
                                                      </option>
                                                      <option value="Proficient">
                                                        Proficient
                                                      </option>
                                                    </Field>
                                                    {/* <div className="validation">{getErrorMessage(errors.languageProficiency, index, 'proficiency')}</div> */}
                                                  </td>
                                                  <td style={{ width: "70px", textAlign: "center" }}>
                                                    <Field
                                                    disabled
                                                      type="checkbox"
                                                      name={`languageProficiency.${index}.read`}
                                                      className="preference-check-input"
                                                      onChange={(
                                                        event
                                                      ) => {
                                                        const flag = event.target.checked ? 'Y' : ''
                                                        setFieldValue((friend.read = flag));

                                                        // console.log((typeof friend.read === 'undefined' ? true : (friend.read === 'N'))
                                                        //   , (typeof friend.write === 'undefined' ? true : (friend.write === 'N'))
                                                        //   , (typeof friend.speak === 'undefined' ? true : (friend.speak === 'N')))
                                                        // console.log(friend.read, typeof friend.read, friend.write, typeof friend.write, friend.speak, typeof friend.speak)

                                                        if ((friend.read !== 'Y')
                                                          && (friend.write !== 'Y')
                                                          && (friend.speak !== 'Y')) {
                                                          // console.log('Inside False')
                                                          setFieldValue((friend.atLeastOneChecked = false));
                                                        } else {
                                                          setFieldValue((friend.atLeastOneChecked = true));

                                                        }

                                                      }}
                                                      checked={friend.read === 'Y'}
                                                    />
                                                    {/* <div className="validation">{getErrorMessage(errors.languageProficiency, index, 'read')}</div> */}
                                                  </td>
                                                  <td style={{ width: "70px", textAlign: "center" }}>
                                                    <Field
                                                    disabled
                                                      type="checkbox"
                                                      name={`languageProficiency.${index}.write`}
                                                      className="preference-check-input"
                                                      onChange={(
                                                        event
                                                      ) => {
                                                        const flag = event.target.checked ? 'Y' : ''
                                                        setFieldValue((friend.write = flag));

                                                        // console.log((typeof friend.read === 'undefined' ? true : (friend.read === 'N'))
                                                        //   , (typeof friend.write === 'undefined' ? true : (friend.write === 'N'))
                                                        //   , (typeof friend.speak === 'undefined' ? true : (friend.speak === 'N')))
                                                        // console.log(friend.read, typeof friend.read, friend.write, typeof friend.write, friend.speak, typeof friend.speak)
                                                        if ((friend.read !== 'Y')
                                                          && (friend.write !== 'Y')
                                                          && (friend.speak !== 'Y')) {
                                                          // console.log('Inside False')
                                                          setFieldValue((friend.atLeastOneChecked = false));
                                                        } else {
                                                          setFieldValue((friend.atLeastOneChecked = true));

                                                        }

                                                      }}
                                                      checked={friend.write === 'Y'}

                                                    />
                                                  </td>
                                                  <td style={{ width: "70px", textAlign: "center" }}>
                                                    <Field
                                                    disabled
                                                      type="checkbox"
                                                      name={`languageProficiency.${index}.speak`}
                                                      className="preference-check-input"
                                                      onChange={(
                                                        event
                                                      ) => {
                                                        const flag = event.target.checked ? 'Y' : ''
                                                        setFieldValue((friend.speak = flag));

                                                        // console.log((typeof friend.read === 'undefined' ? true : (friend.read === 'N'))
                                                        //   , (typeof friend.write === 'undefined' ? true : (friend.write === 'N'))
                                                        //   , (typeof friend.speak === 'undefined' ? true : (friend.speak === 'N')))
                                                        // console.log(friend.read, typeof friend.read, friend.write, typeof friend.write, friend.speak, typeof friend.speak)
                                                        if ((friend.read !== 'Y')
                                                          && (friend.write !== 'Y')
                                                          && (friend.speak !== 'Y')) {
                                                          // console.log('Inside False')
                                                          setFieldValue((friend.atLeastOneChecked = false));
                                                        } else {
                                                          setFieldValue((friend.atLeastOneChecked = true));

                                                        }

                                                      }}
                                                      checked={friend.speak === 'Y'}

                                                    />
                                                  </td>
                                                  {/* <td style={{ textAlign: "center" }}>
                                                    {
                                                      values.languageProficiency.length < 5 && (index === values.languageProficiency.length - 1) ? <button
                                                        disabled={friend.language ? (friend.language.trim() === '' ? true : false) : true}
                                                        type="button"
                                                        className="btn-8 ml-5 mr-5 mt-10"
                                                        onClick={async () => {
                                                          warning("You Dont Have Access To Edit the Profile ,Read Only",warningNotification)
                                                          // const curErrors = await formikProps.validateForm();
                                                          // if (curErrors.languageProficiency) {
                                                          //   if (curErrors.languageProficiency[index]) {
                                                          //     const curErrorsKeys = Object.keys(curErrors.languageProficiency[index]);
                                                          //     if (curErrorsKeys.length) {
                                                          //       const el = document.getElementById(`languageProficiency.${index}.${curErrorsKeys[0]}`);
                                                          //       if (el) el.focus();
                                                          //     }
                                                          //   } else {
                                                          //     arrayHelpers.push(languageObject)
                                                          //   }
                                                          // } else {
                                                          //   arrayHelpers.push(languageObject)
                                                          // }
                                                        }}
                                                      >
                                                        <i className="fa fa-plus" aria-hidden="true"></i>
                                                      </button>
                                                        : ""
                                                    }
                                                    {
                                                      values.languageProficiency.length <= 1 ? "" :
                                                        <button
                                                          type="button"
                                                          className="btn-8 ml-5 mr-5 mt-10"
                                                          // onClick={() => arrayHelpers.remove(index)}
                                                          onClick={
                                                            ()=>{
                                                              warning("You Dont Have Access To Edit the Profile ,Read Only",warningNotification)
                                                          }
                                                            }
                                                        >
                                                          <i className="fa fa-minus" aria-hidden="true"></i>
                                                        </button>
                                                    }
                                                  </td> */}
                                                </tr>
                                              )
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    ) : (
                                      <button
                                        type="button"
                                        style={{cursor:"not-allowed"}}
                                        className="btn-4"
                                        // onClick={() =>
                                        //   //  arrayHelpers.push(languageObject)
                                        //   warning("You Dont Have Access To Edit the Profile ,Read Only",warningNotification)
                                        //   }
                                      >
                                        Add Language Proficiency
                                      </button>
                                    )}
                                  </div>
                                )}
                              />
                            </div>
                          </div>
                          <div className="col-md-4 col-lg-4 col-sm-12 col-xs-12">
                            <div className="row">
                              {/* <div className="col-md-12 col-sm-12 col-xs-12">
                                <label>Job Related Notification</label>
                                <Field
                                  as="select"
                                  name={`jobRelatedNotification`}
                                  className="form-control"
                                  onChange={handleChange}
                                >
                                  <option value="" defaultValue disabled>---Select----</option>
                                  {(values.jobNotificationList || []).map(
                                    (team) => (
                                      <option
                                        key={team.notificationId}
                                        value={team.notificationId}
                                      >
                                        {sentenceCase(team.triggers)}
                                      </option>
                                    )
                                  )}
                                </Field>
                              </div>
                              <div className="col-md-12 col-sm-12 col-xs-12">
                                <label>Course Related Notification</label>
                                <Field
                                  as="select"
                                  name={`courseRelatedNotification`}
                                  className="form-control"
                                  onChange={handleChange}
                                >
                                  <option value="" defaultValue disabled>---Select----</option>
                                  {(values.courseNotificationList || []).map(
                                    (team) => (
                                      <option
                                        key={team.notificationId}
                                        value={team.notificationId}
                                      >
                                        {sentenceCase(team.triggers)}
                                      </option>
                                    )
                                  )}
                                </Field>
                              </div> */}
                            </div>
                          </div>
                          {/* <div className="col-md-2 col-lg-2 col-sm-12 col-xs-12"> */}
                          {/* </div> */}
                        </div>
                      </section>
                    </div>

                    {/* <div className="col-md-12 col-sm-12 col-xs-12">
                      <label>Other Prefrence</label>
                      <div className="row"> */}
                        {/* <div className="col-md-1 col-lg-1 col-sm-12 col-xs-12">
                      </div> */}
                        {/* <div className="col-md-8 col-lg-8 col-sm-12 col-xs-12">
                          <div>
                            {values.otherPreference && values.otherPreference.length > 0 ? (
                              <div className="table-row table-responsive">
                                <table
                                  className="table table-bordered table-hover"
                                  id=""
                                >
                                  <thead>
                                    <tr>
                                      <th className="text-center" colSpan={4} style={{ verticalAlign: "middle" }}>
                                        Preference
                                      </th>
                                      <th className="text-center" colSpan={2}>
                                        Check if Yes
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {values.otherPreference.map(
                                      (friend, index) => (
                                        <tr key={index}>
                                          <td colSpan={4}>
                                            <label >{friend.preferenceDesc}</label>
                                          </td>
                                          <td style={{ width: "70px", textAlign: "center", verticalAlign: "middle" }}>
                                            <Field
                                              type="checkbox"
                                              name={`languageProficiency.${index}.preferenceReply`}
                                              className="preference-check-input"
                                              onChange={(
                                                event
                                              ) => {
                                                const flag = event.target.checked ? 'Y' : 'N'
                                                setFieldValue((friend.preferenceReply = flag));
                                              }}
                                              checked={friend.preferenceReply === 'Y'}
                                            />
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            ) : (
                              ""
                            )}
                          </div> */}

                          {/* <div style={{ display: "flex", alignItems: "flex-end" }}>
                          <span className="mr-20" style={{ width: "50%" }}>
                            <label >Do you have a 2-wheeler?</label>
                          </span>
                          <span>
                            <span className="mr-20" style={{ display: "inline-flex", alignItems: "flex-end" }}>
                              <Field onChange={handleChange} type="radio" className="employement-radio-input mr-10" name="twoWheeler" value="Y" defaultChecked={values.twoWheeler == 'Y'} /> Yes
                            </span>
                            <span style={{ display: "inline-flex", alignItems: "flex-end" }}>
                              <Field onChange={handleChange} type="radio" className="employement-radio-input mr-10" name="twoWheeler" value="N" defaultChecked={values.twoWheeler != 'Y'} /> No
                            </span>
                          </span>
                        </div>
                        <div style={{ display: "flex", alignItems: "flex-end" }}>
                          <span className="mr-20" style={{ width: "50%" }}>
                            <label >Do you have a valid passport?</label>
                          </span>
                          <span>
                            <span className="mr-20" style={{ display: "inline-flex", alignItems: "flex-end" }}>
                              <Field onChange={handleChange} type="radio" className="employement-radio-input mr-10" name="validPassport" value="Y" defaultChecked={values.validPassport == 'Y'} /> Yes
                            </span>
                            <span style={{ display: "inline-flex", alignItems: "flex-end" }}>
                              <Field onChange={handleChange} type="radio" className="employement-radio-input mr-10" name="validPassport" value="N" defaultChecked={values.validPassport != 'Y'} /> No
                            </span>
                          </span>
                        </div>
                        <div style={{ display: "flex", alignItems: "flex-end" }}>
                          <span className="mr-20" style={{ width: "50%" }}>
                            <label >Are you willing to travel locally for the job?</label>
                          </span>
                          <span>
                            <span className="mr-20" style={{ display: "inline-flex", alignItems: "flex-end" }}>
                              <Field onChange={handleChange} type="radio" className="employement-radio-input mr-10" name="willingTravel" value="Y" defaultChecked={values.willingTravel == 'Y'} /> Yes
                            </span>
                            <span style={{ display: "inline-flex", alignItems: "flex-end" }}>
                              <Field onChange={handleChange} type="radio" className="employement-radio-input mr-10" name="willingTravel" value="N" defaultChecked={values.willingTravel != 'Y'} /> No
                            </span>
                          </span>
                        </div>
                        <div style={{ display: "flex", alignItems: "flex-end" }}>
                          <span className="mr-20" style={{ width: "50%" }}>
                            <label >Are you willing to relocate to another location?</label>
                          </span>
                          <span>
                            <span className="mr-20" style={{ display: "inline-flex", alignItems: "flex-end" }}>
                              <Field onChange={handleChange} type="radio" className="employement-radio-input mr-10" name="willingRelocate" value="Y" defaultChecked={values.willingRelocate == 'Y'} /> Yes
                            </span>
                            <span style={{ display: "inline-flex", alignItems: "flex-end" }}>
                              <Field onChange={handleChange} type="radio" className="employement-radio-input mr-10" name="willingRelocate" value="N" defaultChecked={values.willingRelocate != 'Y'} /> No
                            </span>
                          </span>
                        </div> */}
                        {/* </div>
                        <div className="col-md-4 col-lg-4 col-sm-12 col-xs-12">
                        </div>
                      </div> */}

                      {/* <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                      <button onClick={async () => {
                        console.log("Clicked");
                        const curErrors = await formikProps.validateForm();
                        const curErrorsKeys = Object.keys(curErrors);
                        console.log(JSON.stringify(curErrorsKeys, null, 2))
                        if (curErrorsKeys.length) {
                          const el = document.getElementById(
                            curErrorsKeys[0]
                          );
                          if (el) el.focus();
                        } else {

                        }
                      }} type="button" className="btn-2">Submit</button>
                      <hr />
                    </div> */}
                      {/* <pre>
                        {JSON.stringify(values, null, 2)}
                      </pre> */}
                      {/* <pre>
                        {JSON.stringify(values.languageProficiency, null, 2)}
                      </pre>
                      <pre>
                        {JSON.stringify(errors, null, 2)}
                      </pre> */}

                    {/* </div> */}

                  </div>

                  {/* <UserProfileNavigations {...this.props}
                    handleNextTabClick={async () => {
                      const curErrors = await formikProps.validateForm();
                      const curErrorsKeys = Object.keys(curErrors);
                      if (curErrorsKeys.length) {
                        const el = document.getElementById(
                          curErrorsKeys[0]
                        );
                        if (el) el.focus();
                      } else {
                        setFieldValue(values.nav = 'NEXT')
                        if(!values.isNextDisabled){
                        handleSubmit()
                        }
                      }
                    }}
                    handlePreviousTabClick={async () => {
                      const curErrors = await formikProps.validateForm();
                      const curErrorsKeys = Object.keys(curErrors);
                      if (curErrorsKeys.length) {
                        const el = document.getElementById(
                          curErrorsKeys[0]
                        );
                        if (el) el.focus();
                      } else {
                        setFieldValue(values.nav = 'PREV')
                        if(!values.isPreviousDisabled){
                        handleSubmit()
                        }
                      }
                    }} /> */}
                      </section>
       
                            )
                            }
                   {this.state.currentTab === 5&& (
                            this.state.show && (
                          //     <section
                          //       className="create-profile page-section"
                          //       id="create-profile"
                          //     >
                          //       <h2 className="sub-header">Resume Details</h2>
                          //       <div className="form-group">
                          //         <div className="row">
                          //         <div className="col-md-6 col-sm-6 col-xs-12">
                          //             <label>Upload Text Resume</label>
                          //             <div className="text-resume">
                          //               <h3>Select File To Upload</h3>
                          //             </div>
                          //             <div className="Resume profile-add text-center">
                          //               {values.resumeDocumentNameDuringEdit !==
                          //                 "" ? (
                          //                 <span>
                          //                   {
                          //                     values.resumeDocumentNameDuringEditName
                          //                   }
                          //                 </span>
                          //               ) : values.resumeDocumentName ? (
                          //                 <span>
                          //                   {values.resumeDocumentName}
                          //                 </span>
                          //               ) : (
                          //                 <span>
                          //                   <span className="icon">
                          //                     <i
                          //                       className="fa fa-times-circle"
                          //                       aria-hidden="true"
                          //                     ></i>
                          //                   </span>
                          //                   <h4>No File Chosen</h4>
                          //                 </span>
                          //               )}
                          //               <div
                          //                  onClick={
                          //                   ()=>{
                          //                     warning("You Dont Have Access To Edit the Profile ,Read Only",warningNotification)
                          //                 }
                          //                   }
                          //               >
                          //                 <span className="icon btn-file text-center">
                          //                   <i
                          //                     className="fa fa-paperclip color_magento"
                          //                     aria-hidden="true"
                          //                   ></i>
                          //                   {values.documentSizeCheckForResume ? (
                          //                     <p style={{ color: "red" }}>
                          //                       File Size is too large(Maximum
                          //                       File Size:2MB).
                          //                     </p>
                          //                   ) : (
                          //                     ""
                          //                   )}
                          //                   {values.documentTypeCheckForResume ? (
                          //                     <p style={{ color: "red" }}>
                          //                       Invalid Format
                          //                     </p>
                          //                   ) : (
                          //                     ""
                          //                   )}
                          //                   {/* <FileBase64
                                            
                          //                     multiple={true}
                          //                     name="resumeDocumentURL"
                          //                     onChange={handleChange}
                          //                     onDone={(event) => {
                          //                       const checkType =
                          //                         event[0].name.split(".");
                          //                       if (
                          //                         [
                          //                           "pdf",
                          //                           "docx",
                          //                           "rtf",
                          //                           "doc",
                          //                         ].indexOf(checkType[1]) < 0
                          //                       ) {
                          //                         setFieldValue(
                          //                           (values.documentTypeCheckForResume = true)
                          //                         );
                          //                       } else if (
                          //                         event[0].file.size <= 2000000
                          //                       ) {
                          //                         values.document.push({
                          //                           documentHash:
                          //                             event[0].base64,
                          //                           documentType:
                          //                             "ResumeDocument",
                          //                           documentName: event[0].name,
                          //                         });
                          //                         setFieldValue(
                          //                           (values.documentTypeCheckForResume = false)
                          //                         );
                          //                         setFieldValue(
                          //                           (values.documentSizeCheckForResume = false)
                          //                         );
                          //                         setFieldValue(
                          //                           (values.resumeDocumentName =
                          //                             event[0].name)
                          //                         );
                          //                         setFieldValue(
                          //                           (values.resumeDocumentNameDuringEdit =
                          //                             "")
                          //                         );
                          //                         setFieldValue(
                          //                           (values.downloadResumeAfterSelecting =
                          //                             event[0].base64)
                          //                         );
                          //                       } else {
                          //                         setFieldValue(
                          //                           (values.documentSizeCheckForResume = true)
                          //                         );
                          //                       }
                          //                     }}
                          //                     disabled
                          //                   /> */}

                          //                   {/* <a
                          //                 href={values.resumeDocumentURL}
                          //                 className="fa fa-download"
                          //               >
                          //                 Download
                          //               </a> */}
                          //                 </span>
                          //               </div>
                          //             </div>
                          //             <div className="hidden-md hidden-lg hidden-sm col-xs-12">
                          //               <div
                          //                onClick={
                          //                 ()=>{
                          //                   warning("You Dont Have Access To Edit the Profile ,Read Only",warningNotification)
                          //               }
                          //                 }
                          //               className="profile-add">
                          //                 <a className="icon btn-file" href="#">
                          //                   {values.downloadResumeAfterSelecting ? (
                          //                     <a
                          //                       href={
                          //                         values.downloadResumeAfterSelecting
                          //                       }
                          //                       className="download"
                          //                       download={
                          //                         values.resumeDocumentName
                          //                       }
                          //                     >
                          //                       <i
                          //                         className="fa fa-download"
                          //                         aria-hidden="true"
                          //                       ></i>
                          //                       <h4> Download Resume </h4>
                          //                     </a>
                          //                   ) : (
                          //                     values.resumeDocumentURL || ""
                          //                   ).includes("pdf") ? (
                          //                     <a
                          //                       href={values.resumeDocumentURL}
                          //                       className="download"
                          //                       target="_blank"
                          //                       rel="noopener noreferrer"
                          //                     >
                          //                       <i
                          //                         className="fa fa-download"
                          //                         aria-hidden="true"
                          //                       ></i>
                          //                       <h4> Download Resume </h4>
                          //                     </a>
                          //                   ) : values.resumeDocumentURL ? (
                          //                     <a
                          //                       href={values.resumeDocumentURL}
                          //                       className="download"
                          //                     >
                          //                       <i
                          //                         className="fa fa-download"
                          //                         aria-hidden="true"
                          //                       ></i>
                          //                       <h4> Download Resume </h4>
                          //                     </a>
                          //                   ) : (
                          //                     <span>
                          //                       <i
                          //                         className="fa fa-download"
                          //                         aria-hidden="true"
                          //                       ></i>
                          //                       <h4> Download Resume </h4>
                          //                     </span>
                          //                   )}
                          //                 </a>
                          //                 <div className="col-md-12 col-sm-12">
                          //                   <span class="file-size-limit">
                          //                     Supported Formats: .docx, .pdf,
                          //                     .rtf only. <br />
                          //                     File Size: Max 5 MB
                          //                   </span>
                          //                 </div>
                          //               </div>
                          //             </div>
                          //           </div>
                          //           <div className="col-md-6 col-sm-6 col-xs-12">
                          //             <label>Upload Video Resume</label>
                          //             <div className="profile-detail">
                          //               <div className="circle">
                          //                 <div className="profile-pic">
                          //                   <div className="profile">
                          //                     <ReactPlayer
                          //                       width="100%"
                          //                       height="90"
                          //                       url={values.resumeVideoURL}
                          //                       playing={false}
                          //                       controls
                          //                     ></ReactPlayer>
                          //                   </div>
                          //                 </div>
                          //               </div>
                          //             </div>
                          //             <div className="hidden-md hidden-lg hidden-sm col-xs-12">
                          //               <div
                          //                  onClick={
                          //                   ()=>{
                          //                     warning("You Dont Have Access To Edit the Profile ,Read Only",warningNotification)
                          //                 }
                          //                   }
                          //               className="profile-add">
                          //                 <span className="icon btn-file text-center">
                          //                   <i
                          //                     className="fa fa-plus-circle"
                          //                     aria-hidden="true"
                          //                   ></i>
                          //                   {/* <FileBase64
                                            
                          //                     multiple={true}
                          //                     name="resumeVideoURL"
                          //                     onChange={handleChange}
                          //                     onDone={(event) => {
                          //                       if (
                          //                         [
                          //                           "video/mp4",
                          //                           "video/avi",
                          //                           "video/mpeg",
                          //                         ].indexOf(event[0].type) < 0
                          //                       ) {
                          //                         setFieldValue(
                          //                           (values.documentTypeCheckForVideo = true)
                          //                         );
                          //                       } else if (
                          //                         event[0].file.size <= 10000000
                          //                       ) {
                          //                         values.document.push({
                          //                           documentHash:
                          //                             event[0].base64,
                          //                           documentType: "VideoResume",
                          //                           documentName: event[0].name,
                          //                         });
                          //                         setFieldValue(
                          //                           (values.documentTypeCheckForVideo = false)
                          //                         );
                          //                         setFieldValue(
                          //                           (values.documentSizeCheckForVideoCheck = false)
                          //                         );
                          //                         setFieldValue(
                          //                           (values.resumeVideoURL =
                          //                             event[0].base64)
                          //                         );
                          //                       } else {
                          //                         setFieldValue(
                          //                           (values.documentSizeCheckForVideoCheck = true)
                          //                         );
                          //                       }
                          //                     }}
                          //                     disabled
                          //                   /> */}
                          //                 </span>
                          //                 <h4>Add Video</h4>
                          //                 {/* <span className="icon">
                          //                   <i
                          //                     className="fa fa-times-circle"
                          //                     aria-hidden="true"
                          //                   ></i>
                          //                 </span>
                          //                 <h4>Remove Video</h4> */}
                          //                 {values.documentSizeCheckForVideoCheck ? (
                          //                   <p style={{ color: "red" }}>
                          //                     File Size is too large(Maximum
                          //                     File Size:10MB).
                          //                   </p>
                          //                 ) : (
                          //                   ""
                          //                 )}
                          //                 {values.documentTypeCheckForVideo ? (
                          //                   <p style={{ color: "red" }}>
                          //                     Invalid Format
                          //                   </p>
                          //                 ) : (
                          //                   ""
                          //                 )}
                          //                 <div className="col-md-12 col-sm-12">
                          //                   <span class="file-size-limit">
                          //                     Supported Formats: .mp4, .avi,
                          //                     .mpeg only. <br />
                          //                     File Size: Max 10 MB
                          //                   </span>
                          //                 </div>
                          //               </div>
                          //             </div>
                          //           </div>
                          //         </div>
                          //         <div className="row">
                          //          <div className="col-md-6 col-sm-6 hidden-xs">
                          //             <div
                                      
                                      
                          //             className="profile-add">
                          //               <a className="icon btn-file">
                          //                 {values.downloadResumeAfterSelecting ? (
                          //                   <a
                          //                     href={
                          //                       values.downloadResumeAfterSelecting
                          //                     }
                          //                     className="download"
                          //                     download={
                          //                       values.resumeDocumentName
                          //                     }
                          //                   >
                          //                     <i
                          //                       className="fa fa-download"
                          //                       aria-hidden="true"
                          //                     ></i>
                          //                     <h4> Download Resume </h4>
                          //                   </a>
                          //                 ) : (
                          //                   values.resumeDocumentURL || ""
                          //                 ).includes("pdf") ? (
                          //                   <a
                          //                     href={values.resumeDocumentURL}
                          //                     className="download"
                          //                     target="_blank"
                          //                   >
                          //                     <i
                          //                       className="fa fa-download"
                          //                       aria-hidden="true"
                          //                     ></i>
                          //                     <h4> Download Resume </h4>
                          //                   </a>
                          //                 ) : values.resumeDocumentURL ? (
                          //                   <a
                          //                     href={values.resumeDocumentURL}
                          //                     className="download"
                          //                   >
                          //                     <i
                          //                       className="fa fa-download"
                          //                       aria-hidden="true"
                          //                     ></i>
                          //                     <h4> Download Resume </h4>
                          //                   </a>
                          //                 ) : (
                          //                   <span>
                          //                     <i
                          //                       className="fa fa-download"
                          //                       aria-hidden="true"
                          //                     ></i>
                          //                     <h4> Download Resume </h4>
                          //                   </span>
                          //                 )}
                          //               </a>
                          //               <div className="col-md-12 col-sm-12">
                          //                 <span class="file-size-limit">
                          //                   Supported Formats: .docx, .pdf, .rtf
                          //                   only. <br />
                          //                   File Size: Max 5 MB
                          //                 </span>
                          //               </div>
                          //             </div>
                          //           </div>
                          //           <div className="col-md-6 col-sm-6 hidden-xs">
                          //             <div
                          //              onClick={
                          //               ()=>{
                          //                 warning("You Dont Have Access To Edit the Profile ,Read Only",warningNotification)
                          //             }
                          //               }
                          //             className="profile-add">
                          //               <span className="icon btn-file text-center">
                          //                 <i
                          //                   className="fa fa-plus-circle"
                          //                   aria-hidden="true"
                          //                 ></i>
                          //                 {/* <FileBase64
                          //                   multiple={true}
                          //                   name="resumeVideoURL"
                          //                   onChange={handleChange}
                          //                   onDone={(event) => {
                          //                     if (
                          //                       [
                          //                         "video/mp4",
                          //                         "video/avi",
                          //                         "video/mpeg",
                          //                       ].indexOf(event[0].type) < 0
                          //                     ) {
                          //                       setFieldValue(
                          //                         (values.documentTypeCheckForVideo = true)
                          //                       );
                          //                     } else if (
                          //                       event[0].file.size <= 10000000
                          //                     ) {
                          //                       values.document.push({
                          //                         documentHash: event[0].base64,
                          //                         documentType: "VideoResume",
                          //                         documentName: event[0].name,
                          //                       });
                          //                       setFieldValue(
                          //                         (values.documentTypeCheckForVideo = false)
                          //                       );
                          //                       setFieldValue(
                          //                         (values.documentSizeCheckForVideoCheck = false)
                          //                       );
                          //                       setFieldValue(
                          //                         (values.resumeVideoURL =
                          //                           event[0].base64)
                          //                       );
                          //                     } else {
                          //                       setFieldValue(
                          //                         (values.documentSizeCheckForVideoCheck = true)
                          //                       );
                          //                     }
                          //                   }}
                          //                   disabled
                          //                 /> */}
                          //               </span>
                          //               <h4>Add Video</h4>
                          //               {/* <span className="icon">
                          //                   <i
                          //                     className="fa fa-times-circle"
                          //                     aria-hidden="true"
                          //                   ></i>
                          //                 </span>
                          //                 <h4>Remove Video</h4> */}
                          //               {values.documentSizeCheckForVideoCheck ? (
                          //                 <p style={{ color: "red" }}>
                          //                   File Size is too large(Maximum File
                          //                   Size:10MB).
                          //                 </p>
                          //               ) : (
                          //                 ""
                          //               )}
                          //               {values.documentTypeCheckForVideo ? (
                          //                 <p style={{ color: "red" }}>
                          //                   Invalid Format
                          //                 </p>
                          //               ) : (
                          //                 ""
                          //               )}
                          //               <div className="col-md-12 col-sm-12">
                          //                 <span class="file-size-limit">
                          //                   Supported Formats: .mp4, .avi, .mpeg
                          //                   only. <br />
                          //                   File Size: Max 10 MB
                          //                 </span>
                          //               </div>
                          //             </div>
                          //           </div>
                          //         </div>
                          //       </div>
                          //       <div className="row">
                          //       <span className="icon btn-file col-md-6 col-sm-12 col-xs-12 col-lg-6">
                          //   {values.downloadVideoResumeAfterSelecting ? (
                          //     <a
                          //       // href={values.downloadVideoResumeAfterSelecting}
                          //       // // onClick={this.handleDownload}
                          //       // className="download"
                          //       // download={values.resumeVideoName}
                          //       onClick={()=>{this.handleWatermark(this.state.resumeVideoURL)}}
                          //     >
                          //       <i
                          //         className="fa fa-download"
                          //         aria-hidden="true"
                          //       ></i>

                          //       <h4> Download </h4>
                          //     </a>
                          //   ) : (values.resumeVideoURL || "").includes([
                          //       ".mp4",
                          //       ".avi",
                          //       ".mpeg",
                          //     ]) ? (
                          //     <a
                          //       // onClick={this.handleDownload}
                          //       // download={values.resumeVideoName}
                          //       onClick={()=>{this.handleWatermark(this.state.resumeVideoURL)}}
                          //       // href={values.resumeVideoURL}
                          //       // className="download"
                          //       // target="_blank"
                          //       rel="noopener noreferrer"
                          //     >
                          //       <i
                          //         className="fa fa-download"
                          //         aria-hidden="true"
                          //       ></i>
                          //       <h4> Download</h4>
                          //     </a>
                          //   ) : values.resumeVideoURL ? (
                          //     <a
                          //       // onClick={this.handleDownload}
                          //       // href={values.resumeVideoURL}
                          //       onClick={()=>{this.handleWatermark(this.state.resumeVideoURL)}}
                          //       // className="download"
                          //     >
                          //       <i
                          //         className="fa fa-download"
                          //         aria-hidden="true"
                          //       ></i>
                          //       <h4> Download</h4>
                          //     </a>
                          //   ) : (
                          //   ""
                          //   )}
                          // </span>
                          // {/* </span> */}
                
                          //       </div>
                          //     </section>
                            
                          <section className="orange-border" id="">
                          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <h2 className="sub-header">Resume Details</h2>
                          </div>
                          <div className="form-group">
                            <div className="row">
                              <div className="col-md-2 col-sm-2 col-xs-12"></div>
                              {/* <div className="col-md-4 col-sm-4 col-xs-12">
                                <label>Upload Profile Image</label>
                                <div className="profile-detail">
                                  <div className="circle">
                                    <img
                                      className="profile-pic"
                                      src={values.profilePhotoURL}
                                    />
                                    <div className="profile">
                                      <i
                                        className="fa fa-user"
                                        aria-hidden="true"
                                      ></i>
                                    </div>
                                  </div>
                                </div>
                                <div className="hidden-md hidden-lg hidden-sm col-xs-12">
                                  <div className="profile-add">
                                    <a className="icon btn-file">
                                      <i
                                        className="fa fa-plus-circle"
                                        aria-hidden="true"
                                      ></i>
                                      <FileBase64
                                        multiple={true}
                                        onChange={handleChange}
                                        onDone={(event) => {
                                          if (
                                            [
                                              "image/jpg",
                                              "image/jpeg",
                                              "image/png",
                                            ].indexOf(event[0].type) < 0
                                          ) {
                                            setFieldValue(
                                              (values.documentTypeCheckForProfileImage = true)
                                            );
                                          } else if (
                                            event[0].file.size <= 5000000
                                          ) {
                                            values.document.push({
                                              documentHash: event[0].base64,
                                              documentType: "ProfilePhoto",
                                              documentName: event[0].name,
                                            });
                                            setFieldValue(
                                              (values.documentTypeCheckForProfileImage = false)
                                            );
                                            setFieldValue(
                                              (values.documentSizeCheckForProfileCheck = false)
                                            );
                                            values.profilePhotoURL =
                                              event[0].base64;
                                            setFieldValue(
                                              (values.profilePhotoURL =
                                                event[0].base64)
                                            );
                                          } else {
                                            setFieldValue(
                                              (values.documentSizeCheckForProfileCheck = true)
                                            );
                                          }
                                        }}
                                      />
                                    </a>
                                    <a>
                                      {" "}
                                      <h4>Add Image</h4>
                                    </a>
                                    <div className="col-md-12 col-sm-12">
                                      <span className="file-size-limit">
                                        Supported Formats: .jpg, .jpeg, .png
                                        only. <br />
                                        File Size: Max 5 MB
                                      </span>
                                    </div>
                                    {values.documentSizeCheckForProfileCheck ? (
                                      <p style={{ color: "red" }}>
                                        File Size is too large(Maximum File
                                        Size:5MB).
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                    {values.documentTypeCheckForProfileImage ? (
                                      <p style={{ color: "red" }}>
                                        Invalid image format
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                              </div> */}
                                  <div className="col-md-4 col-sm-4 col-xs-12">
                                <label>Upload Text Resume
                                  <span className="validation"> *</span>
                                </label>
                                <div className="text-resume">
                                  <h3>Select File To Upload</h3>
                                </div>
                                <div 
                                 style={{cursor:"not-allowed"}}
                                  // onClick={
                                  //   ()=>{
                                  //     warning("You Dont Have Access To Edit the Profile ,Read Only",warningNotification)
                                  // }
                                  //   }
                                className="Resume profile-add text-center">
                                  {values.resumeDocumentNameDuringEdit !== "" ? (
                                    <span>{values.resumeDocumentNameDuringEditName}</span>
                                  ) : values.resumeDocumentName ? (
                                    <span>{values.resumeDocumentName}</span>
                                  ) : (
                                    <span>
                                      <span className="icon">
                                        <i
                                            style={{cursor:"not-allowed"}}
                                          className="fa fa-times-circle"
                                          aria-hidden="true"
                                        ></i>
                                      </span>
                                      <h4>No File Chosen</h4>
                                    </span>
                                  )}
          
                                  <div>
                                    <a href className="icon btn-file text-center">
                                      <i
                                          style={{cursor:"not-allowed"}}
                                        className="fa fa-paperclip color_magento"
                                        aria-hidden="true"
                                      ></i>
                                      {values.documentSizeCheckForResume ? (
                                        <p style={{ color: "red" }}>
                                          File Size is too large(Maximum File Size:2MB).
                                        </p>
                                      ) : (
                                        ""
                                      )}
                                      {values.documentTypeCheckForResume ? (
                                        <p style={{ color: "red" }}>Invalid Format</p>
                                      ) : (
                                        ""
                                      )}
                                      {/* <FileBase64
                                        multiple={true}
                                        name="resumeDocumentURL"
                                        onChange={handleChange}
                                        onDone={(event) => {
                                          const checkType = event[0].name.split(".");
                                          if (
                                            ["pdf", "docx", "rtf", "doc"].indexOf(
                                              checkType[1]
                                            ) < 0
                                          ) {
                                            setFieldValue(
                                              (values.documentTypeCheckForResume = true)
                                            );
                                          } else if (event[0].file.size <= 2000000) {
                                            values.document.push({
                                              documentHash: event[0].base64,
                                              documentType: "ResumeDocument",
                                              documentName: event[0].name,
                                            });
                                            setFieldValue(
                                              (values.documentTypeCheckForResume = false)
                                            );
                                            setFieldValue(
                                              (values.documentSizeCheckForResume = false)
                                            );
                                            setFieldValue(
                                              (values.resumeDocumentName = event[0].name)
                                            );
                                            setFieldValue(
                                              (values.resumeDocumentNameDuringEdit = "")
                                            );
                                            setFieldValue(
                                              (values.downloadResumeAfterSelecting =
                                                event[0].base64)
                                            );
                                          } else {
                                            setFieldValue(
                                              (values.documentSizeCheckForResume = true)
                                            );
                                          }
                                        }}
                                      /> */}
                                    </a>
                                  </div>
                                </div>
                                <div className="hidden-md hidden-lg hidden-sm col-xs-12">
                                  <div 
                                    
                                  className="profile-add">
                                    <span className="icon btn-file">
                                      {values.downloadResumeAfterSelecting ? (
                                        <a
                                        href
                                          // href={values.downloadResumeAfterSelecting}
                                          className="download"
                                          // download={values.resumeDocumentName}
                                          onClick={()=>{
                                            this.handleWatermarkPDF()
                                          }}
                                        >
                                          <i
                                            className="fa fa-download"
                                            aria-hidden="true"
                                          ></i>
                                          <h4> Download Resume </h4>
                                        </a>
                                      ) : (values.resumeDocumentURL || "").includes(
                                          "pdf"
                                        ) ? (
                                        <a
                                          href
                                          // href={values.resumeDocumentURL}
                                          onClick={()=>{
                                            this.handleWatermarkPDF()
                                          }}
                                          className="download"
                                          // target="_blank"
                                          // rel="noopener noreferrer"
                                        >
                                          <i
                                            className="fa fa-download"
                                            aria-hidden="true"
                                          ></i>
                                          <h4> Download Resume </h4>
                                        </a>
                                      ) : values.resumeDocumentURL ? (
                                        <a
                                          href
                                          // href={values.resumeDocumentURL}
                                          onClick={()=>{
                                            this.handleWatermarkPDF()
                                          }}
                                          className="download"
                                        >
                                          <i
                                            className="fa fa-download"
                                            aria-hidden="true"
                                          ></i>
                                          <h4> Download Resume </h4>
                                        </a>
                                      ) : (
                                        <span>
                                          <i
                                            className="fa fa-download"
                                            aria-hidden="true"
                                          ></i>
                                          <h4> Download Resume </h4>
                                        </span>
                                      )}
                                    </span>
                                    <div className="col-md-12 col-sm-12">
                                      <span className="file-size-limit">
                                        {/* Supported Formats: .doc,.docx, .pdf, .rtf only. */}
                                        Supported Formats:.pdf only.
                                        File Size: Max 2 MB
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            
                              <div className="col-md-4 col-sm-4 col-xs-12">
                                <label>Upload Video Resume</label>
                                <div className="profile-detail">
                                  <div className="circle">
                                    <div className="profile-pic">
                                      <div className="profile">
                                        <ReactPlayer
                                          ref={(player) => {
                                            this.player = player;
                                          }}        
                                          width="100%"
                                          height="90"
                                          url={values.resumeVideoURL}
                                          playing={false}
                                          controls
                                        ></ReactPlayer>             
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="hidden-md hidden-lg hidden-sm col-xs-12">
                                  <div
                                  
                                  className="profile-add">
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 pl pr" style={{padding:"0px"}}>
                                    <span 
                                     style={{cursor:"not-allowed"}}
                                    //  onClick={
                                    //   ()=>{
                                    //     warning("You Dont Have Access To Edit the Profile ,Read Only",warningNotification)
                                    // }
                                    //   } 
                                    className="icon btn-file text-center">
                                      <i
                                          style={{cursor:"not-allowed"}}
                                        className="fa fa-plus-circle"
                                        aria-hidden="true"
                                      ></i>
                                      {/* <FileBase64
                                        multiple={true}
                                        name="resumeVideoURL"
                                        onChange={handleChange}
                                        onDone={(event) => {
                                          console.log(
                                    JSON.stringify(event, null, 2),
                                            event[0].type,
                                            [
                                              "video/mp4",
                                              "video/avi",
                                              "video/mpeg",
                                              "video/x-msvideo",
                                            ].indexOf(event[0].type)
                                          );
                                          if (
                                            [
                                              "video/mp4",
                                              "video/avi",
                                              "video/mpeg",
                                              "video/x-msvideo",
                                            ].indexOf(event[0].type) < 0
                                          ) {
                                            setFieldValue(
                                              (values.documentTypeCheckForVideo = true)
                                            );
                                          } else if (event[0].file.size <= 2000000) {
                                            values.document.push({
                                              documentHash: event[0].base64,
                                              documentType: "VideoResume",
                                              documentName: event[0].name,
                                            });
                                            setFieldValue(
                                              (values.documentTypeCheckForVideo = false)
                                            );
                                            setFieldValue(
                                              (values.documentSizeCheckForVideoCheck = false)
                                            );
                                            setFieldValue(
                                              (values.resumeVideoName = event[0].name)
                                            );
                                            setFieldValue(
                                              (values.resumeVideoURL = event[0].base64)
                                            );
          
                                            setFieldValue(
                                              (values.downloadVideoResumeAfterSelecting =
                                                event[0].base64)
                                            );
                                          } else {
                                            setFieldValue(
                                              (values.documentSizeCheckForVideoCheck = true)
                                            );
                                          }
                                        }}
                                      /> */}
                                    </span>
                                    <h4
                                     style={{cursor:"not-allowed"}}
                                    //  onClick={
                                    //   ()=>{
                                    //     warning("You Dont Have Access To Edit the Profile ,Read Only",warningNotification)
                                    // }
                                    //   } 
                                    >Add Video</h4>
          </div>
                                    {/* <span className="icon">
                                                      <i
                                                        className="fa fa-times-circle"
                                                        aria-hidden="true"
                                                      ></i>
                                                    </span>
                                                    <h4>Remove Video</h4> */}
                                    {values.documentSizeCheckForVideoCheck ? (
                                      <p style={{ color: "red" }}>
                                        File Size is too large(Maximum File Size:4MB).
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                  <div style={{padding:"0px"}} className="col-lg-12 col-md-12 col-sm-12 col-xs-12 pl pr">
                                    <span 
                                     style={{cursor:"not-allowed",padding:"0px"}}
                                    //  onClick={
                                    //   ()=>{
                                    //     warning("You Dont Have Access To Edit the Profile ,Read Only",warningNotification)
                                    // }
                                    //   } 
                                    className="icon btn-file">
                                      <a
                                        href
                                        // href={sampleResumeVideo}
                                        className="download"
                                        // download={sampleResumeVideo}
                                      >
                                        <i
                                            style={{cursor:"not-allowed"}}
                                          className="fa fa-download"
                                          aria-hidden="true"
                                        ></i>
          
                                        <h4     style={{cursor:"not-allowed"}}> Sample Video </h4>
                                      </a>
                                    </span>
                                    </div>
                                    <div style={{padding:"0px"}} className="col-lg-12 col-md-12 col-sm-12 col-xs-12 pl pr">
                                    <span className="icon btn-file" style={{padding:"0px"}}>
                                      
                                      {values.downloadVideoResumeAfterSelecting ? (
                                    
                                        <a
                                          href={values.downloadVideoResumeAfterSelecting}
                                          // onClick={this.handleDownload}
                                          onClick={()=>{this.handleWatermark(this.state.resumeVideoURL)}}
           
                                        
                                        
                                          className="download"
                                          download={values.resumeVideoName}
                                        >
                                          <i
                                            className="fa fa-download"
                                            aria-hidden="true"
                                          ></i>
                                          <h4> Download</h4>
                                        
                                        </a>
                                    
                                      ) : (values.resumeVideoURL || "").includes([
                                          ".mp4",
                                          ".avi",
                                          ".mpeg",
                                        ]) ? (
                                         
                                        <a
                                        href
                                        onClick={()=>{this.handleWatermark(this.state.resumeVideoURL)}}
                                          // href={values.resumeVideoURL}
                                          // className="download"
                                          // target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          <i
                                            className="fa fa-download"
                                            aria-hidden="true"
                                          ></i>
                                          <h4> Download</h4>                               
                                        
                                        </a>
                                  
                                      ) : values.resumeVideoURL ? (
                                      
                                        <a
                                          href
                                          // onClick={this.handleDownload}
                                          // href={values.resumeVideoURL}
                                          // target="_blank"
                                          // className="download"
                                          onClick={()=>{this.handleWatermark(this.state.resumeVideoURL)}}
                                        >
                                          <i
                                            className="fa fa-download"
                                            aria-hidden="true"
                                          ></i>
                                          <h4> Download</h4>
                                         
                                        </a>
                                     
                                      ) : (
                                        <span>
                                          <i
                                            className="fa fa-download"
                                            onClick={()=>{this.handleWatermark(this.state.resumeVideoURL)}}
                                            aria-hidden="true"
                                          ></i>
                                          <h4> Download</h4>
                                        </span>
                                      )}
                                    </span>
                                    </div>
                                    {values.documentTypeCheckForVideo ? (
                                      <p style={{ color: "red" }}>Invalid Format</p>
                                    ) : (
                                      ""
                                    )}
                                    <div className="col-md-12 col-sm-12">
                                      <span class="file-size-limit">
                                        Supported Formats: .mp4, .avi, .mpeg only. File
                                        Size: Max 4 MB
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            <div className="col-md-2 col-sm-2 col-xs-12"></div>
                            </div>
                            <div className="row">
                              <div className="col-md-2 col-sm-2 hidden-xs"></div>
                              {/* <div className="col-md-4 col-sm-4 hidden-xs">
                                <div className="profile-add">
                                  <a className="icon btn-file">
                                    <i
                                      className="fa fa-plus-circle"
                                      aria-hidden="true"
                                    ></i>
                                    <FileBase64
                                      multiple={true}
                                      onChange={handleChange}
                                      onDone={(event) => {
                                        if (
                                          [
                                            "image/jpg",
                                            "image/jpeg",
                                            "image/png",
                                          ].indexOf(event[0].type) < 0
                                        ) {
                                          setFieldValue(
                                            (values.documentTypeCheckForProfileImage = true)
                                          );
                                        } else if (
                                          event[0].file.size <= 5000000
                                        ) {
                                          values.document.push({
                                            documentHash: event[0].base64,
                                            documentType: "ProfilePhoto",
                                            documentName: event[0].name,
                                          });
                                          setFieldValue(
                                            (values.documentTypeCheckForProfileImage = false)
                                          );
                                          setFieldValue(
                                            (values.documentSizeCheckForProfileCheck = false)
                                          );
                                          values.profilePhotoURL =
                                            event[0].base64;
                                          setFieldValue(
                                            (values.profilePhotoURL =
                                              event[0].base64)
                                          );
                                        } else {
                                          setFieldValue(
                                            (values.documentSizeCheckForProfileCheck = true)
                                          );
                                        }
                                      }}
                                    />
                                  </a>
                                  <a>
                                    {" "}
                                    <h4>Add Image</h4>
                                  </a>
                                  <div className="col-md-12 col-sm-12">
                                    <span className="file-size-limit">
                                      Supported Formats: .jpg, .jpeg, .png
                                      only. <br />
                                      File Size: Max 5 MB
                                    </span>
                                  </div>
                                  {values.documentSizeCheckForProfileCheck ? (
                                    <p style={{ color: "red" }}>
                                      File Size is too large(Maximum File
                                      Size:5MB).
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                  {values.documentTypeCheckForProfileImage ? (
                                    <p style={{ color: "red" }}>
                                      Invalid image format
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div> */}
                         
                              <div className="col-md-4 col-sm-4 hidden-xs">
                                <div
                                 
                                className="profile-add">
                                  <span className="icon btn-file">
                                    {values.downloadResumeAfterSelecting ? (
                                      <a
                                        href
                                        // href={values.downloadResumeAfterSelecting}
                                        className="download"
                                        // onClick={this.handleResumeDocDownload}
                                        // download={values.resumeDocumentName}
                                        onClick={()=>{
                                          this.handleWatermarkPDF()
                                        }}
                                      >
                                        <i
                                          className="fa fa-download"
                                          aria-hidden="true"
                                        ></i>
                                        <h4> Download Resume </h4>
                                      </a>
                                    ) : (values.resumeDocumentURL || "").includes(
                                        "pdf"
                                      ) ? (
                                      <a
                                        href
                                        // href={values.resumeDocumentURL}
                                        className="download"
                                        // target="_blank"
                                        // onClick={this.handleResumeDocDownload}
                                        onClick={()=>{
                                          this.handleWatermarkPDF()
                                        }}
                                        // rel="noopener noreferrer"
                                      >
                                        <i
                                          className="fa fa-download"
                                          aria-hidden="true"
                                        ></i>
                                        <h4> Download Resume </h4>
                                      </a>
                                    ) : values.resumeDocumentURL ? (
                                      <a
                                        href
                                        // href={values.resumeDocumentURL}
                                        onClick={()=>{
                                          this.handleWatermarkPDF()
                                        }}
                                        // onClick={this.handleResumeDocDownload}
                                        className="download"
                                      >
                                        <i
                                          className="fa fa-download"
                                          aria-hidden="true"
                                        ></i>
                                        <h4> Download Resume </h4>
                                      </a>
                                    ) : (
                                      ""
                                    )}
                                  </span>
                                  <div className="col-md-12 col-sm-12">
                                    <span className="file-size-limit">
                                      {/* Supported Formats: .doc,.docx, .pdf, .rtf only. File
                                      Size: Max 2 MB */}
                                      Supported Formats.pdf  only. File
                                      Size: Max 2 MB
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-4 col-sm-4 hidden-xs">
                                <div 
                               
                              
                                className="profile-add">
                                  <div style={{padding:"0px"}} className="col-lg-12 col-md-12 col-sm-12 col-xs-12 pl pr">
                                  <span 
                                   style={{cursor:"not-allowed"}}
                                  //  onClick={
                                  //   ()=>{
                                  //     warning("You Dont Have Access To Edit the Profile ,Read Only",warningNotification)
                                  // }
                                  //   } 
                                  className="icon btn-file text-center">
                                    <i
                                        style={{cursor:"not-allowed"}}
                                      className="fa fa-plus-circle"
                                      aria-hidden="true"
                                    ></i>
                                    {/* <FileBase64
                                      multiple={true}
                                      name="resumeVideoURL"
                                      onChange={handleChange}
                                      onDone={(event) => {
                                        if (
                                          [
                                            "video/mp4",
                                            "video/avi",
                                            "video/mpeg",
                                            "video/x-msvideo",
                                          ].indexOf(event[0].type) < 0
                                        ) {
                                          setFieldValue(
                                            (values.documentTypeCheckForVideo = true)
                                          );
                                        } else if (event[0].file.size <= 2000000) {
                                          values.document.push({
                                            documentHash: event[0].base64,
                                            documentType: "VideoResume",
                                            documentName: event[0].name,
                                          });
                                          setFieldValue(
                                            (values.documentTypeCheckForVideo = false)
                                          );
                                          setFieldValue(
                                            (values.documentSizeCheckForVideoCheck = false)
                                          );
                                          setFieldValue(
                                            (values.resumeVideoURL = event[0].base64)
                                          );
                                          setFieldValue(
                                            (values.resumeVideoName = event[0].name)
                                          );
                                          setFieldValue(
                                            (values.downloadVideoResumeAfterSelecting =
                                              event[0].base64)
                                          );
                                        } else {
                                          setFieldValue(
                                            (values.documentSizeCheckForVideoCheck = true)
                                          );
                                        }
                                      }}
                                    /> */}
                                  </span>
          
                                  <h4
                                  //  onClick={
                                  //   ()=>{
                                  //     warning("You Dont Have Access To Edit the Profile ,Read Only",warningNotification)
                                  // }
                                  //   } 
                                  style={{cursor:"not-allowed"}}
                                  
                                  >Add Video</h4>
          </div>
                                  {/* <span className="icon">
                                                      <i
                                                        className="fa fa-times-circle"
                                                        aria-hidden="true"
                                                      ></i>
                                                    </span>
                                                    <h4>Remove Video</h4> */}
                                                    <div  className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{padding:"0px"}}>
                                  {values.documentSizeCheckForVideoCheck ? (
                                    <p style={{ color: "red" }}>
                                      File Size is too large(Maximum File Size 4MB).
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                  {values.documentTypeCheckForVideo ? (
                                    <p style={{ color: "red" }}>Invalid Format</p>
                                  ) : (
                                    ""
                                  )}
                                  <div style={{padding:"0px"}} className="col-lg-12 col-md-12 col-sm-12 col-xs-12 pl pr">
                                    {/* <span className=""> */}
          
                                    <span 
                                     style={{cursor:"not-allowed",padding:"0px"}}
                                    //  onClick={
                                    //   ()=>{
                                    //     warning("You Dont Have Access To Edit the Profile ,Read Only",warningNotification)
                                    // }
                                    //   } 
                                    className="icon btn-file col-md-12 col-sm-12 col-xs-12 col-lg-12 pl pr">
                                      <a
                                        href
                                        // href={sampleResumeVideo}
                                        className="download"
                                        // download={sampleResumeVideo}
                                      >
                                        <i
                                            style={{cursor:"not-allowed"}}
                                          className="fa fa-download"
                                          aria-hidden="true"
                                        ></i>
          
                                        <h4     style={{cursor:"not-allowed"}}> Sample Video </h4>
                                      </a>
                                    </span>
                                    </div>
                                    <div style={{padding:"0px"}} className="col-lg-12 col-md-12 col-sm-12 col-xs-12 pl pr">
                                    {/* </span>
                                      <span className="col-md-6 col-sm-12 col-xs-12 col-lg-6"> */}
          
          <span style={{padding:"0px"}} className="icon btn-file col-md-12 col-sm-12 col-xs-12 col-lg-12">
                                      {values.downloadVideoResumeAfterSelecting ? (
                                        <a
                                          href
                                          // href={values.downloadVideoResumeAfterSelecting}
                                          // // onClick={this.handleDownload}
                                          // className="download"
                                          // download={values.resumeVideoName}
                                          onClick={()=>{this.handleWatermark(this.state.resumeVideoURL)}}
                                        >
                                          <i
                                            className="fa fa-download"
                                            aria-hidden="true"
                                          ></i>
          
                                          <h4> Download </h4>
                                        </a>
                                      ) : (values.resumeVideoURL || "").includes([
                                          ".mp4",
                                          ".avi",
                                          ".mpeg",
                                        ]) ? (
                                        <a
                                          href
                                          // onClick={this.handleDownload}
                                          // download={values.resumeVideoName}
                                          onClick={()=>{this.handleWatermark(this.state.resumeVideoURL)}}
                                          // href={values.resumeVideoURL}
                                          // className="download"
                                          // target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          <i
                                            className="fa fa-download"
                                            aria-hidden="true"
                                          ></i>
                                          <h4> Download</h4>
                                        </a>
                                      ) : values.resumeVideoURL ? (
                                        <a
                                          href
                                          // onClick={this.handleDownload}
                                          // href={values.resumeVideoURL}
                                          onClick={()=>{this.handleWatermark(this.state.resumeVideoURL)}}
                                          // className="download"
                                        >
                                          <i
                                            className="fa fa-download"
                                            aria-hidden="true"
                                          ></i>
                                          <h4> Download</h4>
                                        </a>
                                      ) : (
                                      ""
                                      )}
                                    </span>
                                    </div>
                                    {/* </span> */}
                                  </div>
          
                                  <div className="col-md-12 col-sm-12">
                                    <span class="file-size-limit">
                                      Supported Formats: .mp4, .avi, .mpeg only. <br />
                                      File Size: Max 4 MB
                                    </span>
                                  </div>
                                </div>
                              </div>
          
                              <div className="col-md-2 col-sm-2 hidden-xs"></div>
                            </div>
                            <div className="row">
                              <div className="col-md-2 col-sm-2 col-xs-12"></div>
                              <div className="col-md-4 col-sm-4 col-xs-12">
                                <label>
                                  LinkedIn Profile{" "}
                                  <span className="validation"> *</span>
                                </label>
                                <input
                                  disabled
                                  type="text"
                                  name="linkedInUrl"
                                  id="linkedInUrl"
                                  autoComplete="linkedInUrl"
                                  className="form-control"
                                  placeholder="Linkedin Profile"
                                  style={{border:"1px solid #fbc583"}}
                                  title={this.state.linkedInUrl}
                                  value={this.state.linkedInUrl}
                                />
                              </div>
                              <div className="col-md-6 col-sm-6 col-xs-12"></div>
                              </div>                
                          </div>
          
                        </section>
                    
                            
                            ))}
                            <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 mb-20">
                              {/* <a href="">
                                <button
                                  type="submit"
                                  name="submitForm"
                                  class="btn-4 pull-right"
                                  onClick={async () => {
                                    const curErrors =
                                      await formikProps.validateForm();
                                    const curErrorsKeys =
                                      Object.keys(curErrors);

                                    if (curErrorsKeys.length) {
                                      // Assuming curErrorsKeys[0] identifies the first failing field, use that to
                                      // find the correct DOM element to call .focus() on.
                                      //
                                      // Since I set the id attribute on all my form's <input>s to match the error
                                      // keys, I just use document.getElementById(), but of course you could use refs
                                      const el = document.getElementById(
                                        curErrorsKeys[0]
                                      );

                                      if (el) el.focus();
                                    }
                                  }}
                                >
                                  Submit
                                </button>
                                </a>*/}
                              {/* {this.state.currentTab===1&&<a href="#">
                                <button
                                  type="button"
                                  name="cancelForm"
                                  class="btn-4 mr-20 pull-right"
                                  onClick={this.handleCancel}
                                >
                                  Cancel
                                </button>
                              </a> } */}
                           
                             <div className="row">
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 mb-10">
          {/* {
            // ! Submit Button
            this.state.currentTab===this.state.tabOptionLength&& <div><button className="btn-4 pull-right" onClick={()=>{
              this.handleCancel()
            }} style={{ width: "170px" }}>Submit</button></div>
          } */}
          {
            // ! Next Button
            this.state.currentTab ===5? "" : (this.state.show&&<div><button className="btn-4 pull-right" type="button" onClick={()=>{ 
             if(this.state.currentTab<=5){
              this.setState({
                currentTab:this.state.currentTab+1
              })
            }
          }} style={{ width: "170px" }}>Next <i className="fa fa-arrow-right" aria-hidden="true"></i></button></div>)
          }
          {
            // ! Previous Button
            this.state.currentTab === 1 ? "" : this.state.show&&<div><button className="btn-4 pull-right mr-10" type="button" onClick={  ()=>{ if(this.state.currentTab>=0){
              this.setState({
                currentTab:this.state.currentTab-1
              })
            }
            }} style={{ width: "170px" }}><i className="fa fa-arrow-left" aria-hidden="true"></i> Previous</button></div>
          }
            {
            // ! Cancel Button
            this.state.currentTab === 1&& <div><button className="btn-4 pull-right mr-10"  onClick={()=>{
             this.handleCancel()
            }} style={{ width: "170px" }}>Cancel</button></div>
          }
        </div>
      </div>
                            </div>
                        
                        <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 mb-20">

                        </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
         </div>
           </div>
            </section>
          </React.Fragment>
      )}
      />
    );
  }
} 
);
export default AdminProfileEditConnect;